import React, { useRef, createRef, useEffect, useState, useImperativeHandle, forwardRef } from 'react'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { FlexByRow, XDivider, YDivider, useTheme, CenterText, makeStyles } from 'irmlib/styles'
import styled from 'styled-components'
// import { uiGet } from 'irmlib/http'
import { Label, StopWatchComponent, useStopWatchTimer, ThemeButton, Paper, Box, OutlinedButton, ContainedButton, InputAdornment, IconButton, ToolTip } from 'irmlib/components/Controls'
import { TextField, SaveButton, CancelButton, CheckBox, Select } from 'irmlib/components/FormControls'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { openGeneralDialog, closeGeneralDialog, LocalToast, setBusy, clearBusy } from 'irmlib/containers'
import * as constants from 'irmlib/common/constants'
import * as appConstants from '../../../services/common/appConstants'
import PropTypes, { element } from 'prop-types'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { useLocation, useHistory } from 'react-router-dom'
import * as routePaths from '../../../navigation/routePaths'
import {
  blockIfDuplicateEnterKey,
  createEnterPressTracker
} from './dataEntryEnterDebounce'
import { getValidation, getValidationText, getUserType, errorToast, warningToast, successToast, populateSlashOnDate, dateValidatePattern, getJobStatusToBeupdated, formatValue } from '../../../common/functions'
import ViewAllFiles from './ViewAllFiles'
import { specialCharacterRegex } from '../../../irmlib/src/components/FormControls/regx.js'
import { recordKeystrokes, turnOnKeystrokeRecorder, turnOffKeystrokeRecorder, saveMetricsData, keystrokes, recordKeystroke } from '../../../common/keystrokemanager.js'
import { getUser } from '../../../redux/global'
import { WarningOutlined, FirstPage, LastPage, NavigateNext, NavigateBefore, Refresh, DeleteOutline, LockOutlined, LockOpenOutlined, Info } from '../../../irmlib/src/icons'
import { useNavigatorOnLine } from '../../../utils/useNavigatorOnline'
import NotificationSound from '../../../utils/badscan.wav'
import VerificationSound from '../../../utils/goodscan.wav'

// import { getFunctions, httpsCallable } from '../../../utils/firestore'
import moment from 'moment'
// eslint-disable-next-line
import { jobId, defaultDateFormat, iKeyCode } from '../../../common/constants'
import { today, roundNumber } from 'irmlib/common'
// import { roundNumber } from '../../../irmlib/src/common'
import { useTranslation } from 'react-i18next'
import DatGridTable from '../../Controls/DataGridTable/recentEntries.jsx'
import ErrorPage from '../ErrorPage.jsx'

const SKP_BOX_ID = 'skpBoxId'
const CUSTOMER_ID = 'customerId'
const DEPT_ID = 'departmentId'
const DIV_ID = 'divisionId'
const MAINTENANCE_CODE = 'maintenanceCode'

let logedInUser

// const functions = getFunctions()


const BoxStyle = styled('div')`
  width: 25%;
  padding-left: 10px;
  border-right: 1px solid;
  &:last-child {
    border: none;
  }
  display: flex;
  align-items: center;
`
const InnerBoxStyle = styled('div')`
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
`
const InstructionLabel = styled('label')`
  max-height: 60px;
  overflow: auto;
`
const FieldHidden = styled('div')`
  visibility: hidden;
  height: 0;
  width: 0;
`

const LableStyle = styled('div')`
  border-right: 1px solid;
`
const ExternalContainer = styled('div')`
  margin-top: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: ${(props) => props.theme.palette.subPageHeaderBackground};
`
const BoldTitle = styled('div')`
  padding-right: 5px;
  display: inline-block;
  font-weight: bold;
`
const OuterContainer = styled('div')`
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: ${(props) => props.theme.palette.subPageHeaderBackground};
`
const ButtonCenter = styled('div')`
  display: block;
  margin: 0 auto;
`

const BoxUp = styled('div')`
`

const EvenSpace = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const WidthForSkpBox = styled('div')`
  width: 50%;
`

const MarginLeft = styled('div')`
  margin-left: 10px;
`

const MarginBothSide = styled('div')`
  margin-left: 20px;
  margin-right: 20px;
  width: 900px;
`

const BoxFlex = styled('div')`
  display: flex;
`

const FlexGrow = styled('div')`
  flex-grow: 1;
`

const DivRight = styled('div')`
  display: flex;
  justify-content: right;
`
const DivCenter = styled('div')`
  display: flex;
  justify-content: center;
`

const CloseButtonTitleStyle = styled('div')`
  font-size: 25px;
  margin-bottom: 15px;
`

const CountStyle = styled('div')`
  margin-top: -14px;
  font-size: 15px;
  height: 0px;
  color: #1b75bc;
`

const CountContentHeight = styled('div')`
  height: 20px;
`

const CountCloseButton = styled('div')`
  padding-top: 30px;
`

const ContentDialogDiv = styled('div')`
  padding-right: 30px;
  padding-left: 30px;
  padding-bottom: 20px;
`
const TextContentDialog = styled('div')`
  color: ${(props) => props.theme.palette.primary.main};
`
const NavigationLabel = styled('div')`
  font-size: 16px;
  margin-top: 12px;
`

const FileNumberContainer = styled('div')`

`

const VerticalDivider = () => <YDivider height="30px" />

const BottomPaddedButton = (props) => (
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>
)

const formTemplate = [
  {
    label: 'dataEntry.skpBoxID',
    fieldKey: 'skpId',
    maxLength: 11
  },
  {
    label: 'dataEntry.skpBoxConfirm',
    fieldKey: 'skpBoxConfirm',
    maxLength: 11
  },
  {
    label: 'dataEntry.divisionID',
    fieldKey: 'divisionId',
  },
  {
    label: 'dataEntry.departmentID',
    fieldKey: 'departmentId',
  },
  {
    label: 'dataEntry.exceptionBox',
    fieldKey: 'exceptionBox'
  },
  {
    label: 'dataEntry.exceptionCode',
    fieldKey: 'exceptionCode',
    defaultValue: constants.defaultSelect,
    isRequired: true
  },
  {
    label: 'dataEntry.Description',
    fieldKey: 'Description',
    defaultValue: '',
    isRequired: true
  },
]

const fileNavigation = [
  {
    label: 'dataEntry.fileNumber',
    fieldKey: 'fileNumber',
  }
]

const boxNavigation = [
  {
    label: 'dataEntry.fileNumber',
    fieldKey: 'boxNumber',
  }
]

const SKPBOX = 0
const SKPBOX_CONFIRM = 1
// const DIVISIONBOX = 2
// const DEPARTMENTBOX = 3
const EXCEPTION_BOX = 4
const EXCEPTION_CODE = 5
const DESCRIPTION = 6
const DATAENTRYSTARTINGKEY = 7

// for verify key dialog
const OLD_VALUE = 0
const NEW_VALUE = 1
const CORRECT_VALUE = 2

const FILE_NUMBER = 0
const BOX_NUMBER = 0
const currentBoxCount = 1

const getService = async () => {
  const getObject = {

  }
  return Promise.resolve(getObject)
}

const ContentForExceptionBox = (props) => {
  const exceptionCodes = [
    { value: constants.defaultSelect, label: '--Select--' },
    { value: 'Different Department than Expected', label: props.t(`exceptionCodesObj.${'Different Department than Expected'}`) },
    { value: 'Wrong File Type', label: props.t(`exceptionCodesObj.${'Wrong File Type'}`) },
    { value: 'Loose Documents, Other Material', label: props.t(`exceptionCodesObj.${'Loose Documents, Other Material'}`) },
    { value: 'Other', label: props.t(`exceptionCodesObj.${'Other'}`) }
  ]

  const handleOnEnter = () => {
    let isValid = true
    const exceptionCode = props.arrRefs[EXCEPTION_CODE]?.current?.getValue()
    const description = props.arrRefs[DESCRIPTION]?.current?.getValue()
    if (formTemplate[DESCRIPTION]?.isRequired && !description) {
      isValid = false
      props.arrRefs[DESCRIPTION].current?.setErrorMsg('forms.required')
    }
    if (formTemplate[EXCEPTION_CODE]?.isRequired && exceptionCode === constants.defaultSelect) {
      isValid = false
      props.arrRefs[EXCEPTION_CODE].current?.setErrorMsg('forms.required')
    }
    if (isValid) {
      props.handleUpdate(props)
    }
  }
  return (
    <>
      <Label>{props.t('dataEntry.exceptionReason')}</Label>
      <VerticalDivider />
      <Select
        items={exceptionCodes}
        fieldTemplate={formTemplate[EXCEPTION_CODE]}
        ref={props.arrRefs[EXCEPTION_CODE]}
        noTranslateItems
      />
      <VerticalDivider />
      <TextField
        id={'dataEntry_exception_description'}
        ref={props.arrRefs[DESCRIPTION]}
        fieldTemplate={formTemplate[DESCRIPTION]}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            handleOnEnter()
          }
        }}
      />
    </>
  )
}

ContentForExceptionBox.propTypes = {
  arrRefs: PropTypes.array,
  handleUpdate: PropTypes.array,
  t: PropTypes.any
}

const ButtonsForExceptionBox = (props) => (
  <>
    <CancelButton onClick={props.handleCancel} arrRefs={props.arrRefs} />
    <XDivider width="10px" />
    <SaveButton arrRefs={props.arrRefs} postService={() => props.handleUpdate(props)}
    />
  </>
)

ButtonsForExceptionBox.propTypes = {
  handleCancel: PropTypes.func,
  arrRefs: PropTypes.array,
  handleUpdate: PropTypes.func
}
const ButtonsForConfirmation = (props) => (
  <>
    <OutlinedButton id={'dataEntry_button_cancelFileSave'} onClick={props.cancelFileSave}>buttons.no</OutlinedButton>
    <XDivider width='10px' />
    <ContainedButton id={'dataEntry_button_onSaveFile'} onClick={props.onSaveFile} autoFocus>buttons.yes</ContainedButton>
  </>
)

ButtonsForConfirmation.propTypes = {
  cancelFileSave: PropTypes.func,
  onSaveFile: PropTypes.func,
}

const ButtonsForBoxCompleteAlert = (props) => (
  <>
    <OutlinedButton id={'dataEntry_button_cancelFileSaveBc'} onClick={props.cancelFileSaveBc}>buttons.no</OutlinedButton>
    <XDivider width='10px' />
    <ContainedButton id={'dataEntry_button_onSaveFileBc'} onClick={props.onSaveFileBc} autoFocus>buttons.yes</ContainedButton>
  </>
)

ButtonsForBoxCompleteAlert.propTypes = {
  cancelFileSaveBc: PropTypes.func,
  onSaveFileBc: PropTypes.func,
}

const ButtonForViewAllBoxes = (props) => (
  <>
    <ContainedButton id={'dataEntry_dialogBoxButton_yes'} onClick={props.onSaveBox} autoFocus>buttons.Ok</ContainedButton>
  </>
)
ButtonForViewAllBoxes.propTypes = {
  onSaveBox: PropTypes.func,
}

const ButtonsForPause = (props) => (
  <>
    <ContainedButton onClick={props.onResume}>buttons.resume</ContainedButton>
  </>
)

ButtonsForPause.propTypes = {
  onResume: PropTypes.func
}

const ButtonsForDeleteIcon = (props) => (
  <>
    <ButtonCenter>
      <OutlinedButton id={'dataEntry_button_DeleteIcon_Yes'} onClick={props.handleNoButtonForDeleteIcon}>buttons.no</OutlinedButton>
      <XDivider width='10px' />
      <ContainedButton id={'dataEntry_button_DeleteIcon_No'} onClick={props.handleYesButtonForDeleteIcon}>buttons.yes</ContainedButton>
    </ButtonCenter>
  </>
)

ButtonsForDeleteIcon.propTypes = {
  handleNoButtonForDeleteIcon: PropTypes.func,
  handleYesButtonForDeleteIcon: PropTypes.func,
}

const Buttons = (props) => (
  <>
    {props.isCancelButtonvisible || (props.userType === 'DATAENTRY_AND_VERIFY_USER' || props.userType === 'DATAENTRY_USER')
      ? <>
        <BottomPaddedButton id={'dataEntry_button_handleCancel'} disabled={props.isAddNewFileByQc} onClick={props.handleCancel} variant='outlined' color='primary' arrRefs={props.arrRefs}>buttons.cancelAndGoBack</BottomPaddedButton>
        <XDivider width="10px" />
      </>
      : null
    }
    {props.isBoxCompleteButtonvisible
      ? null
      : props.isVerify
        ? <BottomPaddedButton id={'dataEntry_isVerifyComplete'} disabled={!props.isVerifyComplete || props.isAddNewFileByQc} variant='contained' color='primary' arrRefs={props.arrRefs} onClick={props.handleVerifySubmitData}>buttons.BoxComplete</BottomPaddedButton>
        : <OutlinedButton id={'dataEntry_isButtondisabled'} disabled={!props.isButtondisabled || props.isAddNewFileByQc || props.openTable} arrRefs={props.arrRefs} onClick={props.handleSubmitDataPop}>buttons.BoxComplete</OutlinedButton>
    }
    <XDivider width="10px" />
    {props.isVerify
      ? <BottomPaddedButton id={'dataEntry_handleVerifyPause'} variant='contained' color='primary' arrRefs={props.arrRefs} onClick={props.handleVerifyPause} disabled={props.pauseEnabled || props.recordKeyStrokesStatus}>buttons.pause</BottomPaddedButton>
      : <BottomPaddedButton id={'dataEntry_handlePause'} variant='contained' color='primary' arrRefs={props.arrRefs} onClick={props.handlePause} disabled={props.pauseEnabled || props.recordKeyStrokesStatus}>buttons.pause</BottomPaddedButton>
    }
    <XDivider width="10px" />
    {(props.templateSelected === 'New File' || props.templateSelected === 'Maintenance File') && (props.userType === 'DATAENTRY_AND_VERIFY_USER' || props.userType === 'DATAENTRY_USER') && !props.isBoxCompleteButtonvisible
      ? <BottomPaddedButton variant='contained' color='primary' arrRefs={props.arrRefs} onClick={props.handleJobComplete} disabled={props.jobcompleteDisabled}>buttons.jobComplete</BottomPaddedButton>
      : null
    }
    {(props.templateSelected === 'New Box' || props.templateSelected === 'Maintenance Box') && (props.userType === 'DATAENTRY_AND_VERIFY_USER' || props.userType === 'DATAENTRY_USER')
      ? <BottomPaddedButton variant='contained' color='primary' arrRefs={props.arrRefs} onClick={props.handleJobComplete} disabled={props.jobcompleteDisabled}>buttons.jobComplete</BottomPaddedButton>
      : null
    }
    <XDivider width="10px" />
    {!props.isVerify && !props.addNewFileDuringVerification && (props.templateSelected === 'New File' || props.templateSelected === 'Maintenance File') && props.dataLength > 0 && <BottomPaddedButton variant='outlined' color='primary' arrRefs={props.arrRefs} onClick={() => props.toggleTable('file')} disabled={props.displayeBtnDisable}>buttons.displayFiles</BottomPaddedButton>
    }
    {!props.isVerify && !props.addNewFileDuringVerification && (props.templateSelected === 'New Box' || props.templateSelected === 'Maintenance Box') && props.dataLength > 0 && <BottomPaddedButton variant='outlined' color='primary' arrRefs={props.arrRefs} onClick={() => props.toggleTable('box')} disabled={!props.displayeBtnDisable}>buttons.displayBoxes</BottomPaddedButton>
    }
  </>
)

Buttons.propTypes = {
  isCancelButtonvisible: PropTypes.bool,
  isBoxCompleteButtonvisible: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleSubmitDataPop: PropTypes.func,
  handleVerifySubmitData: PropTypes.func,
  handlePause: PropTypes.func,
  // handleTransmit: PropTypes.func,
  handleJobComplete: PropTypes.func,
  toggleTable: PropTypes.func,
  arrRefs: PropTypes.array,
  handleVerifyPause: PropTypes.func,
  isVerify: PropTypes.bool,
  isButtondisabled: PropTypes.bool,
  jobcompleteDisabled: PropTypes.bool,
  isVerifyComplete: PropTypes.bool,
  templateSelected: PropTypes.any,
  userType: PropTypes.any,
  isAddNewFileByQc: PropTypes.bool,
  pauseEnabled: PropTypes.bool,
  recordKeyStrokesStatus: PropTypes.bool,
  displayeBtnDisable: PropTypes.bool,
  openTable: PropTypes.bool,
  dataLength: PropTypes.number,
  addNewFileDuringVerification: PropTypes.bool
}

const ViewRecentRecordsTable = (props) => {
  const { tableData, columns, arrRefs, currentTemplateType, onEditRecord } = props
  const fileList = []
  const columnList = []

  const defaultFileColumn = {
    title: 'tableColumns.srNo',
    field: 'Sr_No',
    headerAlign: 'left',
    minWidth: 50,
    sortable: false,
    flex: 1,
    getRowHeight: '05px',
  }

  const defaultEditButton = {
    title: 'tableColumns.action',
    field: 'Action',
    headerAlign: 'left',
    minWidth: 200,
    sortable: false,
    flex: 1,
    getRowHeight: '05px',
    renderCell: (rowdata) => {
      return (
        <>
          {(currentTemplateType === 'Maintenance File' || currentTemplateType === 'New File')
            ? <BottomPaddedButton id={'dataEntry_button_handleCancel'} variant='outlined' color='primary' arrRefs={props.arrRefs} onClick={() => onEditRecord(rowdata.id)}>dataEntry.navigation.edit</BottomPaddedButton>
            : <BottomPaddedButton id={'dataEntry_button_handleCancel'} variant='outlined' color='primary' arrRefs={props.arrRefs} onClick={() => onEditRecord(rowdata.id)}>tableColumns.startDataEntry</BottomPaddedButton>
          }
        </>
      )
    }
  }

  columns.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))

  columnList.push(defaultFileColumn)
  columnList.push(defaultEditButton)
  columns.forEach((element) => {
    if ((element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID && element.name !== MAINTENANCE_CODE) || (element.isSelected && element.name !== CUSTOMER_ID && element.name !== MAINTENANCE_CODE && currentTemplateType !== 'Maintenance File' && currentTemplateType !== 'New File')) {
      columnList.push({
        title: element.customName ? element.customName : element.name,
        field: element.name,
        editable: false,
        headerAlign: 'left',
        minWidth: 200,
        getRowHeight: '05px',
        flex: 1,
        sortable: true,
        cellStyle: {
          overflow: 'hidden',
        },
        renderCell: (rowdata) => {
          return (rowdata.fieldValue)
        }
      })
    }
  })

  tableData.forEach((doc, index) => {
    const file = doc
    file.Sr_No = index + 1
    file.id = index + 1
    fileList.push(file)
  })

  return (
    <>
      <DatGridTable
        fileList={fileList.reverse().slice(0, 10)}
        columnsList={columnList}
        arrRefs={arrRefs}
        showCheckBox={false}
      />
    </>
  )
}

ViewRecentRecordsTable.propTypes = {
  currentTemplateType: PropTypes.any,
  arrRefs: PropTypes.array,
  columns: PropTypes.object,
  tableData: PropTypes.object,
  onEditRecord: PropTypes.func
}

const ButtonsForCancelDialogBox = (props) => (
  <>
    <OutlinedButton id={'dataEntry_button_ButtonsForCancelDialogBoxNo'} onClick={closeGeneralDialog}>buttons.no</OutlinedButton>
    <XDivider width='10px' />
    <ContainedButton id={'dataEntry_button_ButtonsForCancelDialogBoxYes'} onClick={props.onCancelDataEntry}>buttons.yes</ContainedButton>
  </>
)

ButtonsForCancelDialogBox.propTypes = {
  onCancelDataEntry: PropTypes.func
}

const useStyles = makeStyles({
  disabledState: {
    pointerEvents: 'none',
    opacity: '0.4',
  },
  startButton: {
    textDecoration: 'none'
  },
  icons: {
    border: '1px solid #58595B',
    cursor: 'pointer'
  }
})


const VerificationDialogBox = (props) => (
  <>
    <DivCenter>
      <WarningOutlined />
      <XDivider width="10px" />
      <Label>{props.t('dataEntry.dataVerification')}</Label>
    </DivCenter>
  </>
)

VerificationDialogBox.propTypes = {
  t: PropTypes.any
}

const initialState = {
  boxList: [],
  boxes: [],
  timerObj: {},
  isTemplateFieldAdded: false,
  isEditable: false,
  isRekey: false,
  isVerification: false,
  jobDetails: {},
  isTemplateFieldsEditable: false,
  isVerifyTemplateFieldsEditable: false,
  isSkpBoxIdEditable: true,
  recordNotifyCount: 0,
  isVerifyBoxCompleteClick: false,
  isDefault: false,
  isSkp: 0,
  isConfirmSkp: 0,
  templateName: '',
  fields: [],
  templateFields: [],
  dataEntryUser: '',
  correctValueVerify: '',
  verificationUser: '',
  fileVerifyStartCount: 0,
  boxVerifyStartCount: 0,
  verifyFieldIndex: [],
  fileList: [],
  initialFiles: 0,
  totalFiles: 0,
  validationCase: false,
  validationErrorCase: [],
  initialfileCount: 0,
  initialboxCount: 0,
  jobData: [],
  boxCount: 0,
  startnewBox: false,
  viewFiles: false,
  showTable: false,
  fileCount: 1,
  boxsCount: 0,
  enterDataDisabled: false,
  jobcompleteDisabled: true,
  recordKeyStrokesStatus: true,
  addNewFileDuringVerification: false,
  startVerificationIndexAfterAddFile: 0,
  isExcetionBoxDisabled: false,
  isVerifyRequired: false,
  isTemplateInstructions: false,
  viewTemplateInstructions: [],
  isVerifyComplete: false,
  fileSequence: 1,
  navigationBoxStartCount: 0,
  deletedFileIndex: [],
  isDeptLocked: true,
  isDivLocked: true,
  divisionValue: '',
  deptValue: '',
  userType: '',
  currentBoxCount: 0,
  currentFileCount: 0,
  currentVerifyFileCount: 0,
  currentVerifyBoxCount: 0,
  currentArrCount: DATAENTRYSTARTINGKEY,
  filesKeyed: 0,
  boxesKeyed: 0,
  fileIndex: 1,
  boxIndex: 1,
  boxIds: [],
  boxValidationErrors: {},
  lockableFields: [],
  lockableFieldsData: [],
  isAllFieldsDisabled: true,
  boxListInfo: [],
  templateTypeSelected: '',
  lastBoxKeyedStatus: '',
  templateInstruction: '',
  hideBoxComplete: false,
  hideViewAllFilesButton: false,
  lastKeyedBoxData: false,
  isUploadCustomerDataFile: false,
  pauseStartTime: false,
  isEditRecordButtonClicked: false,
  displayeBtnDisable: true,
  skpinstance: '',
  allowAccessToDataEntry: true,
  regexFormat: ''
}

const userTypes = {
  DATAENTRY_AND_VERIFY_USER: 'DATAENTRY_AND_VERIFY_USER',
  VERIFICATION_USER: 'VERIFICATION_USER',
  DATAENTRY_USER: 'DATAENTRY_USER'
}
const fileStatus = 'status'
const fileName = 'fileId'
let user

const DataEntryBase = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const refStopWatchComponent = useRef()
  const [state, setState, getState] = useMergeState(initialState)
  const refLocalBusyCursor = useRef(null)
  const refLocalToast = useRef(null)
  const fileNumberRef = useRef()
  const boxNumberRef = useRef()
  const currentJobCompleteButtonEnable = props.currentJobCompleteButtonEnable
  const location = useLocation()
  const theme = useTheme()
  const history = useHistory()
  const classes = useStyles()
  const pathParams = location.pathname.split('/')
  const jobId = pathParams[2]
  let boxId = pathParams[3]
  const isViewAllFiles = pathParams[4] === 'ViewAllFiles' ? pathParams[4] : undefined
  const isAddNewFileByQc = pathParams[4] === 'AddNewFilesByQC' ? pathParams[4] : undefined
  const isBoxExists = (boxId !== undefined)
  const validationErrors = {}
  const [isModalOpen, setIsModalOpen] = useState(true)
  const [showStatus, isStatusShown] = useState(false)
  const online = useNavigatorOnLine()
  const [countData, setCountData] = useState([])
  const [boxComplete, setBoxcomplete] = useState(false)
  const [dropFirstLetterSkpBox, setDropFirstLetterSkpBox] = useState(false)
  const [dropFirstLetterSkpBoxCnf, setDropFirstLetterSkpBoxCnf] = useState(false)
  const [pauseEnabled, setPauseEnabled] = useState(props.showPause)
  const [hideTable, setHideTable] = useState(false)
  const [isPauseShortKeyActive, setPauseShortKeyActive] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const audioPlayer = useRef(null)
  const audioPlayerVerification = useRef(null)
  const lastEnterPressRef = useRef(createEnterPressTracker())

  const additionalGivenPermissions = window?.sessionStorage?.getItem('additional-permissions-user')
  let additionalPermissionsForUser
  let indexOfrequireQualityCheck
  if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined) {
    additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
    indexOfrequireQualityCheck = additionalPermissionsForUser?.map(object => object?.value)?.indexOf('requireQualityCheck')
  }

  useEffect(() => {
    if (history.location.state && (!history.location.state.isTitle && history.location.state.isTitle !== undefined)) {
      arrRefs[SKPBOX].current.setValue(history.location.state.state.detail)
      arrRefs[SKPBOX_CONFIRM]?.current?.setValue(history.location.state.state.detail)
    }
  }, [])

  useEffect(() => {
    getState().fileList.length > 0 && isViewAllFiles && onClickViewAllFiles()
    if (getState().fileList.length === 0 || getState().fileList.length === 1) {
      if (getState().userType === userTypes.VERIFICATION_USER) {
        setState({ fileVerifyStartCount: 0 })
      } else {
        setState({ fileVerifyStartCount: getState().fileList.length })
      }
    }
  }, [getState().fileList.length])


  const shortPauseKey = () => {
    if (!pauseEnabled) {
      if (state.userType === userTypes.DATAENTRY_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
        if (!isPauseShortKeyActive) {
          handlePause()
        } else if (isPauseShortKeyActive) {
          onResume()
          closeGeneralDialog()
        }
      } else if (state.userType === userTypes.VERIFICATION_USER) {
        if (isPauseShortKeyActive) {
          onVerifyResume()
          closeGeneralDialog()
        } else if (!isPauseShortKeyActive) {
          handleVerifyPause()
        }
      }
    }
  }

  const regexObj = new RegExp(specialCharacterRegex)

  const useKeyEvent = (key, callback) => {
    const callbackRef = useRef(callback)
    useEffect(() => {
      callbackRef.current = callback
    })
    useEffect(() => {
      // eslint-disable-next-line  
      function handleKeyDown(event) {
        if (event?.ctrlKey && event?.which === key) {
          callbackRef?.current(event)
        }
      }
      document.addEventListener('keydown', handleKeyDown)
      return () => document.removeEventListener('keydown', handleKeyDown)
    }, [key])
  }

  useKeyEvent(iKeyCode, shortPauseKey)

  useEffect(() => {
    getState()?.templateFields?.forEach((element) => {
      let lockStatus = false
      let hasLockedValue = false

      props?.currentLockableFields && props?.currentLockableFieldsData && Object.keys(props?.currentLockableFieldsData).forEach(key => {
        if ((element.name === key && props?.currentLockableFields[key] === true)) {
          if (element.verify === false) {
            hasLockedValue = true
          }

          let oldLockedValue = props?.currentLockableFieldsData[key]

          if ((oldLockedValue === '' || oldLockedValue === undefined)) {
            oldLockedValue = ''
          }

          setState({
            lockableFieldsData: { ...getState().lockableFieldsData, [element.name]: oldLockedValue },
          })

          if (element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
            setState({
              // eslint-disable-next-line
              lockableFieldsData: { ...getState().lockableFieldsData, [element.name + '_verify']: oldLockedValue },
            })
          }
        }
      })

      if (element.defaultValue || hasLockedValue) {
        lockStatus = true
      }

      setState({
        lockableFields: { ...getState().lockableFields, [element.name]: lockStatus },
      })

      if (element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
        setState({
          // eslint-disable-next-line
          lockableFields: { ...getState().lockableFields, [element.name + '_verify']: lockStatus },
        })
      }
    })
  }, [getState()?.templateFields])

  useEffect(() => {
    if (online && boxComplete) handleSubmitData()
  }, [online, boxComplete])

  useEffect(async () => {
    // 1019: To update the jobData getState for performance Improvement
    const jobDocument = await gdeTransactions.getJobById(jobId)
    const jobDoc = jobDocument.data()
    setState({ jobData: jobDoc })
  }, [])


  useEffect(() => {
    if (online) {
      showStatus && successToast({ message: t('toast.onlineMsg'), autoHideDuration: 5000, closeIcon: true })
    } else {
      audioPlayer.current.play()
      isStatusShown(true)
      errorToast({
        message: <ul dangerouslySetInnerHTML={{ __html: t('toast.offlineStatus') }} style={{ padding: '0', margin: '0' }}></ul>,
        title: t('toast.userOffline'),
        autoHideDuration: 20000,
        isBlocking: true,
        closeIcon: true
      })
    }
  }, [online])

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor
  })

  const getBoxCount = async (userType) => {
    const boxesRaw = await gdeTransactions.getBoxesForJob(jobId)

    const boxes = Object.values(boxesRaw.docs).sort(function (a, b) {
      const boxSrNoA = a.data().boxSrNo || a.data().boxId
      const boxSrNoB = b.data().boxSrNo || b.data().boxId
      return boxSrNoA > boxSrNoB ? 1 : -1
    }).slice(0)

    let boxCount = 0
    let index = 0
    boxes.forEach((ele) => {
      const box = ele.data()
      setState({
        boxListInfo: { ...getState().boxListInfo, [index++]: box },
      })
      if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.DATAENTRY_USER) {
        if (box.status !== constants.boxStatus.requiresReKey &&
          box.status !== constants.boxStatus.dataEntryInProcess) {
          boxCount++
        }
      } else {
        if (box.verificationUser === logedInUser && (box.status === constants.boxStatus.readyForQc ||
          box.status === constants.boxStatus.qcInProcess ||
          box.status === constants.boxStatus.approved ||
          box.status === constants.boxStatus.transmitted)
        ) {
          boxCount++
        }
      }
    })
    return boxCount
  }
  let index = 1
  index = Object.keys(getState()?.boxListInfo).map(key => (getState()?.boxListInfo[key].boxId)).indexOf(getState()?.boxId)
  index = index + 1
  const getJobData = async () => {
    setBusy()
    const jobDocument = await gdeTransactions.getJobById(jobId)
    const jobDoc = jobDocument.data()
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    const regexFormat = skpEncoding[jobDoc?.countryCode]?.regex
    // #340 : storing details into state
    if (jobDoc?.isUploadCustomerDataFile === true && jobDoc?.uniqueFieldKeyToUploadData !== '' && jobDoc?.uniqueFieldKeyToUploadData !== undefined) {
      setState({ isUploadCustomerDataFile: true, uniqueFieldKeyToUploadData: jobDoc?.uniqueFieldKeyToUploadData, dataUploadFields: jobDoc?.dataUploadFields })
    }

    // const templateName = jobDoc.templateName ? jobDoc.templateName : jobDoc.standardTemplateName
    const templateType = jobDoc.dataEntryType
    setState({ templateTypeSelected: templateType })
    // 647: saving the total files count value in the backend
    getFiles(templateType)
    // const templateData = await gdeTransactions.getTemplateById(templateName)
    const templateData = jobDoc.templateData
    setState({ templateInstruction: templateData.templateInstructions })
    const jobUserData = jobDoc.assignedUsers[logedInUser]

    // let templateFields = templateData.data().templateFields
    let templateFields = templateData.templateFields
    let isVerifyRequired = false

    templateFields = Object.keys(templateFields).map((key) => {
      const data = templateFields[key]
      data.name = key
      if (data.verify) {
        if (data.name !== 'skpBoxId') {
          isVerifyRequired = true
        }
      }
      return data
    })

    templateFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))

    let fileList = []
    let boxList = []
    let category = ''
    let isVerifyUser = false
    let boxData
    let dataEntryUser
    let fileCount = 0
    let startFileCount = 0
    let fileSequence = 1
    let currentFileCount = 0
    let filesKeyed = 0
    let boxsCount = 0
    let startBoxCount = 0
    let currentBoxCount = 0
    let boxIndex = 0
    let boxStartCount = 0
    // const boxesKeyed = 0
    let inProgressCount = 0
    let userType = ''
    let enterDataDisabled = false
    let jobcompleteDisabled = true
    let isExcetionBoxDisabled = false
    let isVerifyComplete = false
    let isFileInProgress = false
    const boxIds = []

    const templateObj = {}
    templateFields.forEach((field) => {
      templateObj[field.name] = ''
    })

    if (templateType !== 'New File' || templateType !== 'Maintenance File') {
      const boxesRaw = await gdeTransactions.getBoxesForJob(jobId)
      boxsCount = boxesRaw.size

      const boxes = Object.values(boxesRaw.docs).sort(function (a, b) {
        const boxSrNoA = a.data().boxSrNo || a.data().boxId
        const boxSrNoB = b.data().boxSrNo || b.data().boxId
        return boxSrNoA > boxSrNoB ? 1 : -1
      }).slice(0)

      boxes.forEach((box, index) => {
        if (box.data().status !== constants.boxStatus.dataEntryInProcess) {
          boxIds.push(box.id)
        }

        templateObj[SKP_BOX_ID] = box.id
        templateObj[CUSTOMER_ID] = jobDoc.accountLevel1.toUpperCase()
        const boxInfo = box.data()?.boxInfo ? { ...box.data().boxInfo } : { ...templateObj }
        boxInfo[fileStatus] = box.data().status ? box.data().status : ''
        boxInfo.boxId = box.id
        boxList.push(boxInfo)
      })
    }

    if (templateType === 'New File' || templateType === 'Maintenance File') {
      if (boxId === undefined) {
        userType = getUserType(jobUserData, logedInUser, undefined, getState().addNewFileDuringVerification)
        if (props.updatedFileList?.length > 0 || props.updatedFileList) {
          boxId = props.boxId
          setIsModalOpen(props.isRecordCountOpen)
          fileCount = fileList.length
          fileList = props.updatedFileList
          currentFileCount = props.currentFileCount
          if (history.location.state && (!history.location.state.isTitle && history.location.state.isTitle !== undefined)) {
            if (props.boxId !== history.location.state.state.detail) {
              arrRefs[SKPBOX].current.setValue(history.location.state.state.detail)
              arrRefs[SKPBOX_CONFIRM]?.current?.setValue(history.location.state.state.detail)
            }
          } else {
            arrRefs[SKPBOX].current.setValue(props.boxId)
            arrRefs[SKPBOX_CONFIRM]?.current?.setValue(props.boxId)
          }

          startFileCount = props.fileVerifyStartCount || fileList.length
          fileSequence = props.fileSequence
          filesKeyed = props.updatedFileList.length

          setState({ isTemplateFieldsEditable: props.isTemplateFieldsEditable, enterDataDisabled: false, isExcetionBoxDisabled: false, viewFiles: true })
        }

        if (fileList.length === 0 && arrRefs[SKPBOX_CONFIRM]?.current?.getValue() === undefined) {
          enterDataDisabled = true
          isExcetionBoxDisabled = true
        }
      } else {
        if (props.updatedFileList) {
          boxId = props.boxId
        }

        const box = await gdeTransactions.getBox(jobId, boxId)
        boxData = box.data()
        userType = getUserType(jobUserData, logedInUser, boxData, getState().addNewFileDuringVerification)
        arrRefs[SKPBOX_CONFIRM]?.current?.setValue(boxId)
        if (boxData.status === constants.boxStatus.dataEntryInProcess ||
          boxData.status === constants.boxStatus.requiresReKey ||
          boxData.status === constants.boxStatus.transmitted ||
          boxData.status === constants.boxStatus.readyForVerification ||
          boxData.status === constants.boxStatus.verificationInProcess || (boxData.status === constants.boxStatus.qcInProcess && getState().addNewFileDuringVerification)) {
          const filesForBox = await gdeTransactions.getFilesForBox(jobId, boxId)

          const files = filesForBox.docs.sort(function (a, b) {
            return a.id.localeCompare(b.id, undefined, {
              numeric: true,
              sensitivity: 'base'
            })
          })

          files.forEach((doc) => {
            const list = doc.data().fileInfo

            // adding a filestatus key for each file back in file.fileInfo
            list[fileStatus] = doc.data().status ? doc.data().status : ''
            list.fileId = doc.data().fileNumber

            fileList.push(list)
            if (dataEntryUser === undefined) {
              dataEntryUser = doc.data().dataEntryUser
            }
          })

          inProgressCount = fileList.length
          fileList.forEach((file, index) => {
            if (file[fileStatus] === constants.fileStatus.inProgress) {
              inProgressCount = index
              isFileInProgress = true
            }
          })
          fileSequence = fileList.length > 0 ? isFileInProgress ? parseInt(fileList[fileList.length - 1]?.fileId) : parseInt(fileList[fileList.length - 1]?.fileId) + 1 : 1
          if (boxData.status === constants.boxStatus.verificationInProcess) {
            let verifiedFiles = 0
            let keyedFiles = 0
            inProgressCount = 0
            fileList.forEach((file, index) => {
              if (file[fileStatus] === constants.fileStatus.verified) {
                verifiedFiles = verifiedFiles + 1
                inProgressCount = index + 1
              }
              if (file[fileStatus] === constants.fileStatus.keyed) {
                keyedFiles = keyedFiles + 1
              }
            })

            if (verifiedFiles === fileList.length) {
              enterDataDisabled = true
              isExcetionBoxDisabled = true
              isVerifyComplete = true
              inProgressCount = fileList.length - 1
            } else if (keyedFiles === fileList.length) {
              inProgressCount = 0
            }
          }

          filesKeyed = fileList.length
          // maintain the previous state when returning from View all Files screen
          if (props.updatedFileList) {
            setIsModalOpen(props.isRecordCountOpen)
            fileCount = fileList.length
            fileSequence = props.fileSequence
            fileList = props.updatedFileList
            currentFileCount = props.currentFileCount
            inProgressCount = props.fileVerifyStartCount
            boxId = props.boxId
            setState({ isTemplateFieldsEditable: props.isTemplateFieldsEditable, viewFiles: true })
          } else {
            fileCount = fileList !== undefined ? fileList.length : state.initialfileCount
          }
          startFileCount = (fileList !== undefined && (boxData.status === constants.boxStatus.dataEntryInProcess || boxData.status === constants.boxStatus.verificationInProcess)) ? inProgressCount : state.fileVerifyStartCount
        }
      }
    } else {
      if (boxId === undefined) {
        userType = getUserType(jobUserData, logedInUser, undefined, getState().addNewFileDuringVerification)
        if (boxList.length === 0) {
          enterDataDisabled = true
          isExcetionBoxDisabled = true
        } else {
          enterDataDisabled = true
          boxStartCount = boxList.length
        }
      } else {
        const box = await gdeTransactions.getBox(jobId, boxId)
        boxData = box.data()
        userType = getUserType(jobUserData, logedInUser, boxData, getState().addNewFileDuringVerification)
        arrRefs[SKPBOX_CONFIRM]?.current?.setValue(boxId)

        if (boxData.status === constants.boxStatus.dataEntryInProcess ||
          boxData.status === constants.boxStatus.requiresReKey ||
          boxData.status === constants.boxStatus.readyForVerification ||
          boxData.status === constants.boxStatus.verificationInProcess) {
          let verifyStartCount = 0
          if (boxData.status === constants.boxStatus.requiresReKey) {
            boxList.forEach((box, index) => {
              if (boxId === box[SKP_BOX_ID]) {
                boxIndex = index
              }
            })
            // boxList.push(boxData.boxInfo)
          } else {
            const boxesForJob = await gdeTransactions.getBoxesForJob(jobId)

            const boxes = boxesForJob.docs.sort(function (a, b) {
              return a.id.localeCompare(b.id, undefined, {
                numeric: true,
                sensitivity: 'base'
              })
            })

            boxes.forEach((doc) => {
              if (dataEntryUser === undefined) {
                dataEntryUser = doc.data().dataEntryUser
              }
            })
          }

          inProgressCount = boxList.length
          boxList.forEach((box, index) => {
            if (box[fileStatus] === constants.fileStatus.inProgress) {
              inProgressCount = index
            }
            if (box.skpBoxId === boxId) {
              verifyStartCount = index
            }
          })

          if (boxData.status === constants.boxStatus.verificationInProcess) {
            let verifiedFiles = 0
            let keyedBoxes = 0
            boxList.forEach((box, index) => {
              if (box[fileStatus] === constants.fileStatus.verified) {
                verifiedFiles = verifiedFiles + 1
                inProgressCount = index + 1
              }
              if (box[fileStatus] === constants.fileStatus.keyed) {
                keyedBoxes = keyedBoxes + 1
              }
            })

            if (verifiedFiles === boxList.length) {
              enterDataDisabled = true
              isExcetionBoxDisabled = true
              isVerifyComplete = true
              inProgressCount = boxList.length - 1
            } else if (keyedBoxes === boxList.length) {
              inProgressCount = 0
            }
          }
          // maintain the previous state when returning from View all Files screen
          if (props.updatedBoxList) {
            boxsCount = boxList.length
            boxList = props.updatedBoxList
            currentBoxCount = props.currentBoxCount
            setState({ isTemplateFieldsEditable: props.isTemplateFieldsEditable, viewFiles: true })
          } else {
            boxsCount = boxList !== undefined ? boxList.length : state.initialboxCount
          }

          // startBoxCount = (boxList !== undefined && (boxData.status === constants.boxStatus.dataEntryInProcess || boxData.status === constants.boxStatus.verificationInProcess)) ? inProgressCount : state.boxVerifyStartCount
          startBoxCount = verifyStartCount
          boxStartCount = (boxData !== undefined && (boxData.status === constants.boxStatus.readyForVerification || boxData.status === constants.boxStatus.verificationInProcess || boxData.status === constants.boxStatus.dataEntryInProcess)) ? startBoxCount : (boxData.status === constants.boxStatus.requiresReKey) ? boxIndex : boxsCount
        }
      }
    }

    const boxCount = await getBoxCount(userType)
    const isRekey = (boxData !== undefined && boxData.status === constants.boxStatus.requiresReKey)
    const isVerification = (boxData !== undefined && (boxData.status === constants.boxStatus.readyForVerification || boxData.status === constants.boxStatus.verificationInProcess))
    const boxesRaw = await gdeTransactions.getBoxesForJob(jobId)

    const boxes = Object.values(boxesRaw.docs).sort(function (a, b) {
      const boxSrNoA = a.data().boxSrNo || a.data().boxId
      const boxSrNoB = b.data().boxSrNo || b.data().boxId
      return boxSrNoA > boxSrNoB ? 1 : -1
    }).slice(0)

    if (userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
      category = appConstants.dataEntryUser
      isVerifyUser = true
    } else if (userType === userTypes.DATAENTRY_USER) {
      category = appConstants.dataEntryUser
    } else {
      category = appConstants.verificationUser
    }
    const timerObj = {
      jobId: jobId,
      jobOrderNumber: jobDoc.orderNumber,
      jobLastModifyTs: jobDoc.actionTs,
      accountLevel1: jobDoc.accountLevel1.toUpperCase(),
      dataEntryType: jobDoc.dataEntryType,
      templateName: jobDoc.templateName ? jobDoc.templateName : jobDoc.standardTemplateName,
      wmsCode: jobDoc.wmsCode,
      workerId: logedInUser,
      jobCategory: category,
      isVerifyUser: isVerifyUser,
      districtId: user.district,
      workerFirstName: user.firstName,
      workerLastName: user.lastName,
      workerCountry: user.country,
      activityType: constants.keystrokeType,
      accountLevel1Description: jobDoc.accountLevel1Description
    }

    if (currentJobCompleteButtonEnable === true && (jobDoc.dataEntryType === 'New Box' || jobDoc.dataEntryType === 'Maintenance Box')) {
      jobcompleteDisabled = false
    }

    setState({
      userType: userType,
      jobDetails: jobDoc,
      recordNotifyCount: jobDoc?.recordNotifyCount,
      jobId: jobId,
      boxId: boxId,
      boxIds: boxIds,
      boxVerifyStartCount: boxStartCount,
      templateFields: templateFields,
      fileList: fileList,
      boxList: boxList,
      initialfileCount: fileCount,
      currentFileCount: currentFileCount,
      fileVerifyStartCount: startFileCount,
      fileSequence: fileSequence,
      // boxVerifyStartCount: startBoxCount,
      initialboxCount: boxCount,
      currentBoxCount: currentBoxCount,
      startnewBox: (boxId === undefined),
      boxData: boxData,
      viewFiles: (fileList.length > 0),
      jobUserData: jobUserData,
      dataEntryUser: dataEntryUser,
      isRekey: isRekey,
      isVerification: isVerification,
      isSkpBoxIdEditable: (boxId === undefined),
      enterDataDisabled: enterDataDisabled,
      jobcompleteDisabled: jobcompleteDisabled,
      recordKeyStrokesStatus: !recordKeystrokes,
      isExcetionBoxDisabled: isExcetionBoxDisabled,
      timerObj: timerObj,
      isVerifyRequired: isVerifyRequired,
      boxCount: boxCount,
      boxesForJob: boxes,
      isCancelButtonvisible: (!(fileList.length > fileCount)),
      boxesKeyed: boxsCount,
      filesKeyed: filesKeyed,
      isVerifyComplete: isVerifyComplete,
      fileIndex: startFileCount + 1,
      boxIndex: startBoxCount + 1,
      boxsCount: boxsCount,
      skpinstance: jobDoc?.skpinstance,
      regexFormat: regexFormat,
      verificationPopupOn: false
    })

    if (isRekey) { setTimeout(createFormTemplatesForRekey, 5) } else { setTimeout(createFormTemplatesForDataEntry, 5) }
    isAddNewFileByQc !== undefined && onAddNewFile()
    clearBusy()
  }

  useEffect(() => {
    user = getUser()
    logedInUser = user.workerId
    getJobData()
    handleViewTemplateInstructions()
  }, [])

  useEffect(async () => {
    // #1019: Added a listner to improve the performance(This can be further used for other issues)
    const unsubscribe = await gdeTransactions.serialListner(setCountData, jobId)
    return () => unsubscribe()
  }, [jobId])

  const getFiles = async (templateTypeSelected) => {
    setBusy()
    if (templateTypeSelected === 'New File' || templateTypeSelected === 'Maintenance File') {
      const totalfileCount = await gdeTransactions.getFileCountForJob(jobId)
      // 647: setting the fileskeyed from backend to display in the UI
      setState({
        totalFiles: totalfileCount
      })
      const data = {
        totalFileCount: getState().totalFiles
      }
      // 647: saving the total files count value in the backend
      gdeTransactions.totalUserFiles(jobId, data)
    }
    clearBusy()
  }

  const createBox = async (e) => {
    const boxId = arrRefs[SKPBOX].current.getValue() || arrRefs[SKPBOX_CONFIRM]?.current?.getValue()
    const boxesForJob = await gdeTransactions.getBoxesForJob(getState().jobId)

    let dataentryUser
    let verificationUser
    if (getState().userType === userTypes.DATAENTRY_USER || getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
      const jobDocument = await gdeTransactions.getJobById(getState().jobId)
      const jobDoc = jobDocument.data()
      const verifyUser = jobDoc?.assignedUsers[logedInUser]?.verifyUser

      setState({ jobUserData: jobDoc?.assignedUsers[logedInUser] })
      if (getState().userType === userTypes.DATAENTRY_USER) {
        dataentryUser = logedInUser
        verificationUser = verifyUser || getState()?.jobUserData?.verifyUser || logedInUser
      } else if (getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
        dataentryUser = logedInUser
        verificationUser = verifyUser || logedInUser
      }
    }

    const date = new Date()

    let isRequireQC = false
    if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined' && additionalPermissionsForUser[indexOfrequireQualityCheck]?.enabled && getState().isVerifyRequired) {
      isRequireQC = true
    }

    const boxData = {
      jobId: getState().jobId,
      districtId: getState().jobDetails.districtId,
      accountLevel1: getState().jobDetails.accountLevel1.toUpperCase(),
      boxId: boxId,
      status: constants.boxStatus.dataEntryInProcess,
      dataEntryUser: dataentryUser,
      verificationUser: verificationUser,
      actionTs: date,
      createdTs: date,
      transmissionStatus: constants.boxTransmissionStatus.pending,
      transmissionStatusTs: new Date(),
      requireQC: isRequireQC,
      totalFiles: getState().currentFileCount
    }

    let boxAlreadyExists = false
    let maxBoxSerialNo = 0
    boxesForJob.forEach((doc, index) => {
      const boxData = doc.data()
      if (boxId !== boxData.boxId && maxBoxSerialNo < boxData.boxSrNo && boxAlreadyExists === false) {
        maxBoxSerialNo = boxData.boxSrNo
      }

      if (boxId === boxData.boxId) {
        boxAlreadyExists = true
        maxBoxSerialNo = boxData.boxSrNo
      }
    })

    if (!boxAlreadyExists) {
      boxData.boxSrNo = maxBoxSerialNo + 1
    } else {
      boxData.boxSrNo = maxBoxSerialNo
    }

    if (!isBoxExists) {
      await gdeTransactions.createNewBox(getState().jobId, boxId, boxData)
    }
    // if (getState().templateTypeSelected === 'Maintenance Box' || getState().templateTypeSelected === 'New Box') {
    //   const lockableFieldsDataArray = Object.keys(getState()?.lockableFieldsData)
    //   let tempCounter = 0
    //   getState().templateFields.forEach((element, index) => {
    //     if (element.name in getState().lockableFields && lockableFields[element.name]) {
    //       tempCounter++
    //     }
    //   })
    //   if (tempCounter === getState().templateFields.length - 2 && e !== undefined) {
    //     onLastEnterBoxKeyPress()
    //   }
    // }
  }

  const handleCorrectValue = async (e) => {
    e.preventDefault()
    setState({ correctValueVerify: e.target.value })
  }

  const ContentForDataVerification = (props) => {
    // #870 : setting verificationPopupOn as true for the implementation of ESC key functionality
    setState({
      verificationPopupOn: true
    })
    audioPlayerVerification.current.play()
    const { format = '', customFormat = '', customName = '' } = props.element
    const DataVerificationForm = [
      {
        label: t('dataEntry.oldValue')
      },
      {
        label: t('dataEntry.newValue')
      },
      {
        label: t('dataEntry.correctValue'),
        placeholder: (customFormat || format)
      }
    ]
    const arrefsForCorrectVal = createRef()
    const maskedData = {
      status: false,
      value: ''
    }
    const definedDateFormat = Object.keys(dateValidatePattern)
    if (props.element?.customFormat && (props.element?.customFormat !== definedDateFormat[0] && props.element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(props?.element?.customFormat)) {
      maskedData.status = true
      maskedData.value = props.element?.customFormat
    }

    return (
      <>
        <ContentDialogDiv>
          <CenterText noTranslate={true}>
            {t('dataEntry.verificationMisMatchMsg')}
            <br />
            <TextContentDialog theme={theme}>{customName}</TextContentDialog>
          </CenterText>
          <VerticalDivider />
          <TextField
            id={'dataEntry_dataVerificationForm_oldValue'}
            fieldTemplate={DataVerificationForm[OLD_VALUE]}
            defaultValue={props.oldData}
            disabled={true}
            noTranslate={true}
          />
          <VerticalDivider />
          <TextField
            id={'dataEntry_dataVerificationForm_newValue'}
            fieldTemplate={DataVerificationForm[NEW_VALUE]}
            defaultValue={props.newData}
            disabled={true}
            noTranslate={true}
          />
          <VerticalDivider />
          <TextField
            id={'dataEntry_dataVerificationForm_correctValue'}
            inputProps={{ maxLength: props.element.customLength }}
            fieldTemplate={DataVerificationForm[CORRECT_VALUE]}
            ref={arrefsForCorrectVal}
            onKeyDown={(e) => {
              props.handleVerifyClick(e, props.arrCount, props.element, arrefsForCorrectVal)
              handleKeyUp(e, props.element)
            }}
            onKeyUp={(e) => handleKeyUp(e, props.element)}
            onBlur={(e) => handleCorrectValue(e)}
            noTranslate={true}
            autoFocus
            maskedData={maskedData}
          />
        </ContentDialogDiv>
        <DivRight>
          {getState().userType === userTypes.VERIFICATION_USER
            ? <ContainedButton id={'dataEntry_button_VerificationSave'} onClick={(e) => handleVerifySaveDif(e, props.arrCount, props.element, arrefsForCorrectVal)}>buttons.save</ContainedButton>
            : <ContainedButton id={'dataEntry_button_VerificationSave'} onClick={(e) => handleVerifySave(e, props.arrCount, props.element, arrefsForCorrectVal)}>buttons.save</ContainedButton>
          }
        </DivRight>
      </>
    )
  }

  ContentForDataVerification.propTypes = {
    oldData: PropTypes.string,
    newData: PropTypes.string,
    customName: PropTypes.string,
    element: PropTypes.object,
    handleVerifyClick: PropTypes.func,
    arrCount: PropTypes.number
  }

  const RecordCountContent = () => {
    const refRecordCountCloseGeneralDialog = useRef(null)

    useEffect(() => {
      if (refRecordCountCloseGeneralDialog.current) {
        refRecordCountCloseGeneralDialog.current.focus()
      }
    }, [refRecordCountCloseGeneralDialog.current])

    return (
      <>
        <CountContentHeight>
          <DivCenter>
            <Label>{t('dataEntry.yourKeyRecordOne')}</Label>
            <pre>
              <CountStyle> {state.fileList.length} </CountStyle>
            </pre>
            <Label>{t('dataEntry.yourKeyRecordTwo')}</Label>
          </DivCenter>
        </CountContentHeight>
        <DivCenter>
          <Label>{t('dataEntry.ensureForKey')}</Label>
        </DivCenter>
        <DivCenter>
          <Label>{t('dataEntry.thankYou')}</Label>
        </DivCenter>
        <CountCloseButton >
          <DivCenter>
            <ContainedButton ref={refRecordCountCloseGeneralDialog} onClick={closeGeneralDialog} noTranslate={true}>
              <Label>{t('buttons.close')}</Label>
            </ContainedButton>
          </DivCenter>
        </CountCloseButton>
      </>
    )
  }

  const recordCountAlert = () => {
    setIsModalOpen(true)
    openGeneralDialog({
      title: <DivCenter>
        <CloseButtonTitleStyle>
          <Label>{t('dataEntry.recordCountAlert')}</Label>
        </CloseButtonTitleStyle>
      </DivCenter>,
      message: <RecordCountContent arrRefs={arrRefs} />,
      translateMessage: false,
      noTranslateTitle: true,
      buttons: <></>,
      closeX: true
    })
    return Promise.resolve()
  }

  const createFormTemplatesForRekey = () => {
    const formTemplate2 = []
    if (getState().isTemplateFieldAdded === false) {
      if (arrRefs.length > DATAENTRYSTARTINGKEY) {
        arrRefs.splice(DATAENTRYSTARTINGKEY, arrRefs.length)
      }
      if (formTemplate.length > DATAENTRYSTARTINGKEY) {
        formTemplate.splice(DATAENTRYSTARTINGKEY, formTemplate.length)
      }
      const { userType } = getState()
      const verifyfields = []
      let fieldValue
      if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.DATAENTRY_USER) {
        getState().templateFields.forEach((element) => {
          if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
            if (getState().fileVerifyStartCount < getState().initialfileCount) {
              fieldValue = getState().fileList[getState().fileVerifyStartCount][element.name]
            } else {
              fieldValue = ''
            }
          } else {
            if (getState().boxVerifyStartCount < getState().initialboxCount) {
              fieldValue = getState().boxList[getState().boxVerifyStartCount][element.name]
            } else {
              fieldValue = ''
            }
          }
          if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
            let label = element.customName ? element.customName : element.name
            if (element.isRequired) {
              label = `${label} *`
            }
            formTemplate.push({
              label: label,
              fieldKey: element.name,
              defaultValue: fieldValue,
              placeholder: element.customFormat || element.format,
              required: true,
              regX: getValidationText(element),
              regxError: 'invalid format',
              disabled: getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]
            })
            arrRefs.push(createRef())
            if (element.verify && userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
              formTemplate2.push({
                label: element.customName ? element.customName : element.name,
                fieldKey: `${element.name}_verify`,
                defaultValue: '',
                required: true,
                disabled: false,
                placeholder: element.customFormat || element.format
              })
              arrRefs.push(createRef())
              verifyfields.push(element.name)
            }
          }
        })
        formTemplate2.forEach((formElement) => {
          formTemplate.push(formElement)
        })
        setState({ isTemplateFieldAdded: true, verifyFields: verifyfields })
      } else {
        getState().templateFields.forEach((element) => {
          if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
            let label = element.customName ? element.customName : element.name
            if (element.isRequired) {
              label = `${label} *`
            }
            formTemplate.push({
              label: label,
              fieldKey: element.name,
              placeholder: element.customFormat || element.format,
            })
            arrRefs.push(createRef())
          }
        })
        setState({ isTemplateFieldAdded: true })
      }
    }
  }

  const createFormTemplatesForDataEntry = () => {
    const { userType, lockableFields, lockableFieldsData } = getState()
    formTemplate.length = DATAENTRYSTARTINGKEY
    const formTemplate2 = []
    arrRefs.length = DATAENTRYSTARTINGKEY
    // let divisionValue = ''
    // let deptValue = ''
    if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.DATAENTRY_USER) {
      getState().templateFields.forEach((element) => {
        let disabled = false
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          let label = element.customName ? element.customName : element.name
          if (element.isRequired) {
            label = `${label} *`
          }
          if (getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
            // if (element.name === DEPT_ID) {
            //   const prevValue = getState().fileList.length > 1 && getState().isDeptLocked ? getState().fileList[getState().fileVerifyStartCount - 1][element.name] : ''
            //   deptValue = element.defaultValue || state.deptValue || prevValue
            //   disabled = !((element.isRequired === true && deptValue === ''))
            // }

            // if (element.name === DIV_ID) {
            //   const prevValue = getState().fileList.length > 1 && getState().isDivLocked ? getState().fileList[getState().fileVerifyStartCount - 1][element.name] : ''
            //   divisionValue = element.defaultValue || state.divisionValue || prevValue
            //   disabled = !((element.isRequired === true && divisionValue === ''))
            // }

            if (element.name in lockableFields && lockableFields[element.name] && getState().fileList.length > 1) {
              // const prevValue = getState().fileList[getState().fileVerifyStartCount - 1][element.name]
              // lockableFieldsData[element.name] = element.defaultValue || state.lockableFieldsData[element.name] || prevValue
              disabled = !((element.isRequired === true && lockableFieldsData[element.name] === ''))
            }
          } else {
            // if (element?.name === DEPT_ID) {
            //   const prevValue = getState()?.boxList?.length > 1 && getState()?.isDeptLocked && getState()?.isDeptLocked ? getState()?.boxList[getState()?.boxVerifyStartCount - 1][element?.name] : ''
            //   deptValue = element?.defaultValue || state?.deptValue || prevValue
            //   disabled = !((element?.isRequired === true && deptValue === ''))
            // }

            // if (element.name === DIV_ID) {
            //   const prevValue = getState().boxList.length > 1 && getState().isDivLocked ? getState().boxList[getState().boxVerifyStartCount - 1][element.name] : ''
            //   divisionValue = element.defaultValue || state.divisionValue || prevValue
            //   disabled = !((element.isRequired === true && divisionValue === ''))
            // }

            if (element.name in lockableFields && lockableFields[element.name] && getState().boxList.length > 1) {
              // const prevValue = getState().boxList[getState().boxVerifyStartCount - 1][element.name]
              // lockableFieldsData[element.name] = element.defaultValue || state.lockableFieldsData[element.name] || prevValue
              disabled = !((element.isRequired === true && lockableFieldsData[element.name] === ''))
            }
          }

          formTemplate.push({
            label: label,
            fieldKey: element.name,
            defaultValue: lockableFieldsData[element.name],
            placeholder: element.customFormat || element.format,
            disabled: disabled
          })
          arrRefs.push(createRef())
          if (element.verify && userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
            formTemplate2.push({
              label: element.customName ? element.customName : element.name,
              fieldKey: `${element.name}_verify`,
              defaultValue: '',
              required: true,
              placeholder: element.customFormat || element.format,
              disabled: disabled
            })
            arrRefs.push(createRef())
          }
        }
      })
      // setState({ isTemplateFieldAdded: true, divisionValue, deptValue })
      formTemplate2.forEach((formElement) => {
        formTemplate.push(formElement)
      })
      setState({ isTemplateFieldAdded: true })
    } else {
      const verifyFieldIndex = []
      let index = 0
      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          let label = element.customName ? element.customName : element.name
          if (element.isRequired) {
            label = `${label} *`
          }
          formTemplate.push({
            label: label,
            fieldKey: element.name,
            placeholder: element.customFormat || element.format,
          })
          arrRefs.push(createRef())
          if (element.verify) {
            verifyFieldIndex.push(index)
          }
          index++
        }
      })
      setState({ isTemplateFieldAdded: true, verifyFieldIndex: verifyFieldIndex })
    }
  }  

  const handleClickFieldLock = async (fieldName, arrCount, isVerify = false, field) => {
    const validationErrors = {}
    const boxValidationErrors = {}
    // const focusKey = DATAENTRYSTARTINGKEY
    const files = getState().fileList
    const boxes = getState().boxList
    let fieldValue = getState().lockableFieldsData[fieldName] || arrRefs[arrCount].current?.getValue()
    let lockState = false
    if (getState().jobDetails.dataEntryType === 'Maintenance File' || getState().jobDetails.dataEntryType === 'New File') {
      const [validate, noTranslate = false] = await getValidation(field, arrRefs[arrCount], getState().jobId, files, arrRefs, getState().skpinstance, getState()?.regexFormat)
      if (validate !== undefined) {
        validationErrors[element.name] = validate
        if (noTranslate) {
          arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
        } else {
          arrRefs[arrCount].current.setErrorMsg(validate)
        }
      } else {
        arrRefs[arrCount].current.clearErrorMsg()
        delete validationErrors[element.name]
      }
      let fromDateValue
      let fromDateValueIndex
      let toDateValue
      let toDateValueIndex
      for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'fromDate') {
          fromDateValue = arrRefs[i]?.current?.getValue()
          fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          fromDateValueIndex = i
        }

        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'toDate') {
          toDateValue = arrRefs[i]?.current?.getValue()
          toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          toDateValueIndex = i
        }
      }

      if (fromDateValue && toDateValue) {
        if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
          arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          validationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'

          arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          validationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'
        }
      }
    } else {
      const [validate, noTranslate = false] = await getValidation(field, arrRefs[arrCount], getState().jobId, boxes, getState().boxesForJob, getState().skpinstance, getState()?.regexFormat)
      if (validate !== undefined) {
        boxValidationErrors[element.name] = validate
        if (noTranslate) {
          arrRefs[arrCount].current.setErrorMsg(validate, noTranslate)
        } else {
          arrRefs[arrCount].current.setErrorMsg(validate)
        }
      } else {
        delete boxValidationErrors[element.name]
      }
      let fromDateValue
      let fromDateValueIndex
      let toDateValue
      let toDateValueIndex
      for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'fromDate') {
          fromDateValue = arrRefs[i]?.current?.getValue()
          fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          fromDateValueIndex = i
        }

        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'toDate') {
          toDateValue = arrRefs[i]?.current?.getValue()
          toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          toDateValueIndex = i
        }
      }

      if (fromDateValue && toDateValue) {
        if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
          arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          boxValidationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'

          arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          boxValidationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'
        } else {
          delete boxValidationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name]
          delete boxValidationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name]
        }
      }
    }
    if (!state.lockableFields[fieldName] && Object.keys(validationErrors).length === 0 && Object.keys(boxValidationErrors).length === 0) {
      // deptValue = arrRefs[arrCount].current.getValue()
      fieldValue = arrRefs[arrCount].current?.getValue()
      formTemplate[arrCount].disabled = true
      if (isVerify) {
        if (formTemplate[arrCount + 1] === undefined) {
          formTemplate[arrCount].disabled = false
        } else {
          formTemplate[arrCount + 1].disabled = false
        }
      }

      lockState = true

      if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        files.forEach((file) => {
          // file[fieldName] = arrRefs[arrCount].current.getValue()
        })
      } else {
        boxes.forEach((box) => {
          // box[fieldName] = arrRefs[arrCount].current.getValue()
        })
      }
    } else {
      formTemplate[arrCount].disabled = false
      if (isVerify) {
        if (formTemplate[arrCount + 1] === undefined) {
          formTemplate[arrCount].disabled = false
        } else {
          formTemplate[arrCount + 1].disabled = false
        }
      }
    }

    if (lockState === false) {
      let focusKey = DATAENTRYSTARTINGKEY
      setTimeout(() => {
        for (let i = arrCount; i < arrRefs.length; i++) {
          if (!getState().lockableFields[arrRefs[i].current.getFormTemplate().fieldKey]) {
            focusKey = i
            break
          }
        }
        arrRefs[focusKey].current.focus()
      }, 3)
    }

    if (!lockState) {
      fieldValue = undefined
    }

    setState({
      lockableFieldsData: { ...getState().lockableFieldsData, [fieldName]: fieldValue },
    })

    setTimeout(setState({
      lockableFields: { ...getState().lockableFields, [fieldName]: lockState },
    }), 20)

    if (isVerify || getState().lockableFields[`${fieldName}_verify`] !== undefined) {
      setState({
        lockableFieldsData: { ...getState().lockableFieldsData, [`${fieldName}_verify`]: fieldValue },
      })
    }

    if (isVerify || getState().lockableFields[`${fieldName}_verify`] !== undefined) {
      setTimeout(setState({
        lockableFields: { ...getState().lockableFields, [`${fieldName}_verify`]: lockState },
      }), 20)
    }
    if (lockState === true) {
      const { lockableFields } = getState()
      // const arrCount = DATAENTRYSTARTINGKEY
      let focusKey = DATAENTRYSTARTINGKEY
      setTimeout(() => {
        for (let i = arrCount; i < arrRefs.length; i++) {
          if (!lockableFields[arrRefs[i].current.getFormTemplate().fieldKey]) {
            focusKey = i
            break
          }
        }

        if (lockableFields[arrRefs[focusKey].current.getFormTemplate().fieldKey]) {
          for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
            if (!lockableFields[arrRefs[i].current.getFormTemplate().fieldKey]) {
              focusKey = i
              break
            }
          }
        }
        arrRefs[focusKey].current.focus()
      }, 3)
    }
    // #1039: Fixed the bug when some fields have default values.
    if (getState()?.templateTypeSelected === 'New Box' || getState()?.templateTypeSelected === 'Maintenance Box') {
      let lockableFieldsDataArray = Object.keys(getState()?.lockableFieldsData)
      let tempCounter = 0
      getState()?.templateFields.forEach((element, index) => {
        const lockedDefault = []
        if (element.name in getState()?.lockableFields && getState()?.lockableFields[element.name]) {
          tempCounter++
        }
        if (element.defaultValue !== '' && (element.name !== 'maintenanceCode' && element.name !== 'customerId' && element.name !== 'skpBoxId')) {
          lockedDefault.push(element.name)
        }
        lockableFieldsDataArray = [...new Set([...lockableFieldsDataArray, ...lockedDefault])]
      })

      if (getState()?.templateTypeSelected === 'New Box' && lockableFieldsDataArray.length === getState()?.templateFields.length - 2 && tempCounter === getState()?.templateFields.length - 2) {
        onLastEnterBoxKeyPress()
      }
      if (getState()?.templateTypeSelected === 'Maintenance Box' && lockableFieldsDataArray.length === getState()?.templateFields.length - 3 && tempCounter === getState()?.templateFields.length - 2) {
        onLastEnterBoxKeyPress()
      }
    }
  }

  // removed the commented out functions handleClickDivLock & handleClickDeptLock

  const getFieldsForReKey = () => {
    const fields = []
    const fieldsVerify = []
    const { lockableFields, lockableFieldsData } = getState()
    if (getState().isTemplateFieldAdded) {
      let count = 6
      let countVerify = 6 + getState().templateFields.length
      let fieldValue = ''
      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          ++count
          const innercount = count
          if (getState().fileList.length > 0 && getState().fileVerifyStartCount < (getState().fileList.length)) {
            fieldValue = getState().fileList[getState().fileVerifyStartCount][element.name]
          } else {
            fieldValue = element.defaultValue ? element.defaultValue : ''
            // if (element.name === DEPT_ID || element.name === DIV_ID) {
            //   const prevValue = getState().fileList.length > 0 && getState().isDeptLocked ? getState().fileList[getState().fileVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.deptValue || prevValue
            // }
            // if (element.name === DIV_ID) {
            //   const prevValue = getState().fileList.length > 0 && getState().isDivLocked ? getState().fileList[getState().fileVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.divisionValue || prevValue
            // }
            if (element.name in lockableFields && lockableFields[element.name] && getState().fileList.length > 0) {
              // const prevValue = getState().fileList[getState().fileVerifyStartCount - 1][element.name]
              // lockableFieldsData[element.name] = element.defaultValue || state.lockableFieldsData[element.name] || prevValue
              fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || lockableFieldsData[element.name]
            }
          }

          if (formTemplate[innercount]) {
            formTemplate[innercount].defaultValue = fieldValue
          }

          const maskedData = {
            status: false,
            value: ''
          }
          const definedDateFormat = Object.keys(dateValidatePattern)
          if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
            maskedData.status = true
            maskedData.value = element?.customFormat
          }

          fields.push(
            <>
              <TextField
                id={`dataEntry_fields_${formTemplate[innercount].label}`}
                fieldTemplate={formTemplate[innercount]}
                ref={arrRefs[innercount]}
                data={data}
                type={(element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) ? 'password' : 'text'}
                disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]}
                onKeyDown={(e) => {
                  e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                }}
                onKeyUp={(e) => {
                  handleKeyUp(e, element)
                }}
                onBlur={(e) => {
                  e.keyCode !== 27 && handleDataEntry(e, innercount, false, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                }}
                endAdornment={
                  <InputAdornment position="end">
                    {((getState()?.dataUploadFields && !getState()?.dataUploadFields.includes(element.name)) || getState()?.dataUploadFields === undefined) &&
                      <IconButton
                        // eslint-disable-next-line
                        id={'dataEntry_lock' + element.name}
                        onClick={() => handleClickFieldLock(element.name, innercount, element.verify, element)}
                        disabled={(element.doNotLock === true)}
                      >
                        {state.lockableFields[element.name] ? <LockOutlined /> : <LockOpenOutlined />}
                      </IconButton>}
                    {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                  </InputAdornment>
                }
                noTranslate
                value={fieldValue}
                maskedData={maskedData}
              />
              <XDivider width="30px" />
            </>
          )
          if (element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
            // ++count
            ++countVerify
            const innercount = countVerify - 2
            const maskedData = {
              status: false,
              value: ''
            }
            if (getState().fileList.length > 0 && getState().fileVerifyStartCount < (getState().fileList.length)) {
              fieldValue = getState().fileList[getState().fileVerifyStartCount][`${element.name}_verify`]
            }

            if (element.name in lockableFields && lockableFields[`${element.name}_verify`] && !fieldValue) {
              fieldValue = lockableFieldsData[`${element.name}_verify`]
            }

            const definedDateFormat = Object.keys(dateValidatePattern)
            if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
              maskedData.status = true
              maskedData.value = element?.customFormat
            }
            if (formTemplate[innercount]) {
              formTemplate[innercount].defaultValue = fieldValue
            }
            fieldsVerify.push(
              <>
                <TextField
                  id={`dataEntry_fields_${formTemplate[innercount].label}`}
                  fieldTemplate={formTemplate[innercount]}
                  ref={arrRefs[innercount]}
                  disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[`${element.name}_verify`]}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, true, element)
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && handleDataEntry(e, innercount, true, false, element)
                  }}
                  // removed the commented out code for dataEntry lock
                  endAdornment={
                    <InputAdornment position="end">
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  maskedData={maskedData}
                  value={fieldValue}
                />
                <XDivider width="30px" />
              </>
            )
          }
        }
      })
    }

    let headerAdded = false
    fieldsVerify.forEach((formElement) => {
      if (!headerAdded) {
        headerAdded = true

        fields.splice(0, 0,
          <h3 style={{ color: '#1b75bc' }}>{t('routeTitles.dataEntry')}</h3>
        )

        fields.push(
          <h3 style={{ color: '#1b75bc' }}>{t('dashBoard.verification')}</h3>
        )
      }
      fields.push(formElement)
    })
    return [...fields]
  }

  const getBoxFieldsForReKey = () => {
    const fields = []
    const fieldsVerify = []
    const { lockableFields, lockableFieldsData } = getState()
    if (getState().isTemplateFieldAdded) {
      let count = 6
      let countVerify = 6 + getState().templateFields.length
      let fieldValue = ''
      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          ++count
          const innercount = count
          if (getState().boxList.length > 0 && getState().boxVerifyStartCount < (getState().boxList.length)) {
            fieldValue = getState().boxList[getState().boxVerifyStartCount][element.name]
          } else {
            fieldValue = element.defaultValue ? element.defaultValue : ''
            // if (element.name === DEPT_ID || element.name === DIV_ID) {
            //   const prevValue = getState().boxList.length > 0 && getState().isDeptLocked ? getState().boxList[getState().boxVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.deptValue || prevValue
            // }
            // if (element.name === DIV_ID) {
            //   const prevValue = getState().boxList.length > 0 && getState().isDivLocked ? getState().boxList[getState().boxVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.divisionValue || prevValue
            // }
            if (element.name in lockableFields && lockableFields[element.name] && getState().boxList.length > 1) {
              // const prevValue = getState().boxList[getState().boxVerifyStartCount - 1][element.name]
              // lockableFieldsData[element.name] = element.defaultValue || prevValue
              fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.lockableFieldsData[element.name]
            }
          }

          if (formTemplate[innercount]) {
            formTemplate[innercount].defaultValue = fieldValue
          }

          const maskedData = {
            status: false,
            value: ''
          }
          const definedDateFormat = Object.keys(dateValidatePattern)
          if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
            maskedData.status = true
            maskedData.value = element?.customFormat
          }

          fields.push(
            <>
              <TextField
                id={`dataEntry_fields_${formTemplate[innercount].label}`}
                fieldTemplate={formTemplate[innercount]}
                inputProps={{ maxLength: element.customLength }}
                ref={arrRefs[innercount]}
                data={data}
                type={(element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) ? 'password' : 'text'}
                disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]}
                onKeyDown={(e) => {
                  e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                }}
                onKeyUp={(e) => {
                  handleKeyUp(e, element)
                }}
                onBlur={(e) => {
                  e.keyCode !== 27 && handleBoxDataEntry(e, innercount, false, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      // eslint-disable-next-line
                      id={'dataEntry_lock' + element.name}
                      onClick={() => handleClickFieldLock(element.name, innercount, element.verify, element)}
                      disabled={(element.doNotLock === true)}
                    >
                      {state.lockableFields[element.name] ? <LockOutlined /> : <LockOpenOutlined />}
                    </IconButton>
                    {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                  </InputAdornment>
                }
                noTranslate
                value={fieldValue}
                maskedData={maskedData}
              />
              <XDivider width="30px" />
            </>
          )
          if (element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
            // if (element.name !== DEPT_ID && element.name !== DIV_ID) {
            if (element.name !== '') {
              // ++count
              ++countVerify
              const innercount = countVerify - 2
              const maskedData = {
                status: false,
                value: ''
              }
              if (getState().boxList.length > 0 && getState().boxVerifyStartCount < (getState().boxList.length)) {
                fieldValue = getState().boxList[getState().boxVerifyStartCount][`${element.name}_verify`]
              }

              if (element.name in lockableFields && lockableFields[`${element.name}_verify`] && !fieldValue) {
                fieldValue = lockableFieldsData[`${element.name}_verify`]
              }

              const definedDateFormat = Object.keys(dateValidatePattern)
              if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
                maskedData.status = true
                maskedData.value = element?.customFormat
              }
              if (formTemplate[innercount]) {
                formTemplate[innercount].defaultValue = fieldValue
              }
              fieldsVerify.push(
                <>
                  <TextField
                    id={`dataEntry_fields_${formTemplate[innercount].label}`}
                    fieldTemplate={formTemplate[innercount]}
                    ref={arrRefs[innercount]}
                    inputProps={{ maxLength: element.customLength }}
                    disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[`${element.name}_verify`]}
                    onKeyDown={(e) => {
                      e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, true, element)
                    }}
                    onKeyUp={(e) => {
                      handleKeyUp(e, element)
                    }}
                    onBlur={(e) => {
                      e.keyCode !== 27 && handleBoxDataEntry(e, innercount, true, false, element)
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                      </InputAdornment>
                    }
                    noTranslate
                    maskedData={maskedData}
                    value={fieldValue}
                  />
                  <XDivider width="30px" />
                </>
              )
            }
          }
        }
      })
    }

    let headerAdded = false
    fieldsVerify.forEach((formElement) => {
      if (!headerAdded) {
        headerAdded = true

        fields.splice(0, 0,
          <h3 style={{ color: '#1b75bc' }}>{t('routeTitles.dataEntry')}</h3>
        )

        fields.push(
          <h3 style={{ color: '#1b75bc' }}>{t('dashBoard.verification')}</h3>
        )
      }
      fields.push(formElement)
    })
    return [...fields]
  }

  const getTemplateFields = () => {
    const fields = []
    const fieldsVerify = []
    const { lockableFields, lockableFieldsData } = getState()
    if (getState().isTemplateFieldAdded) {
      let count = 6
      let countVerify = 6 + getState().templateFields.length
      let fieldValue = ''

      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          ++count
          const innercount = count
          if (getState().fileList.length > 0 && getState().fileVerifyStartCount < (getState().fileList.length)) {
            fieldValue = getState().fileList[getState().fileVerifyStartCount][element.name]
          } else {
            fieldValue = element.defaultValue ? element.defaultValue : ''
            // if (element.name === DEPT_ID) {
            //   const prevValue = getState().fileList.length > 0 && getState().isDeptLocked ? getState().fileList[getState().fileVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount]?.defaultValue || element.defaultValue || state.deptValue || prevValue
            // }
            // if (element.name === DIV_ID) {
            //   const prevValue = getState().fileList.length > 0 && getState().isDivLocked ? getState().fileList[getState().fileVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount]?.defaultValue || element.defaultValue || state.divisionValue || prevValue
            // }
            if (element.name in lockableFields && lockableFields[element.name] && getState().fileList.length > 0) {
              // const prevValue = getState().fileList[getState().fileVerifyStartCount - 1][element.name]
              fieldValue = formTemplate[innercount]?.defaultValue || element.defaultValue || lockableFieldsData[element.name]
            }

            if (element.name in lockableFields && lockableFields[element.name] && !fieldValue) {
              fieldValue = lockableFieldsData[element.name]
            }
          }

          if (formTemplate[innercount]) {
            formTemplate[innercount].defaultValue = fieldValue
          }

          const maskedData = {
            status: false,
            value: ''
          }
          const definedDateFormat = Object.keys(dateValidatePattern)
          if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
            maskedData.status = true
            maskedData.value = element?.customFormat
          }

          if (element.name === MAINTENANCE_CODE) {
            fields.push(
              <><FieldHidden>
                <TextField
                  id={`dataEntry_fields_${formTemplate[innercount].label}`}
                  inputProps={{ maxLength: element.customLength }}
                  fieldTemplate={formTemplate[innercount]}
                  ref={arrRefs[innercount]}
                  data={data}
                  disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && handleDataEntry(e, innercount, false, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {((getState()?.dataUploadFields && !getState()?.dataUploadFields.includes(element.name)) || getState()?.dataUploadFields === undefined) &&
                        <IconButton
                          // eslint-disable-next-line
                          id={'dataEntry_lock' + element.name}
                          onClick={() => handleClickFieldLock(element.name, innercount, element.verify, element)}
                          disabled={(element.doNotLock === true)}
                        >
                          {state.lockableFields[element.name] ? <LockOutlined /> : <LockOpenOutlined />}
                        </IconButton>}
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={fieldValue}
                  maskedData={maskedData}
                />
                <XDivider width="30px" />
              </FieldHidden>
              </>
            )
          } else {
            fields.push(
              <>
                <TextField
                  id={`dataEntry_fields_${formTemplate[innercount].label}`}
                  inputProps={{ maxLength: element.customLength }}
                  fieldTemplate={formTemplate[innercount]}
                  ref={arrRefs[innercount]}
                  data={data}
                  disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && handleDataEntry(e, innercount, false, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {((getState()?.dataUploadFields && !getState()?.dataUploadFields.includes(element.name)) || getState()?.dataUploadFields === undefined) &&
                        <IconButton
                          // eslint-disable-next-line
                          id={'dataEntry_lock' + element.name}
                          onClick={() => handleClickFieldLock(element.name, innercount, element.verify, element)}
                          disabled={(element.doNotLock === true)}
                        >
                          {state.lockableFields[element.name] ? <LockOutlined /> : <LockOpenOutlined />}
                        </IconButton>}
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={fieldValue}
                  maskedData={maskedData}
                />
                <XDivider width="30px" />
              </>
            )
          }
          if (element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
            // ++count
            ++countVerify
            const innercount = countVerify - 2
            const maskedData = {
              status: false,
              value: ''
            }

            if (getState().fileList.length > 0 && getState().fileVerifyStartCount < (getState().fileList.length)) {
              fieldValue = getState().fileList[getState().fileVerifyStartCount][`${element.name}_verify`]
            }

            if (element.name in lockableFields && lockableFields[`${element.name}_verify`] && !fieldValue) {
              fieldValue = lockableFieldsData[`${element.name}_verify`]
            }

            const definedDateFormat = Object.keys(dateValidatePattern)
            if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
              maskedData.status = true
              maskedData.value = element?.customFormat
            }
            if (formTemplate[innercount]) {
              formTemplate[innercount].defaultValue = fieldValue
            }
            fieldsVerify.push(
              <>
                <TextField
                  id={`dataEntry_fieldsEditable_${formTemplate[innercount].label}`}
                  inputProps={{ maxLength: element.customLength }}
                  fieldTemplate={formTemplate[innercount]}
                  ref={arrRefs[innercount]}
                  disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[`${element.name}_verify`]}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, true, element)
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && handleDataEntry(e, innercount, true, false, element)
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={fieldValue}
                  maskedData={maskedData}
                />
                <XDivider width="30px" />
              </>
            )
          }
        }
      })
    }

    let headerAdded = false
    fieldsVerify.forEach((formElement) => {
      if (!headerAdded) {
        headerAdded = true

        fields.splice(0, 0,
          <h3 style={{ color: '#1b75bc' }}>{t('routeTitles.dataEntry')}</h3>
        )

        fields.push(
          <h3 style={{ color: '#1b75bc' }}>{t('dashBoard.verification')}</h3>
        )
      }
      fields.push(formElement)
    })
    return fields
  }

  const getBoxTemplateFields = () => {
    const fields = []
    const fieldsVerify = []
    // eslint-disable-next-line
    const { lockableFields, lockableFieldsData } = getState()
    if (getState().isTemplateFieldAdded) {
      let count = 6
      let countVerify = 6 + getState().templateFields.length
      let fieldValue = ''
      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          ++count
          const innercount = count
          if (getState().boxList.length > 0 && getState().boxVerifyStartCount < (getState().boxList.length)) {
            fieldValue = getState().boxList[getState().boxVerifyStartCount][element.name]
          } else {
            fieldValue = element.defaultValue ? element.defaultValue : ''
            // if (element.name === DEPT_ID) {
            //   const prevValue = getState().boxList.length > 0 && getState().isDeptLocked ? getState().boxList[getState().boxVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.deptValue || prevValue
            // }
            // if (element.name === DIV_ID) {
            //   const prevValue = getState().boxList.length > 0 && getState().isDivLocked ? getState().boxList[getState().boxVerifyStartCount - 1][element.name] : ''
            //   fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.divisionValue || prevValue
            // }
            if (element.name in lockableFields && lockableFields[element.name] && getState().boxList.length > 1) {
              // const prevValue = getState().boxList[getState().boxVerifyStartCount - 1][element.name]
              fieldValue = formTemplate[innercount].defaultValue || element.defaultValue || state.lockableFieldsData[element.name]
            }
          }

          if (!fieldValue && lockableFields[element.name]) {
            fieldValue = state.lockableFieldsData[element.name]
          }

          if (formTemplate[innercount]) {
            formTemplate[innercount].defaultValue = fieldValue
          }

          const maskedData = {
            status: false,
            value: ''
          }
          const definedDateFormat = Object.keys(dateValidatePattern)
          if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
            maskedData.status = true
            maskedData.value = element?.customFormat
          }
          if (element.name === MAINTENANCE_CODE) {
            fields.push(
              <><FieldHidden>
                <TextField
                  id={`dataEntry_fields_${formTemplate[innercount].label}`}
                  fieldTemplate={formTemplate[innercount]}
                  inputProps={{ maxLength: element.customLength }}
                  ref={arrRefs[innercount]}
                  data={data}
                  disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && handleBoxDataEntry(e, innercount, false, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        // eslint-disable-next-line
                        id={'dataEntry_lock' + element.name}
                        onClick={() => handleClickFieldLock(element.name, innercount, element.verify, element)}
                        disabled={(element.doNotLock === true)}
                      >
                        {state.lockableFields[element.name] ? <LockOutlined /> : <LockOpenOutlined />}
                      </IconButton>
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={fieldValue}
                  maskedData={maskedData}
                />
                <XDivider width="30px" />
              </FieldHidden></>
            )
          } else {
            fields.push(
              <>
                <TextField
                  id={`dataEntry_fields_${formTemplate[innercount].label}`}
                  fieldTemplate={formTemplate[innercount]}
                  inputProps={{ maxLength: element.customLength }}
                  ref={arrRefs[innercount]}
                  data={data}
                  disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[element.name]}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && handleBoxDataEntry(e, innercount, false, false, element, !!((element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)))
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        // eslint-disable-next-line
                        id={'dataEntry_lock' + element.name}
                        onClick={() => handleClickFieldLock(element.name, innercount, element.verify, element)}
                        disabled={(element.doNotLock === true)}
                      >
                        {state.lockableFields[element.name] ? <LockOutlined /> : <LockOpenOutlined />}
                      </IconButton>
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={fieldValue}
                  maskedData={maskedData}
                />
                <XDivider width="30px" />
              </>
            )
          }
          if (element.verify && getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
            // if (element.name !== DEPT_ID && element.name !== DIV_ID) {
            if (element.name !== '') {
              // ++count
              ++countVerify
              const innercount = countVerify - 2
              const maskedData = {
                status: false,
                value: ''
              }
              if (getState().boxList.length > 0 && getState().boxVerifyStartCount < (getState().boxList.length)) {
                fieldValue = getState().boxList[getState().boxVerifyStartCount][element.name]
              }

              if (!fieldValue && getState().lockableFields[element.name]) {
                fieldValue = getState().lockableFieldsData[element.name]
              }

              const definedDateFormat = Object.keys(dateValidatePattern)
              if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
                maskedData.status = true
                maskedData.value = element?.customFormat
              }

              if (formTemplate[innercount]) {
                formTemplate[innercount].defaultValue = fieldValue
              }

              fieldsVerify.push(
                <>
                  <TextField
                    id={`dataEntry_fieldsEditable_${formTemplate[innercount].label}`}
                    fieldTemplate={formTemplate[innercount]}
                    ref={arrRefs[innercount]}
                    inputProps={{ maxLength: element.customLength }}
                    disabled={getState().isAllFieldsDisabled === true ? true : state.lockableFields[`${element.name}_verify`]}
                    onKeyDown={(e) => {
                      e.keyCode !== 27 && dataEntryEnterKeyPress(e, innercount, true, element)
                    }}
                    onKeyUp={(e) => {
                      handleKeyUp(e, element)
                    }}
                    onBlur={(e) => {
                      e.keyCode !== 27 && handleBoxDataEntry(e, innercount, true, false, element)
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                      </InputAdornment>
                    }
                    noTranslate
                    value={fieldValue}
                    maskedData={maskedData}
                  />
                  <XDivider width="30px" />
                </>
              )
            }
          }
        }
      })
    }

    let headerAdded = false
    fieldsVerify.forEach((formElement) => {
      if (!headerAdded) {
        headerAdded = true

        fields.splice(0, 0,
          <h3 style={{ color: '#1b75bc' }}>{t('routeTitles.dataEntry')}</h3>
        )

        fields.push(
          <h3 style={{ color: '#1b75bc' }}>{t('dashBoard.verification')}</h3>
        )
      }
      fields.push(formElement)
    })
    return fields
  }

  const getVerificationUserTemplateFields = () => {
    const unVerifiedFiles = getState().fileList
    // setting the infoToast for the firsttime User goes to 'Verification in Process' box
    if (getState().boxData.status === constants.boxStatus.verificationInProcess) {
      let isVerificationPending = ''
      let firstUnverifiedFile
      const unVerifiedFiles = []
      const unVerifiedFilesId = []
      let fileVerifyStartCount = 0
      const fileCount = getState().fileVerifyStartCount + 1
      getState().fileList.forEach((file, index) => {
        if (file[fileStatus] !== constants.fileStatus.verified) {
          unVerifiedFilesId.push(index + 1)
          file.fileIndex = index + 1
          unVerifiedFiles.push(file)
          if (unVerifiedFiles.length === 1) {
            firstUnverifiedFile = index + 1
          }
        }
      })

      let prevFileId = false
      let foundInSequence = false
      unVerifiedFilesId.forEach((fileId, fileIndex) => {
        if (fileIndex === 0) {
          prevFileId = fileId
          isVerificationPending = `${isVerificationPending} ${fileId}`
        } else if (prevFileId + 1 === fileId) {
          prevFileId = fileId
          foundInSequence = true
        } else if (fileId - prevFileId > 1) {
          if (foundInSequence) {
            foundInSequence = false
            isVerificationPending = `${isVerificationPending} - ${prevFileId}`
          }
          isVerificationPending = `${isVerificationPending}, ${fileId}`
          prevFileId = fileId
        }

        if (foundInSequence && fileIndex + 1 === unVerifiedFilesId.length) {
          foundInSequence = false
          isVerificationPending = `${isVerificationPending} - ${prevFileId}`
        }

        isVerificationPending = `${isVerificationPending}`
      })

      if (firstUnverifiedFile <= getState().fileList.length && fileCount !== firstUnverifiedFile) {
        fileVerifyStartCount = firstUnverifiedFile
        setState({ fileVerifyStartCount: fileVerifyStartCount - 1 })
        warningToast({
          message: t('toast.filesVerificationPendingMsg2', { verificatioPendingFiles: isVerificationPending, firstUnverifiedFile: firstUnverifiedFile }),
          noTranslateMessage: true,
          autoHideDuration: 5000,
          closeIcon: true,
          isBlocking: false
        })
      }
    }
    const differentUserField = []
    if (getState().isTemplateFieldAdded) {
      let count = 0
      let fileverified = false
      if (unVerifiedFiles[getState()?.fileVerifyStartCount]?.status === constants.fileStatus.verified && getState()?.jobDetails?.boxLevelRetransmit !== true) {
        fileverified = true
      }
      const formTemplateCount = DATAENTRYSTARTINGKEY
      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          const innercount = formTemplateCount + count
          const fieldValue = unVerifiedFiles[getState()?.fileVerifyStartCount][element.name]
          const maskedData = {
            status: false,
            value: ''
          }
          const definedDateFormat = Object.keys(dateValidatePattern)
          if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
            maskedData.status = true
            maskedData.value = element?.customFormat
          }
          if (element.name === MAINTENANCE_CODE) {
            differentUserField.push(
              <>
                <FieldHidden>
                  <TextField
                    id={`dataEntry_fields_verify${formTemplate[innercount].label}`}
                    inputProps={{ maxLength: element.customLength }}
                    fieldTemplate={formTemplate[innercount]}
                    ref={arrRefs[innercount]}
                    disabled={(!getState().isVerifyTemplateFieldsEditable || !element.verify)}
                    onKeyDown={(e) => {
                      e.keyCode !== 27 && dataEntryVerifyEnterKeyPress(
                        e,
                        innercount,
                        element,
                        fieldValue,
                        arrRefs
                      )
                      handleKeyUp(e, element)
                    }}
                    onKeyUp={(e) => {
                      handleKeyUp(e, element)
                    }}
                    onBlur={(e) => {
                      e.keyCode !== 27 && dataValidationCheck(
                        e,
                        innercount,
                        element,
                        fieldValue,
                        arrRefs
                      )
                      handleKeyUp(e, element)
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                      </InputAdornment>
                    }
                    noTranslate
                    value={(element.verify === true && !fileverified) ? '' : fieldValue}
                    maskedData={maskedData}
                  />
                  <VerticalDivider></VerticalDivider>
                </FieldHidden>
              </>
            )
          } else {
            differentUserField.push(
              <>
                <TextField
                  id={`dataEntry_fields_verify${formTemplate[innercount].label}`}
                  inputProps={{ maxLength: element.customLength }}
                  fieldTemplate={formTemplate[innercount]}
                  ref={arrRefs[innercount]}
                  disabled={(!getState().isVerifyTemplateFieldsEditable || !element.verify)}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryVerifyEnterKeyPress(
                      e,
                      innercount,
                      element,
                      fieldValue,
                      arrRefs
                    )
                    handleKeyUp(e, element)
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && dataValidationCheck(
                      e,
                      innercount,
                      element,
                      fieldValue,
                      arrRefs
                    )
                    handleKeyUp(e, element)
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={(element.verify === true && !fileverified) ? '' : fieldValue}
                  maskedData={maskedData}
                />
                <VerticalDivider></VerticalDivider>
              </>
            )
          }
          ++count
        }
      })
    }
    return differentUserField
  }

  const getVerificationUserBoxTemplateFields = () => {
    const differentUserField = []
    if (getState().isTemplateFieldAdded) {
      let count = 0
      const formTemplateCount = DATAENTRYSTARTINGKEY
      getState().templateFields.forEach((element) => {
        if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
          const innercount = formTemplateCount + count
          const fieldValue = getState().boxList[getState().boxVerifyStartCount][element.name]
          const maskedData = {
            status: false,
            value: ''
          }
          const definedDateFormat = Object.keys(dateValidatePattern)
          if (element?.customFormat && (element?.customFormat !== definedDateFormat[0] && element?.customFormat !== definedDateFormat[1]) && !appConstants.countrySpecificFormats.includes(element?.customFormat)) {
            maskedData.status = true
            maskedData.value = element?.customFormat
          }
          if (element.name === MAINTENANCE_CODE) {
            differentUserField.push(
              <>
                <FieldHidden>
                  <TextField
                    id={`dataEntry_fields_verify${formTemplate[innercount].label}`}
                    fieldTemplate={formTemplate[innercount]}
                    ref={arrRefs[innercount]}
                    inputProps={{ maxLength: element.customLength }}
                    disabled={(!getState().isVerifyTemplateFieldsEditable || !element.verify)}
                    onKeyDown={(e) => {
                      dataEntryVerifyEnterKeyPress(
                        e,
                        innercount,
                        element,
                        fieldValue,
                        arrRefs
                      )
                      handleKeyUp(e, element)
                    }}
                    onKeyUp={(e) => {
                      handleKeyUp(e, element)
                    }}
                    onBlur={(e) => {
                      e.keyCode !== 27 && dataValidationCheck(
                        e,
                        innercount,
                        element,
                        fieldValue,
                        arrRefs
                      )
                      handleKeyUp(e, element)
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                      </InputAdornment>
                    }
                    noTranslate
                    value={element.verify === true ? '' : fieldValue}
                    maskedData={maskedData}
                  />
                  <VerticalDivider></VerticalDivider>
                </FieldHidden>
              </>
            )
          } else {
            differentUserField.push(
              <>
                <TextField
                  id={`dataEntry_fields_verify${formTemplate[innercount].label}`}
                  fieldTemplate={formTemplate[innercount]}
                  ref={arrRefs[innercount]}
                  inputProps={{ maxLength: element.customLength }}
                  disabled={(!getState().isVerifyTemplateFieldsEditable || !element.verify)}
                  onKeyDown={(e) => {
                    e.keyCode !== 27 && dataEntryVerifyEnterKeyPress(
                      e,
                      innercount,
                      element,
                      fieldValue,
                      arrRefs
                    )
                    handleKeyUp(e, element)
                  }}
                  onKeyUp={(e) => {
                    handleKeyUp(e, element)
                  }}
                  onBlur={(e) => {
                    e.keyCode !== 27 && dataValidationCheck(
                      e,
                      innercount,
                      element,
                      fieldValue,
                      arrRefs
                    )
                    handleKeyUp(e, element)
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      {element.instructionData ? <ToolTip noTranslate message={element.instructionData}><Info /></ToolTip> : <div style={{ width: '24px' }}></div>}
                    </InputAdornment>
                  }
                  noTranslate
                  value={element.verify === true ? '' : fieldValue}
                  maskedData={maskedData}
                />
                <VerticalDivider></VerticalDivider>
              </>
            )
          }
          ++count
        }
      })
    }
    return differentUserField
  }

  const onLastEnterKeyPress = async (currentArrCount, e) => {
    for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
      let isRequired
      getState().templateFields.forEach((element) => {
        if (element.name === arrRefs[i]?.current.getFormTemplate().fieldKey) {
          isRequired = element.isRequired
          return isRequired
        }
      })

      const value = arrRefs[i]?.current?.getValue()
      if (isRequired && value === '') {
        arrRefs[i]?.current?.setErrorMsg('dataEntry.requiredErrorcode')
        validationErrors[arrRefs[i]?.current?.getFormTemplate().name] = 'dataEntry.requiredErrorcode'
      }
    }

    let fromDateValue
    let fromDateValueIndex
    let toDateValue
    let toDateValueIndex
    for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
      if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'fromDate') {
        fromDateValue = arrRefs[i]?.current?.getValue()
        fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        fromDateValueIndex = i
      }

      if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'toDate') {
        toDateValue = arrRefs[i]?.current?.getValue()
        toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        toDateValueIndex = i
      }
    }

    if (fromDateValue && toDateValue) {
      if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
        arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        validationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'

        arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        validationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'
      }
    }
    // #925: Code which disables saving of the files if there are any validation errors in the particular File
    setState({ validationCase: getState()?.validationErrorCase?.length !== 0 })

    if (Object.keys(validationErrors).length === 0 && !getState()?.validationCase) {
      const arrCount = DATAENTRYSTARTINGKEY
      const enteredData = {}
      let { fileVerifyStartCount: fileCount, currentFileCount, fileList, fileSequence } = getState()
      const originalFileCount = fileCount
      const isProgress = fileList[fileCount]?.status ? (fileList[fileCount]?.status === constants.fileStatus.inProgress) : undefined
      const isAddingNewFile = originalFileCount >= fileList.length
      const shouldIncrementTotalFiles = !state.isRekey && (isAddingNewFile || isProgress)
      // const filename = `file-${fileCount + 1}`
      const fileNO = `${fileSequence}`
      const filename = fileNO.padStart(5, '0')
      enteredData[fileStatus] = constants.fileStatus.keyed
      enteredData[fileName] = filename
      if (fileCount < fileList.length) {
        fileList = updateFileOnEnter(true)

        if (isProgress || state.isRekey) {
          currentFileCount++
        }
        if (isProgress) {
          fileSequence++
        }
      } else {
        currentFileCount++
        fileSequence++
        fileList.push(enteredData)
      }

      fileCount++

      let focusKey = DATAENTRYSTARTINGKEY
      for (let i = arrCount; i < arrRefs.length; i++) {
        // #340 : code to move the focus on the data entry field after clicking enter from last field
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const key2 = key.replace('_verify', '')
        let isKeyAvailable = false
        if (key2 !== getState()?.uniqueFieldKeyToUploadData && getState()?.isUploadCustomerDataFile === true) {
          isKeyAvailable = getState()?.dataUploadFields.includes(key2)
        }

        const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]
        if (!nextFieldLockStatus && nextFieldLockStatus !== undefined && isKeyAvailable !== true) {
          focusKey = i
          break
        }
      }


      // arrRefs[focusKey]?.current?.setValue('')
      arrRefs[focusKey].current.focus()

      if (getState().isEditRecordButtonClicked) {
        setState({ isEditRecordButtonClicked: false })
        fileCount = fileList.length
      }

      setState({ fileList: fileList, filesKeyed: fileCount, viewFiles: true, currentFileCount: currentFileCount, fileVerifyStartCount: fileCount, isCancelButtonvisible: false, fileSequence })

      for (let i = arrCount; i < arrRefs.length; i++) {
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const isDisabled = arrRefs[i]?.current?.getFormTemplate().disabled
        enteredData[key] = arrRefs[i]?.current?.getValue()

        if (enteredData[key] === undefined && getState()?.isUploadCustomerDataFile === true) {
          enteredData[key] = getState()?.lockableFieldsData[key]
        }

        if (!isDisabled || !getState().lockableFields[key]) {
          arrRefs[i]?.current?.clear()
          if (arrRefs[i]?.current?.getFormTemplate().defaultValue) {
            arrRefs[i]?.current?.setValue(arrRefs[i]?.current?.getFormTemplate().defaultValue)
          } else {
            arrRefs[i]?.current?.setValue('')
          }
        }
      }

      enteredData.isLastExisiting = false
      let fileSaved = false
      if (fileList[fileCount - 1]?.isLastExisiting) {
        saveFiles(fileCount - 1, fileList[fileCount - 1], true, fileList[fileCount - 1].fileId)
      } else {
        fileSaved = true
        saveFiles(fileCount - 1, enteredData, false, fileSequence - 1)
      }
      if ((getState().fileList.length % getState()?.recordNotifyCount) === 0) {
        e?.preventDefault()
        if (isModalOpen) recordCountAlert()
      }

      // #340: code to empty the auto populated fields after saving
      if (fileSaved === true && getState()?.isUploadCustomerDataFile === true) {
        for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
          const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
          const key2 = key.replace('_verify', '')
          if (getState().dataUploadFields.includes(key) || getState().dataUploadFields.includes(key2)) {
            arrRefs[i]?.current?.clear()
            arrRefs[i]?.current?.setValue('')
          }
        }
      }
      // AI Generated Start - only increment Files Keyed for new or in-progress files, not re-saved keyed files
      if (shouldIncrementTotalFiles) {
        // 647: Increasing the total file count by 1 when user keys a file from UI only
        setState({
          totalFiles: getState().totalFiles + 1
        })
      }
      // AI Generated End
    }
  }


  const clearFields = () => {
    const arrCount = DATAENTRYSTARTINGKEY
    const enteredData = {}
    const { templateFields } = getState()
    enteredData[fileStatus] = constants.fileStatus.keyed
    enteredData.skpBoxId = arrRefs[SKPBOX]?.current?.getValue()
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      for (let i = arrCount; i < arrRefs.length; i++) {
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const isDisabled = arrRefs[i]?.current?.getFormTemplate().disabled
        enteredData[key] = arrRefs[i]?.current?.getValue()

        if (!isDisabled || !getState().lockableFields[key]) {
          arrRefs[i]?.current?.clear()
          if (arrRefs[i]?.current?.getFormTemplate().defaultValue) {
            arrRefs[i]?.current?.setValue(arrRefs[i]?.current?.getFormTemplate().defaultValue)
          } else {
            arrRefs[i]?.current?.setValue('')
          }
        }
      }
    } else {
      for (let i = arrCount; i < arrRefs.length; i++) {
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const isDisabled = arrRefs[i]?.current?.getFormTemplate().disabled
        enteredData[key] = arrRefs[i]?.current?.getValue()
        let defaultValue = ''
        // checking default value with template field data
        templateFields.forEach((element) => {
          if (element.name === key) {
            defaultValue = element.defaultValue
          }
        })

        if (!isDisabled || !getState().lockableFields[key]) {
          arrRefs[i]?.current?.clear()
          if (defaultValue) {
            arrRefs[i]?.current?.setValue(defaultValue)
          } else {
            arrRefs[i]?.current?.setValue('')
          }
        }
      }
    }

    arrRefs[SKPBOX]?.current?.setValue('')
    arrRefs[SKPBOX_CONFIRM]?.current?.setValue('')
    arrRefs[SKPBOX]?.current?.focus()
  }

  // #1019: Added a new function which gets called only when all the fields are locked in the template
  const onLockFieldSave = async (e) => {
    dropFirstLetterSkpBox && setDropFirstLetterSkpBox(false)
    dropFirstLetterSkpBoxCnf && setDropFirstLetterSkpBoxCnf(false)
    setState({ isSkpBoxIdEditable: false })
    if (!recordKeystrokes) {
      props.resume()
      turnOnKeystrokeRecorder(getState().timerObj)
    }

    const boxId = getState().boxId || getBoxId() || arrRefs[SKPBOX].current.getValue()
    // const boxesForJob = await gdeTransactions.getBoxesForJob(getState().jobId)

    let boxAlreadyExists = false
    let maxBoxSerialNo = 0
    countData.forEach((item) => {
      if (boxId !== item.boxId && maxBoxSerialNo < item.boxSrNo && boxAlreadyExists === false) {
        maxBoxSerialNo = item.boxSrNo
      }
      if (boxId === item.boxId) {
        boxAlreadyExists = true
        maxBoxSerialNo = item.boxSrNo
      }
    })

    let dataentryUser
    let verificationUser
    let status
    if (getState().userType === userTypes.DATAENTRY_USER || getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
      // const jobDocument = await gdeTransactions.getJobById(getState().jobId)
      const jobDoc = getState()?.jobData
      const isQualityCheckRequired = jobDoc?.qualityCheck

      if (getState().userType === userTypes.DATAENTRY_USER) {
        if (getState().isVerifyRequired) {
          status = constants.boxStatus.readyForVerification
        } else {
          if (isQualityCheckRequired) {
            status = constants.boxStatus.readyForQc
          } else {
            status = constants.boxStatus.approved
          }
        }
      } else if (getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER || getState().userType === userTypes.VERIFICATION_USER) {
        if (isQualityCheckRequired) {
          status = constants.boxStatus.readyForQc
        } else {
          status = constants.boxStatus.approved
        }
      }
      const verifyUser = jobDoc?.assignedUsers[logedInUser]?.verifyUser
      setState({ jobUserData: jobDoc?.assignedUsers[logedInUser] })
      if (getState().userType === userTypes.DATAENTRY_USER) {
        dataentryUser = logedInUser
        verificationUser = verifyUser || getState()?.jobUserData?.verifyUser || logedInUser
      } else if (getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
        dataentryUser = logedInUser
        verificationUser = verifyUser || logedInUser
      }
    }
    let isRequireQC = false
    if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined' && additionalPermissionsForUser[indexOfrequireQualityCheck]?.enabled && getState().isVerifyRequired) {
      isRequireQC = true
    }

    let boxData = {
      jobId: getState().jobId,
      districtId: getState().jobDetails.districtId,
      accountLevel1: getState().jobDetails.accountLevel1.toUpperCase(),
      boxId: boxId,
      status: status,
      dataEntryUser: dataentryUser,
      verificationUser: verificationUser,
      actionTs: new Date(),
      createdTs: new Date(),
      transmissionStatus: constants.boxTransmissionStatus.pending,
      transmissionStatusTs: new Date(),
      requireQC: isRequireQC,
    }

    if (!boxAlreadyExists) {
      boxData.boxSrNo = maxBoxSerialNo + 1
    } else {
      boxData.boxSrNo = maxBoxSerialNo
    }

    const enteredData = {}
    let { boxsCount, currentBoxCount, boxList } = getState()
    const isProgress = boxList[boxsCount]?.status ? (boxList[boxsCount]?.status === constants.fileStatus.inProgress) : undefined
    enteredData[fileStatus] = constants.fileStatus.keyed
    enteredData.skpBoxId = boxId

    for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
      const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
      enteredData[key] = arrRefs[i]?.current?.getValue()
    }

    if (getState()?.boxsCount < getState()?.boxList.length) {
      boxList = updateBoxOnEnter(true)
      boxsCount++
      if (isProgress || state.isRekey) {
        setState({ currentBoxCount: currentBoxCount + 1 })
      }
    } else {
      setState({ currentBoxCount: currentBoxCount + 1 })
      boxList.push(enteredData)
    }

    if (online) {
      const { boxIds, boxList } = getState()
      const boxCountMetrics = getState().currentBoxCount
      setPauseEnabled(true)
      props.stop()

      if (recordKeystrokes) {
        if (keystrokes.length > 0) {
          turnOffKeystrokeRecorder(false, boxId, 0, boxCountMetrics)
        } else {
          saveMetricsData(false, boxId, 0, boxCountMetrics)
        }
      } else {
        saveMetricsData(false, boxId, 0, boxCountMetrics, false, getState().timerObj)
      }

      const boxesListToUpdate = [...getState().boxList]
      boxesListToUpdate.forEach(async (box) => {
        if (box.skpBoxId === boxId) {
          const boxName = box.skpBoxId
          box.skpBoxId = boxName
          if (getState()?.jobDetails?.dataEntryType === 'Maintenance Box' && getState()?.jobDetails?.templateData?.templateFields !== undefined) {
            box.maintenanceCode = getState()?.jobDetails?.templateData?.templateFields?.maintenanceCode?.defaultValue
          }
          box.customerId = getState().jobDetails.accountLevel1.toUpperCase()
          delete box.status
          boxData = { ...boxData, boxInfo: box }
        }
      })
      boxIds.push(boxId)
      // 1019: To update the AutoTransmit and the Job Status for Box Templates
      if (getState()?.jobDetails?.jobStatus !== constants.jobStatus.inProgress) {
        const autoTransmit = (getState()?.jobDetails?.autoTransmit === undefined) ? 'true' : getState()?.jobDetails?.autoTransmit
        getState().jobDetails.jobStatus = constants.jobStatus.inProgress
        getState().jobDetails.autoTransmitAndStatus = `${autoTransmit}-${constants.jobStatus.inProgress}`
        gdeTransactions.updateJob(getState()?.jobId, getState()?.jobDetails)
      }
      gdeTransactions.createNewBoxLockField(getState().jobId, boxId, boxData)
        .then(() => {
          arrRefs[SKPBOX].current.setValue('')
          arrRefs[SKPBOX_CONFIRM]?.current?.setValue('')
          refLocalToast.current?.successToastOn({
            message: t('toast.boxSubmitted'),
            title: t('toast.jobManagement'),
            autoHideDuration: 1000,
          })

          // setting all values to initial state as we are starting a new box again
          setState({
            boxesKeyed: boxIds.length,
            jobcompleteDisabled: false,
            recordKeyStrokesStatus: true,
            isSkpBoxIdEditable: true,
            isTemplateFieldsEditable: false,
            currentBoxCount: 0,
            boxsCount: boxsCount + 1,
            boxId: undefined,
            boxIds: boxIds,
            lastBoxKeyedStatus: status,
            isAllFieldsDisabled: true,
            boxList: boxList,
            lastKeyedBoxData: false,
            displayeBtnDisable: true,
            enterDataDisabled: true
          })
        }).then(() => arrRefs[SKPBOX].current.focus())
      return Promise.resolve()
    } else {
      errorToast({ message: t('toast.offlineMsg'), title: t('toast.userOffline'), autoHideDuration: 3000 })
      isStatusShown(true)
    }
  }

  const onLastEnterBoxKeyPress = (currentArrCount, e) => {
    setBusy()
    const { boxValidationErrors } = getState()
    for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
      let isRequired
      getState().templateFields.forEach((element) => {
        if (element.name === arrRefs[i]?.current.getFormTemplate().fieldKey) {
          isRequired = element.isRequired
          return isRequired
        }
      })

      const value = arrRefs[i]?.current?.getValue()
      if (isRequired && value === '') {
        arrRefs[i]?.current?.setErrorMsg('dataEntry.requiredErrorcode')
        boxValidationErrors[arrRefs[i]?.current?.getFormTemplate().fieldKey] = 'dataEntry.requiredErrorcode'
      }
    }

    for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
      let isRequired
      getState().templateFields.forEach((element) => {
        if (element.name === arrRefs[i]?.current.getFormTemplate().fieldKey) {
          isRequired = element.isRequired
          return isRequired
        }
      })

      const value = arrRefs[i]?.current?.getValue()
      if (isRequired && value === '') {
        arrRefs[i]?.current?.setErrorMsg('dataEntry.requiredErrorcode')
        validationErrors[arrRefs[i]?.current?.getFormTemplate().name] = 'dataEntry.requiredErrorcode'
      }
    }

    let fromDateValue
    let fromDateValueIndex
    let toDateValue
    let toDateValueIndex
    for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
      if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'fromDate') {
        fromDateValue = arrRefs[i]?.current?.getValue()
        fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        fromDateValueIndex = i
      }

      if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'toDate') {
        toDateValue = arrRefs[i]?.current?.getValue()
        toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
        toDateValueIndex = i
      }
    }

    if (fromDateValue && toDateValue) {
      if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
        arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        boxValidationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'

        arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
        boxValidationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'
      } else {
        // 925: #Existing bug which is not deleting the validation errors if from date and to date values are appropriate
        delete boxValidationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().fieldKey]
        delete boxValidationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().fieldKey]
        delete boxValidationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name]
        delete boxValidationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name]
      }
    }
    // #925: Code which disables saving of the Box if there are any validation errors in the particular Box
    setState({ validationCase: getState()?.validationErrorCase?.length !== 0 })

    if (Object.keys(boxValidationErrors).length === 0 && !getState()?.validationCase) {
      const enteredData = {}

      let { boxVerifyStartCount: boxsCount, currentBoxCount, boxList } = getState()
      const isProgress = boxList[boxsCount]?.status ? (boxList[boxsCount]?.status === constants.fileStatus.inProgress) : undefined

      const boxId = getState().boxId || getBoxId() || arrRefs[SKPBOX].current.getValue()
      // if (!state.isRekey) {
      //   boxId = arrRefs[SKPBOX].current.getValue()
      // }

      enteredData[fileStatus] = constants.fileStatus.keyed
      enteredData.skpBoxId = boxId

      for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        enteredData[key] = arrRefs[i]?.current?.getValue()
      }

      if (boxsCount < boxList.length) {
        boxList = updateBoxOnEnter(true)
        boxsCount++
        if (isProgress || state.isRekey) {
          currentBoxCount++
        }
      } else {
        currentBoxCount++
        boxList.push(enteredData)
      }

      setState({ boxList: boxList, boxId: boxId, boxesKeyed: boxsCount, viewFiles: false, currentBoxCount: currentBoxCount, boxVerifyStartCount: boxsCount, navigationBoxStartCount: getState().navigationBoxStartCount + 1, isCancelButtonvisible: true, lastKeyedBoxData: enteredData })
      setTimeout(handleSubmitData, 2)
      setTimeout(updateRefs, 1)


      arrRefs[SKPBOX].current.setValue('')
      arrRefs[SKPBOX_CONFIRM]?.current?.setValue('')
      arrRefs[SKPBOX].current.focus()

      if (getState().fileList.length >= getState()?.recordNotifyCount) {
        e?.preventDefault()
        recordCountAlert()
      }
    }
    // onHaveMoreBoxToComplete()
    clearBusy()
  }

  const handleDataEntry = async (e, arrCount, isVerify, focusRequired, element, isMasked) => {
    if (e.type === 'blur' && element.name === getState()?.uniqueFieldKeyToUploadData && getState()?.isUploadCustomerDataFile === true) {
      // eslint-disable-next-line
      const timePass = 0
    } else {
      let allowDataEntry = true
      // #340 : code to fetch data on the keying of unique field
      if (element.name === getState()?.uniqueFieldKeyToUploadData) {
        const data = await gdeTransactions.getUploadCollectionById(getState().jobId, arrRefs[arrCount]?.current?.getValue())
        const fileData = data.data()
        if (fileData === undefined) {
          arrRefs[arrCount].current.setErrorMsg('dataEntry.dataNotFound')
          // #340 : code to auto populate uploaded data into respetive fields
          for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
            const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
            const key2 = key.replace('_verify', '')
            if ((getState().dataUploadFields.includes(key) || getState().dataUploadFields.includes(key2)) && key2 !== getState().uniqueFieldKeyToUploadData) {
              arrRefs[i]?.current?.setValue('')
            }
          }
          allowDataEntry = false
        } else {
          // #340 : code to auto populate uploaded data into respetive fields
          for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
            const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
            const key2 = key.replace('_verify', '')
            if ((getState().dataUploadFields.includes(key) || getState().dataUploadFields.includes(key2)) && key2 !== getState().uniqueFieldKeyToUploadData) {
              arrRefs[i]?.current?.setValue(fileData.processedData[key2])
            }
          }
          allowDataEntry = true
        }
      }

      if (allowDataEntry) {
        const key = 'verify'
        // verification when verification and data entry user is same
        const { boxValidationErrors } = getState()
        if (isVerify) {
          let fileListforValidation = []
          const fieldValue = arrRefs[arrCount]?.current?.getValue()
          if (element.doNotDuplicate && (getState().fileVerifyStartCount < getState().fileList.length)) {
            const fileList = getState().fileList
            const tempFileList = [...fileList]
            tempFileList.forEach((file, index) => {
              if (index === getState().fileVerifyStartCount) {
                if (file[element.name] === fieldValue) {
                  const fileObj = { skpBoxId: file.skpBoxId }
                  fileListforValidation.push(fileObj)
                } else {
                  fileListforValidation.push(file)
                }
              } else {
                fileListforValidation.push(file)
              }
            })
          } else {
            fileListforValidation = getState().fileList
          }
          const [validate, noTranslate = false] = await getValidation(element, arrRefs[arrCount], getState().jobId, fileListforValidation, arrRefs, getState().skpinstance, getState()?.regexFormat)
          if (validate !== undefined) {
            setState({ isValid: false })
            validationErrors[element.name] = validate
            // #925: Code to save the validation errors in an object for file type templates if DE user and Verifier are same
            const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
            if ((validate !== 'dataEntry.requiredErrorcode') && (validate !== 'dataEntry.fromDateToDateError')) {
              const myObj = { name: fieldNameNew, error: validate }
              if (!getState()?.validationErrorCase.some(item => item.name === fieldNameNew)) {
                getState()?.validationErrorCase.push(myObj)
              } else {
                if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
                  const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
                  setState({ validationErrorCase: updatedErrors })
                }
              }
            } else if (validate === 'dataEntry.fromDateToDateError') {
              if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
                const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
                setState({ validationErrorCase: updatedErrors })
              }
            }
            if (noTranslate) {
              arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
            } else {
              arrRefs[arrCount].current.setErrorMsg(validate)
            }
          } else {
            // #925: Code to delete the validation errors in an object for file Type templates if DE user and verifier are same
            let updatedErrors
            const fieldNameNew = arrRefs[arrCount].current?.getFormTemplate()?.fieldKey
            if (fieldNameNew.endsWith('_verify')) {
              const verifyupdated = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
              updatedErrors = verifyupdated.filter(item => item.name !== fieldNameNew.replace('_verify', ''))
              setState({ validationErrorCase: updatedErrors })
            } else {
              updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
              setState({ validationErrorCase: updatedErrors })
            }
            setState({ isValid: false })
            arrRefs[arrCount].current.clearErrorMsg()
            delete validationErrors[element.name]
            delete boxValidationErrors[key]
            const fieldValue = arrRefs[arrCount]?.current?.getValue()
            if (fieldValue && Boolean(element?.specifyLength)) {
              const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
              arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
            }

            // #841 : code to get the value of data entry field for new verification workflow
            let indexOfDataEntryField = 9999
            for (const [elementIndex, elementData] of Object.entries(formTemplate)) {
              if (element.name === elementData.fieldKey && indexOfDataEntryField === 9999 && elementIndex >= DATAENTRYSTARTINGKEY) {
                indexOfDataEntryField = elementIndex
              }
            }

            if (arrRefs[arrCount].current.getValue().toLowerCase() !== arrRefs[indexOfDataEntryField].current.getValue().toLowerCase()) {
              openGeneralDialog({
                title: <VerificationDialogBox t={t} />,
                message: <ContentForDataVerification arrCount={arrCount} oldData={arrRefs[indexOfDataEntryField].current.getValue()} newData={arrRefs[arrCount].current.getValue()} element={element} handleVerifyClick={handleVerifyOnDataEntry} t={t} />,
                translateMessage: false,
                noTranslateTitle: true,
                buttons: <></>,
                closeX: true
              })
            } else if (arrCount + 1 < arrRefs.length) {
              delete boxValidationErrors[key]
              // #840 : To move the focus to next filed on click of ESC button from verification popup
              if (focusRequired && (e.keyCode === 13 || (e.keyCode === 27 && getState().verificationPopupOn))) {
                for (let i = arrCount + 1; i < arrRefs.length; i++) {
                  const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]

                  // #340 : code to move the focus on next data entry field by excluding uploaded fields
                  const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
                  const key2 = key.replace('_verify', '')
                  let isKeyAvailable = false
                  if (key2 !== getState()?.uniqueFieldKeyToUploadData && getState()?.isUploadCustomerDataFile === true) {
                    isKeyAvailable = getState()?.dataUploadFields.includes(key2)
                  }

                  if (!nextFieldLockStatus && nextFieldLockStatus !== undefined && isKeyAvailable !== true) {
                    arrRefs[i]?.current?.focus()
                    break
                  } else if (i === arrRefs.length - 1 && (nextFieldLockStatus || isKeyAvailable === true)) {
                    onLastEnterKeyPress(arrCount, e)
                    break
                  }
                }
                // #840 : Resetting state varibale after moving to next field on click of ESC
                getState()?.verificationPopupOn && setState({ verificationPopupOn: false })
              }
            } else {
              delete boxValidationErrors[key]
              if (focusRequired) {
                onLastEnterKeyPress(arrCount, e)
              }
            }
          }
        } else {
          let fileListforValidation = []
          const fieldValue = arrRefs[arrCount]?.current?.getValue()
          if (element.doNotDuplicate && (getState().fileVerifyStartCount < getState().fileList.length)) {
            const fileList = getState().fileList
            const tempFileList = [...fileList]
            tempFileList.forEach((file, index) => {
              if (index === getState().fileVerifyStartCount) {
                if (file[element.name] === fieldValue) {
                  const fileObj = { skpBoxId: file.skpBoxId }
                  fileListforValidation.push(fileObj)
                } else {
                  fileListforValidation.push(file)
                }
              } else {
                fileListforValidation.push(file)
              }
            })
          } else {
            fileListforValidation = getState().fileList
          }
          const [validate, noTranslate = false] = await getValidation(element, arrRefs[arrCount], getState().jobId, fileListforValidation, arrRefs, getState().skpinstance, getState()?.regexFormat)
          if (validate !== undefined) {
            validationErrors[element.name] = validate
            // #925: Code to save the validation errors in an object for file templates 
            const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
            if ((validate !== 'dataEntry.requiredErrorcode') && (validate !== 'dataEntry.fromDateToDateError')) {
              const myObj = { name: fieldNameNew, error: validate }
              if (!getState()?.validationErrorCase.some(item => item.name === fieldNameNew)) {
                getState()?.validationErrorCase.push(myObj)
              } else {
                if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
                  const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
                  setState({ validationErrorCase: updatedErrors })
                }
              }
            } else if (validate === 'dataEntry.fromDateToDateError') {
              if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
                const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
                setState({ validationErrorCase: updatedErrors })
              }
            }

            if (noTranslate) {
              arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
            } else {
              arrRefs[arrCount].current.setErrorMsg(validate)
            }
          } else {
            // #925: Code to delete the validation errors in an object for file templates
            const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
            const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
            setState({ validationErrorCase: updatedErrors })
            arrRefs[arrCount].current.clearErrorMsg()
            delete validationErrors[element.name]
            delete boxValidationErrors[key]
            const fieldValue = arrRefs[arrCount]?.current?.getValue()
            if (fieldValue && Boolean(element?.specifyLength)) {
              const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
              arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
            }
            if (isMasked) {
              // #841 : code to get the value of data entry field for new verification workflow
              let indexOfVerificationField = 9999
              for (const [elementIndex, elementData] of Object.entries(formTemplate)) {
                // eslint-disable-next-line
                if (elementData.fieldKey.match(element.name + '_verify') && indexOfVerificationField === 9999 && elementIndex > arrCount) {
                  indexOfVerificationField = elementIndex
                }
              }

              arrRefs[arrCount]?.current?.setFieldType('password')
              // remove error message when user changes first verify field
              if (arrRefs[arrCount].current.getValue() === arrRefs[indexOfVerificationField].current.getValue()) {
                delete validationErrors[element.name]
                arrRefs[indexOfVerificationField].current.clearErrorMsg()
              } else if (arrRefs[indexOfVerificationField].current.getValue() !== '') {
                validationErrors[element.name] = 'dataEntry.fieldsMustMatch'
                arrRefs[indexOfVerificationField].current.setErrorMsg('dataEntry.fieldsMustMatch')
              }
            }

            if (arrCount + 1 < arrRefs.length && e.keyCode === 13) {
              for (let i = arrCount + 1; i < arrRefs.length; i++) {
                const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]

                // #340 : code to move the focus on next data entry field by excluding uploaded fields
                const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
                const key2 = key.replace('_verify', '')
                let isKeyAvailable = false
                if (key2 !== getState()?.uniqueFieldKeyToUploadData && getState()?.isUploadCustomerDataFile === true) {
                  isKeyAvailable = getState()?.dataUploadFields.includes(key2)
                }

                if (!nextFieldLockStatus && nextFieldLockStatus !== undefined && isKeyAvailable !== true) {
                  arrRefs[i]?.current?.focus()
                  break
                } else if (i === arrRefs.length - 1 && (nextFieldLockStatus || isKeyAvailable === true)) {
                  onLastEnterKeyPress(arrCount, e)
                  break
                }
              }
            } else if (getState().fileVerifyStartCount < getState().fileList.length - 1) {
              if (focusRequired && Object.keys(validationErrors).length === 0) {
                let { fileVerifyStartCount: fileCount, currentFileCount, fileList } = getState()
                if (fileList[fileCount].status === constants.fileStatus.inProgress || state.isRekey) {
                  currentFileCount++
                }
                fileList = updateFileOnEnter(true)
                let focusKey = DATAENTRYSTARTINGKEY
                const arrCount = DATAENTRYSTARTINGKEY
                for (let i = arrCount; i < arrRefs.length; i++) {
                  const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]
                  if (!nextFieldLockStatus && nextFieldLockStatus !== undefined) {
                    focusKey = i
                    break
                  }
                }

                arrRefs[focusKey].current.focus()
                if (getState().isEditRecordButtonClicked) {
                  setState({ fileVerifyStartCount: fileList.length, currentFileCount, fileList: fileList, isEditRecordButtonClicked: false })
                } else {
                  setState({ fileVerifyStartCount: getState().fileVerifyStartCount + 1, currentFileCount, fileList: fileList })
                }
                saveFiles(fileCount, fileList[fileCount], true, fileList[fileCount].fileId)
                setTimeout(updateRefs, 2)
              }
            } else {
              // last enter keypress
              if (focusRequired) {
                onLastEnterKeyPress(arrCount, e)
              }
            }
          }

          // #841 : Enable sound notification when user is moving to verification field from the data entry field
          let indexOfCurrentField = 9999
          formTemplate.forEach((fieldData, index) => {
            if (index > DATAENTRYSTARTINGKEY && element.name === fieldData.fieldKey && indexOfCurrentField === 9999) {
              indexOfCurrentField = index
            }

            if (indexOfCurrentField !== 9999 && formTemplate[indexOfCurrentField + 1]?.fieldKey === MAINTENANCE_CODE) {
              indexOfCurrentField++
            }
          })

          if (formTemplate[indexOfCurrentField + 1] !== undefined && indexOfCurrentField !== 9999 && !isVerify) {
            // eslint-disable-next-line
            const nextFieldKey = formTemplate[indexOfCurrentField + 1].fieldKey
          }
        }

        setState({ currentArrCount: arrCount })
      }
    }
    clearBusy()
  }

  const blockIfDuplicateEnter = (e, element, arrCount) => {
    const fieldKey = element?.name || arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
    return blockIfDuplicateEnterKey(e.keyCode, fieldKey, lastEnterPressRef.current)
  }

  const handleBoxDataEntry = async (e, arrCount, isVerify, focusRequired, element, isMasked) => {
    const key = 'verify'
    const { boxValidationErrors } = getState()
    // verification when verification and data entry user is same

    if (isVerify) {
      const [validate, noTranslate = false] = await getValidation(element, arrRefs[arrCount], getState().jobId, getState().boxList, getState().boxesForJob, getState().skpinstance, getState()?.regexFormat)
      if (validate !== undefined) {
        boxValidationErrors[element.name] = validate
        // #925: Code to save the validation errors in an object for boxType templates if DE user and verifier are same
        const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
        if ((validate !== 'dataEntry.requiredErrorcode') && (validate !== 'dataEntry.fromDateToDateError')) {
          const myObj = { name: fieldNameNew, error: validate }
          if (!getState()?.validationErrorCase.some(item => item.name === fieldNameNew)) {
            getState()?.validationErrorCase.push(myObj)
          } else {
            if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
              const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
              setState({ validationErrorCase: updatedErrors })
            }
          }
        } else if (validate === 'dataEntry.fromDateToDateError') {
          if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
            const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
            setState({ validationErrorCase: updatedErrors })
          }
        }
        if (noTranslate) {
          arrRefs[arrCount].current.setErrorMsg(validate, noTranslate)
        } else {
          arrRefs[arrCount].current.setErrorMsg(validate)
        }
      } else {
        // #925: Code to delete the validation errors in an object for boxType templates if DE user and verifier are same
        let updatedErrors
        const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
        if (fieldNameNew?.endsWith('_verify')) {
          const verifyupdated = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
          updatedErrors = verifyupdated.filter(item => item.name !== fieldNameNew.replace('_verify', ''))
          setState({ validationErrorCase: updatedErrors })
        } else {
          updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
          setState({ validationErrorCase: updatedErrors })
        }
        delete boxValidationErrors[element.name]
        const fieldValue = arrRefs[arrCount]?.current?.getValue()
        if (fieldValue && Boolean(element?.specifyLength)) {
          const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
          arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
        }

        // #841 : code to get the value of data entry field for new verification workflow
        let indexOfDataEntryField = 9999
        for (const [elementIndex, elementData] of Object.entries(formTemplate)) {
          if (element.name === elementData.fieldKey && indexOfDataEntryField === 9999 && elementIndex >= DATAENTRYSTARTINGKEY) {
            indexOfDataEntryField = elementIndex
          }
        }

        if (arrRefs[arrCount]?.current?.getValue()?.toLowerCase() !== arrRefs[indexOfDataEntryField]?.current?.getValue()?.toLowerCase()) {
          openGeneralDialog({
            title: <VerificationDialogBox t={t} />,
            message: <ContentForDataVerification arrCount={arrCount} oldData={arrRefs[indexOfDataEntryField].current.getValue()} newData={arrRefs[arrCount].current.getValue()} element={element} handleVerifyClick={handleVerifyOnDataEntry} t={t} />,
            translateMessage: false,
            noTranslateTitle: true,
            buttons: <></>,
            closeX: true
          })
        } else if (arrCount + 1 < arrRefs.length) {
          // delete validationErrors[key]
          delete boxValidationErrors[key]
          delete boxValidationErrors[element.name]
          // #840 : To move the focus to next filed on click of ESC button from verification popup
          if (focusRequired && (e.keyCode === 13 || (e.keyCode === 27 && getState().verificationPopupOn))) {
            if (blockIfDuplicateEnter(e, element, arrCount)) {
              return false
            }

            // if (arrRefs[arrCount + 1]?.current.getFormTemplate().disabled) {
            //   arrRefs[arrCount + 2]?.current.focus()
            // } else {
            //   arrRefs[arrCount + 1]?.current.focus()
            // }
            for (let i = arrCount + 1; i < arrRefs.length; i++) {
              const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]
              if (!nextFieldLockStatus && nextFieldLockStatus !== undefined) {
                arrRefs[i]?.current?.focus()
                arrRefs[i]?.current?.focus()
                break
              } else if (i === arrRefs.length - 1 && nextFieldLockStatus) {
                onLastEnterBoxKeyPress(arrCount, e)
                break
              }
            }
            // #840 : Resetting state varibale after moving to next field on click of ESC
            getState()?.verificationPopupOn && setState({ verificationPopupOn: false })
          }

          // if (arrCount === arrRefs.length - 2 && arrRefs[arrCount + 1].current.getFormTemplate().disabled) {
          //   if (focusRequired) {
          //     onLastEnterBoxKeyPress(arrCount, e)
          //   }
          // }
        } else {
          delete boxValidationErrors[key]
          if (focusRequired) {
            if (blockIfDuplicateEnter(e, element, arrCount)) {
              return false
            }
            onLastEnterBoxKeyPress(arrCount, e)
          }
        }
      }
    } else {
      const [validate, noTranslate = false] = await getValidation(element, arrRefs[arrCount], getState().jobId, getState().boxList, arrRefs, getState().skpinstance, getState()?.regexFormat)
      if (validate !== undefined) {
        boxValidationErrors[element.name] = validate
        // #925: Code to save the validation errors in an object for boxType templates
        const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
        if ((validate !== 'dataEntry.requiredErrorcode') && (validate !== 'dataEntry.fromDateToDateError')) {
          const myObj = { name: fieldNameNew, error: validate }
          if (!getState()?.validationErrorCase.some(item => item.name === fieldNameNew)) {
            getState()?.validationErrorCase.push(myObj)
          } else {
            if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
              const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
              setState({ validationErrorCase: updatedErrors })
            }
          }
        } else if (validate === 'dataEntry.fromDateToDateError') {
          if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
            const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
            setState({ validationErrorCase: updatedErrors })
          }
        }
        if (noTranslate) {
          arrRefs[arrCount].current.setErrorMsg(validate, noTranslate)
        } else {
          arrRefs[arrCount].current.setErrorMsg(validate)
        }
      } else {
        // #925: Code to delete the validation errors in an object for boxType templates
        const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
        const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
        setState({ validationErrorCase: updatedErrors })
        delete boxValidationErrors[element.name]
        const fieldValue = arrRefs[arrCount]?.current?.getValue()
        if (fieldValue && Boolean(element?.specifyLength)) {
          const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
          arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
        }
        if (isMasked) {
          arrRefs[arrCount]?.current?.setFieldType('password')
        }
        if (blockIfDuplicateEnter(e, element, arrCount)) {
          return false
        }

        if (arrCount + 1 < arrRefs.length && e.keyCode === 13) {
          for (let i = arrCount + 1; i < arrRefs.length; i++) {
            const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]
            if (!nextFieldLockStatus && nextFieldLockStatus !== undefined) {
              arrRefs[i]?.current?.focus()
              break
            } else if (i === arrRefs.length - 1 && nextFieldLockStatus && e.keyCode === 13) {
              onLastEnterBoxKeyPress(arrCount, e)
              break
            }
          }
        } else if (getState().boxVerifyStartCount < getState().boxList.length - 1) {
          if (focusRequired && Object.keys(boxValidationErrors).length === 0) {
            let { boxVerifyStartCount: boxsCount, currentBoxCount, boxList } = getState()
            const isProgress = boxList[boxsCount]?.status ? (boxList[boxsCount]?.status === constants.fileStatus.inProgress) : undefined
            boxList = updateBoxOnEnter(true)

            if (isProgress || state.isRekey) {
              currentBoxCount++
            }

            setState({ boxList: boxList, currentBoxCount: currentBoxCount, navigationBoxStartCount: getState().navigationBoxStartCount + 1, isCancelButtonvisible: true })
            setTimeout(updateRefs, 3)
            handleSubmitData()
          }
        } else {
          // last enter keypress
          if (focusRequired) {
            onLastEnterBoxKeyPress(arrCount, e)
          }
        }
      }

      // #841 : Enable sound notification when user is moving to verification field from the data entry field
      let indexOfCurrentField = 9999
      formTemplate.forEach((fieldData, index) => {
        if (index > DATAENTRYSTARTINGKEY && element.name === fieldData.fieldKey && indexOfCurrentField === 9999) {
          indexOfCurrentField = index
        }

        if (indexOfCurrentField !== 9999 && formTemplate[indexOfCurrentField + 1]?.fieldKey === MAINTENANCE_CODE) {
          indexOfCurrentField++
        }
      })

      if (formTemplate[indexOfCurrentField + 1] !== undefined && indexOfCurrentField !== 9999 && !isVerify) {
        // eslint-disable-next-line
        const nextFieldKey = formTemplate[indexOfCurrentField + 1].fieldKey
      }
    }
    clearBusy()
    setState({ currentArrCount: arrCount, boxValidationErrors })
  }

  const handleCustomFormats = (keyCode, value, fields) => {
    const format = fields?.customFormat || fields?.format
    const isDate = Object.keys(dateValidatePattern).includes(format)
    if (isDate && value) {
      const dateValue = populateSlashOnDate(keyCode, value)
      if (dateValue) {
        return dateValue
      }
    } else if (appConstants.countrySpecificFormats.includes(format) && value) {
      const formattedValue = formatValue(keyCode, fields?.regExPattern, value)
      return formattedValue
    }

    return false
  }

  const handleKeyUp = (e, element) => {
    const value = handleCustomFormats(e.keyCode, e?.target?.value, element)
    if (value) {
      e.target.value = value
    }
  }

  const dataEntryEnterKeyPress = async (e, arrCount, isVerify, element, isMasked) => {
    // populate slash on date fields
    const value = handleCustomFormats(e.keyCode, e?.target?.value, element)
    if (value) {
      e.target.value = value
    }

    if (isMasked) {
      arrRefs[arrCount]?.current?.setFieldType('text')
    }

    // #870 : code to allow focus to a next field on click of ESC on the verification popup
    if (e.keyCode === 13 || (e.keyCode === 27 && getState().verificationPopupOn)) {
      if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        await handleDataEntry(e, arrCount, isVerify, true, element, isMasked)
      } else {
        await handleBoxDataEntry(e, arrCount, isVerify, true, element, isMasked)
      }
    }
  }

  // #925 : code to allow focus to a next field on click of SAVE button on the verification popup id DE user and verifier are same
  const handleVerifySameFocus = async (e, arrCount, isVerify, element, isMasked) => {
    // populate slash on date fields
    const value = handleCustomFormats(e.keyCode, e?.target?.value, element)
    if (value) {
      e.target.value = value
    }
    if (isMasked) {
      arrRefs[arrCount]?.current?.setFieldType('text')
    }
    // #925 : code to allow focus to a next field on click of SAVE button on the verification popup id DE user and verifier are same
    if (e.keyCode === 13) {
      if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        await handleDataEntry(e, arrCount, isVerify, true, element, isMasked)
      } else {
        await handleBoxDataEntry(e, arrCount, isVerify, true, element, isMasked)
      }
    }
  }

  const handleFocusForVerification = (arrCount) => {
    const verifyfieldIndexes = getState().verifyFieldIndex
    const fileStatus = 'status'
    const count = getState().fileVerifyStartCount
    const fileList = getState().fileList
    let { currentVerifyFileCount, currentFileCount, fileIndex, fileVerifyStartCount } = getState()
    let isCompleteVerifyForfile = true
    for (let i = 0; i <= verifyfieldIndexes.length; i++) {
      if (arrCount === (verifyfieldIndexes[i] + DATAENTRYSTARTINGKEY)) {
        if (i < verifyfieldIndexes.length - 1) {
          arrRefs[(verifyfieldIndexes[i + 1] + DATAENTRYSTARTINGKEY)].current.focus()
          isCompleteVerifyForfile = false
          break
        }
      }
    }
    if (isCompleteVerifyForfile) {
      fileList[count][fileStatus] = constants.fileStatus.verified
      saveFiles(fileVerifyStartCount)
      currentVerifyFileCount++
      currentFileCount++
      if (getState().fileVerifyStartCount + 1 < getState().fileList.length) {
        setState({ fileVerifyStartCount: getState().fileVerifyStartCount + 1, fileIndex: fileIndex + 1 })
        let verifiedcase = false
        getState().fileList.forEach((file, index) => {
          if (file[fileStatus] !== constants.fileStatus.verified) {
            verifiedcase = true
          }
        })
        if (verifiedcase) {
          if (getState()?.isVerifyBoxCompleteClick) {
            handleVerifySubmitData()
          }
          for (let i = 0; i < verifyfieldIndexes.length; i++) {
            arrRefs[verifyfieldIndexes[i] + DATAENTRYSTARTINGKEY].current.setValue('')
          }
          arrRefs[verifyfieldIndexes[0] + DATAENTRYSTARTINGKEY].current.focus()
        }
      } else {
        setState({ isVerifyTemplateFieldsEditable: false, enterDataDisabled: true, isExcetionBoxDisabled: true, isVerifyComplete: isCompleteVerifyForfile })
        setTimeout(() => {
          for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
            arrRefs[i].current.setValue('')
          }
        }, 3)
      }
      setState({ fileList: fileList, isCancelButtonvisible: false, currentVerifyFileCount: currentVerifyFileCount, currentFileCount: currentFileCount })
    }
  }

  const handleFocusBoxForVerification = (arrCount) => {
    const verifyfieldIndexes = getState().verifyFieldIndex
    const boxStatus = 'status'
    const count = getState().boxVerifyStartCount
    const boxList = getState().boxList
    let { currentVerifyBoxCount, currentBoxCount, boxIndex } = getState()
    let isCompleteVerifyForBox = true
    for (let i = 0; i <= verifyfieldIndexes.length; i++) {
      if (arrCount === (verifyfieldIndexes[i] + DATAENTRYSTARTINGKEY)) {
        if (i < verifyfieldIndexes.length - 1) {
          arrRefs[(verifyfieldIndexes[i + 1] + DATAENTRYSTARTINGKEY)].current.focus()
          isCompleteVerifyForBox = false
          break
        }
      }
    }
    if (isCompleteVerifyForBox) {
      boxList[count][boxStatus] = constants.fileStatus.verified
      currentVerifyBoxCount++
      currentBoxCount++
      if (getState().boxVerifyStartCount + 1 < getState().boxList.length) {
        setState({ boxVerifyStartCount: getState().boxVerifyStartCount + 1, boxIndex: boxIndex + 1 })
        for (let i = 0; i < verifyfieldIndexes.length; i++) {
          arrRefs[verifyfieldIndexes[i] + DATAENTRYSTARTINGKEY].current.setValue('')
        }
        arrRefs[verifyfieldIndexes[0] + DATAENTRYSTARTINGKEY].current.focus()
      } else {
        for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
          arrRefs[i].current.setValue('')
          setState({ isVerifyTemplateFieldsEditable: false, enterDataDisabled: true, isExcetionBoxDisabled: true, isVerifyComplete: isCompleteVerifyForBox })
        }
      }
      handleVerifySubmitData()
      setState({ boxList: boxList, isCancelButtonvisible: true, currentVerifyBoxCount: currentVerifyBoxCount, currentBoxCount: currentBoxCount })
    }
  }
  /*eslint-disable*/
  const dataEntryVerifyEnterKeyPress = async (e, arrCount, element, oldValue, arrRefs) => {
    // 925: Code to show popup on Click of Tab if the Entered value is incorrect
    if ((e.keyCode === 13 || e.keyCode === 9) || (e.keyCode === 27 && getState().verificationPopupOn)) {
      let fromDateValue
      let fromDateValueIndex
      let toDateValue
      let toDateValueIndex
      let errorStatus = false
      const { boxValidationErrors } = getState()
      const key = 'verify'

      for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'fromDate') {
          fromDateValue = arrRefs[i]?.current?.getValue()
          //925: fixed a bug where we are saving the dates if the fromDate is more than toDate 
          if (fromDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
            fromDateValue = getState().fileList[getState()?.fileVerifyStartCount].fromDate
          } else if (fromDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewBox' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceBox')) {
            fromDateValue = getState().boxList[getState()?.boxVerifyStartCount].fromDate
          }
          fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          fromDateValueIndex = i
        }

        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'toDate') {
          toDateValue = arrRefs[i]?.current?.getValue()
          //925: fixed a bug where we are saving the dates if the fromDate is more than toDate 
          if (toDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
            toDateValue = getState()?.fileList[getState()?.fileVerifyStartCount].toDate
          } else if (fromDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewBox' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceBox')) {
            toDateValue = getState()?.boxList[getState()?.boxVerifyStartCount].toDate
          }
          toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          toDateValueIndex = i
        }
      }

      if (fromDateValue && toDateValue) {
        if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
          arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          validationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'

          arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          validationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'

          errorStatus = true
        }
      }

      if (!errorStatus) {
        let getList
        const fieldValue = e.target.value
        if (fieldValue && Boolean(element?.specifyLength)) {
          const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
          arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
        }
        //925: Fixed a bug where we are not validating the Filetype templated cause the validation is happening only for the Box types
        if (state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' || state.jobDetails.standardTemplateName === 'skpStandardNewFile') {
          getList = getState()?.fileList
        } else {
          getList = getState()?.boxList
        }
        const [validate, noTranslate = false] = await getValidation(element, arrRefs[arrCount], getState().jobId, getList, arrRefs, getState().skpinstance, getState()?.regexFormat)
        if (validate !== undefined) {
          boxValidationErrors[element.name] = validate
          // #925: Code to save the validation errors in an object for Verification Flow
          const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
          if ((validate !== 'dataEntry.requiredErrorcode') && (validate !== 'dataEntry.fromDateToDateError')) {
            const myObj = { name: fieldNameNew, error: validate }
            if (!getState()?.validationErrorCase.some(item => item.name === fieldNameNew)) {
              getState()?.validationErrorCase.push(myObj)
            } else {
              if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
                const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
                setState({ validationErrorCase: updatedErrors })
              }
            }
          }
          if (noTranslate) {
            arrRefs[arrCount].current.setErrorMsg(validate, noTranslate)
          } else {
            arrRefs[arrCount].current.setErrorMsg(validate)
          }
        } else {
          // #925: Code to delete the validation errors in an object for Verification Flow
          const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
          const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
          setState({ validationErrorCase: updatedErrors })
          delete boxValidationErrors[element.name]
          const fieldValue = arrRefs[arrCount]?.current?.getValue()
          if (fieldValue && Boolean(element?.specifyLength)) {
            const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
            arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
          }

          if (arrRefs[arrCount]?.current?.getValue()?.toLowerCase() !== oldValue?.toLowerCase()) {
            openGeneralDialog({
              title: <VerificationDialogBox t={t} />,
              message: <ContentForDataVerification arrCount={arrCount} oldData={oldValue} newData={arrRefs[arrCount].current.getValue()} element={element} handleVerifyClick={handleVerifyClick} t={t} />,
              buttons: <></>,
              translateMessage: false,
              noTranslateTitle: true,
              closeX: true
            })
          } else {
            // #925: Code to check if the Verifer is on the last field or not 
            let updatedFields
            const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
            for (let i = 2; i < getState()?.templateFields.length; i++) {
              updatedFields = getState().templateFields.filter((item) => item.verify === true)
            }
            if (fieldNameNew === updatedFields[updatedFields?.length - 1]?.name) {
              setState({ validationCase: getState()?.validationErrorCase?.length !== 0 })
            } else {
              setState({ validationCase: false })
            }
            if ((e.keyCode === 13 || (e.keyCode === 27 && getState().verificationPopupOn)) && !getState()?.validationCase) {
              if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
                handleFocusForVerification(arrCount)
              } else {
                handleFocusBoxForVerification(arrCount)
              }
            }
          }
        }
      } else {
        const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
        const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
        setState({ validationErrorCase: updatedErrors })
      }
      // setting the "Verification Completed" Toast ,if the user completes verification for all the files.
      let verifiedcase = false
      getState().fileList.forEach((file, index) => {
        if (file[fileStatus] !== constants.fileStatus.verified) {
          verifiedcase = true
        }
      })
      if (!verifiedcase && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
        setState({ isVerifyComplete: true })
        refLocalToast.current?.successToastOn({
          message: t('toast.filesVerificationCompleteMsg'),
          autoHideDuration: 3000,
        })
        handleLastPage()
      }
    }
  }

  // #925: Code for the onBlur in the Verification Flow
  const dataValidationCheck = async (e, arrCount, element, oldValue, arrRefs) => {
    // Removed OnBlur for the last field for verification flow
    let verificationFields
    let lastCheck = false
    const verifyFieldName = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
    for (let i = 2; i < getState()?.templateFields.length; i++) {
      verificationFields = getState().templateFields.filter((item) => item.verify === true)
    }
    if (verifyFieldName === verificationFields[verificationFields?.length - 1]?.name) {
      lastCheck = true
    }
    if (!lastCheck) {
      let fromDateValue
      let fromDateValueIndex
      let toDateValue
      let toDateValueIndex
      let errorStatus = false
      const { boxValidationErrors } = getState()
      const key = 'verify'
      for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'fromDate') {
          fromDateValue = arrRefs[i]?.current?.getValue()
          if (fromDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
            fromDateValue = getState().fileList[getState()?.fileVerifyStartCount].fromDate
          } else if (fromDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewBox' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceBox')) {
            fromDateValue = getState().boxList[getState()?.boxVerifyStartCount].fromDate
          }
          fromDateValue = moment(fromDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          fromDateValueIndex = i
        }
        if (arrRefs[i]?.current?.getFormTemplate().fieldKey === 'toDate') {
          toDateValue = arrRefs[i]?.current?.getValue()
          if (toDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
            toDateValue = getState()?.fileList[getState()?.fileVerifyStartCount].toDate
          } else if (fromDateValue === undefined && (state.jobDetails.standardTemplateName === 'skpStandardNewBox' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceBox')) {
            toDateValue = getState()?.boxList[getState()?.boxVerifyStartCount].toDate
          }
          toDateValue = moment(toDateValue, arrRefs[i]?.current?.getFormTemplate().placeholder).format(defaultDateFormat)
          toDateValueIndex = i
        }
      }

      if (fromDateValue && toDateValue) {
        if (new Date(fromDateValue).getTime() > new Date(toDateValue).getTime()) {
          arrRefs[fromDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          validationErrors[arrRefs[fromDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'
          arrRefs[toDateValueIndex]?.current?.setErrorMsg('dataEntry.fromDateToDateError')
          validationErrors[arrRefs[toDateValueIndex]?.current?.getFormTemplate().name] = 'dataEntry.fromDateToDateError'
          errorStatus = true
        }
      }

      if (!errorStatus) {
        let getList
        const fieldValue = e.target.value
        if (fieldValue && Boolean(element?.specifyLength)) {
          const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
          arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
        }

        if (state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' || state.jobDetails.standardTemplateName === 'skpStandardNewFile') {
          getList = getState()?.fileList
        } else {
          getList = getState()?.boxList
        }
        const [validate, noTranslate = false] = await getValidation(element, arrRefs[arrCount], getState().jobId, getList, arrRefs, getState().skpinstance, getState()?.regexFormat)
        if (validate !== undefined) {
          boxValidationErrors[element.name] = validate
          const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
          if ((validate !== 'dataEntry.requiredErrorcode') && (validate !== 'dataEntry.fromDateToDateError')) {
            const myObj = { name: fieldNameNew, error: validate }
            if (!getState()?.validationErrorCase.some(item => item.name === fieldNameNew)) {
              getState()?.validationErrorCase.push(myObj)
            } else {
              if (getState()?.validationErrorCase.some(item => item.error !== validate)) {
                const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
                setState({ validationErrorCase: updatedErrors })
              }
            }
          }
          if (noTranslate) {
            arrRefs[arrCount].current.setErrorMsg(validate, noTranslate)
          } else {
            arrRefs[arrCount].current.setErrorMsg(validate)
          }
        } else {
          const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
          const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
          setState({ validationErrorCase: updatedErrors })
          delete boxValidationErrors[element.name]
          const fieldValue = arrRefs[arrCount]?.current?.getValue()
          if (fieldValue && Boolean(element?.specifyLength)) {
            const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
            arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
          }
          if (arrRefs[arrCount]?.current?.getValue()?.toLowerCase() !== oldValue?.toLowerCase()) {
            openGeneralDialog({
              title: <VerificationDialogBox t={t} />,
              message: <ContentForDataVerification arrCount={arrCount} oldData={oldValue} newData={arrRefs[arrCount].current.getValue()} element={element} handleVerifyClick={handleVerifyClick} t={t} />,
              buttons: <></>,
              translateMessage: false,
              noTranslateTitle: true,
              closeX: true
            })
          } else {
            let updatedFields
            const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
            for (let i = 2; i < getState()?.templateFields.length; i++) {
              updatedFields = getState().templateFields.filter((item) => item.verify === true)
            }
            if (fieldNameNew === updatedFields[updatedFields?.length - 1]?.name) {
              setState({ validationCase: getState()?.validationErrorCase?.length !== 0 })
            } else {
              setState({ validationCase: false })
            }
            if ((e.keyCode === 13 || (e.keyCode === 27 && getState().verificationPopupOn)) && !getState()?.validationCase) {
              if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
                handleFocusForVerification(arrCount)
              } else {
                handleFocusBoxForVerification(arrCount)
              }
            }
          }
        }
      } else {
        const fieldNameNew = arrRefs[arrCount]?.current?.getFormTemplate()?.fieldKey
        const updatedErrors = getState()?.validationErrorCase.filter(item => item.name !== fieldNameNew)
        setState({ validationErrorCase: updatedErrors })
      }
      // setting the "Verification Completed" Toast ,if the user completes verification for all the files.
      let verifiedcase = false
      getState().fileList.forEach((file, index) => {
        if (file[fileStatus] !== constants.fileStatus.verified) {
          verifiedcase = true
        }
      })
      if (!verifiedcase && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
        setState({ isVerifyComplete: true })
        refLocalToast.current?.successToastOn({
          message: t('toast.filesVerificationCompleteMsg'),
          autoHideDuration: 3000,
        })
        handleLastPage()
      }
    }
  }

  const handleVerifySaveDif = async (e, arrCount, element, correctValArrRef) => {
    const filesList = [...getState().fileList]
    filesList.splice(getState().fileVerifyStartCount, 1)

    const [validate, noTranslate = false] = await getValidation(element, correctValArrRef, getState().jobId, filesList, arrRefs, getState().skpinstance, getState()?.regexFormat)
    if (validate !== undefined) {
      validationErrors[element.name] = validate
      if (noTranslate) {
        arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
        correctValArrRef.current.setErrorMsg(validate, noTranslate)
      } else {
        arrRefs[arrCount].current.setErrorMsg(validate)
        correctValArrRef.current.setErrorMsg(validate)
      }
    } else {
      delete validationErrors[element.name]
      const fieldValue = getState().correctValueVerify
      let valueWithLeadingZeros = fieldValue

      if (fieldValue && Boolean(element?.specifyLength)) {
        valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
        arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
      }
      closeGeneralDialog()
      const fileList = getState().fileList
      const boxList = getState().boxList
      if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        fileList[getState().fileVerifyStartCount][element.name] = valueWithLeadingZeros
        setState({ fileList: fileList })
      } else {
        boxList[getState().boxVerifyStartCount][element.name] = valueWithLeadingZeros
        setState({ boxList: boxList })
      }
      arrRefs[arrCount].current.setValue(valueWithLeadingZeros)
      e.keyCode = 13
      dataEntryVerifyEnterKeyPress(e, arrCount, element, getState().correctValueVerify, arrRefs)
    }
  }

  const handleVerifyClick = async (e, arrCount, element, correctValArrRef) => {
    // #870 : verification popup handlind on the click of ESC button
    if (e.keyCode === 27 && getState().verificationPopupOn) {
      const filesList = [...getState().fileList]
      filesList.splice(getState().fileVerifyStartCount, 1)

      const [validate, noTranslate = false] = await getValidation(element, correctValArrRef, getState().jobId, filesList, arrRefs, getState().skpinstance, getState()?.regexFormat)
      if (validate !== undefined) {
        validationErrors[element.name] = validate
        if (noTranslate) {
          arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
          correctValArrRef.current.setErrorMsg(validate, noTranslate)
        } else {
          arrRefs[arrCount].current.setErrorMsg(validate)
          correctValArrRef.current.setErrorMsg(validate)
        }
      } else {
        delete validationErrors[element.name]
        const fieldValue = e.target.value
        let valueWithLeadingZeros = fieldValue

        if (fieldValue && Boolean(element?.specifyLength)) {
          valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
          arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
        }
        closeGeneralDialog()
        const fileList = getState().fileList
        const boxList = getState().boxList
        if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
          fileList[getState().fileVerifyStartCount][element.name] = valueWithLeadingZeros
          setState({ fileList: fileList })
        } else {
          boxList[getState().boxVerifyStartCount][element.name] = valueWithLeadingZeros
          setState({ boxList: boxList })
        }
        arrRefs[arrCount].current.setValue(valueWithLeadingZeros)
        dataEntryVerifyEnterKeyPress(e, arrCount, element, e.target.value, arrRefs)
      }
    }
  }

  const handleVerifySave = async (e, arrCount, element, correctValArrRef) => {
    const filesList = [...getState().fileList]
    filesList.splice(getState().fileVerifyStartCount, 1)
    const fieldValue = getState().correctValueVerify
    const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
    const [validate, noTranslate = false] = await getValidation(element, correctValArrRef, getState().jobId, filesList, arrRefs, getState().skpinstance, getState()?.regexFormat)
    if (validate !== undefined) {
      validationErrors[element.name] = validate
      if (noTranslate) {
        arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
        correctValArrRef.current.setErrorMsg(validate, noTranslate)
      } else {
        arrRefs[arrCount].current.setErrorMsg(validate)
        correctValArrRef.current.setErrorMsg(validate)
      }
    } else {
      // #841 : code to set correct value to data entry field after verification popup
      let indexOfDataEntryField = 9999
      for (const [elementIndex, elementData] of Object.entries(formTemplate)) {
        if (element.name === elementData.fieldKey && indexOfDataEntryField === 9999 && elementIndex >= DATAENTRYSTARTINGKEY) {
          indexOfDataEntryField = elementIndex
        }
      }
      delete validationErrors[element.name]
      arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
      arrRefs[indexOfDataEntryField]?.current?.setValue(valueWithLeadingZeros)
      e.keyCode = 13
      // #925 : code to allow focus to a next field on click of SAVE button on the verification popup id DE user and verifier are same
      handleVerifySameFocus(e, arrCount, true, element)
      closeGeneralDialog()
    }
  }

  const handleVerifyOnDataEntry = async (e, arrCount, element, correctValArrRef) => {
    // verification popup handlind on the click of ESC button
    if (e.keyCode === 27 && getState().verificationPopupOn) {
      const filesList = [...getState().fileList]
      filesList.splice(getState().fileVerifyStartCount, 1)
      const fieldValue = e.target.value
      const valueWithLeadingZeros = fieldValue.padStart(element?.specifyLength, '0')
      const [validate, noTranslate = false] = await getValidation(element, correctValArrRef, getState().jobId, filesList, arrRefs, getState().skpinstance, getState()?.regexFormat)
      if (validate !== undefined) {
        validationErrors[element.name] = validate
        if (noTranslate) {
          arrRefs[arrCount]?.current?.setErrorMsg(validate, noTranslate)
          correctValArrRef.current.setErrorMsg(validate, noTranslate)
        } else {
          arrRefs[arrCount].current.setErrorMsg(validate)
          correctValArrRef.current.setErrorMsg(validate)
        }
      } else {
        // #841 : code to set correct value to data entry field after verification popup
        let indexOfDataEntryField = 9999
        for (const [elementIndex, elementData] of Object.entries(formTemplate)) {
          if (element.name === elementData.fieldKey && indexOfDataEntryField === 9999 && elementIndex >= DATAENTRYSTARTINGKEY) {
            indexOfDataEntryField = elementIndex
          }
        }
        delete validationErrors[element.name]
        arrRefs[arrCount]?.current?.setValue(valueWithLeadingZeros)
        arrRefs[indexOfDataEntryField]?.current?.setValue(valueWithLeadingZeros)
        dataEntryEnterKeyPress(e, arrCount, true, element)
        closeGeneralDialog()
      }
    }
  }
  const onCancelDataEntry = async () => {
    const { currentFileCount, currentBoxCount, jobDetails, userType, fileList } = getState()
    if (userType === 'DATAENTRY_AND_VERIFY_USER' || userType === 'DATAENTRY_USER') {
      props.stop()
      const boxId = getBoxId()

      if (jobDetails.standardTemplateName === 'skpStandardNewFile' || jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        if (currentFileCount > 0) {
          if (recordKeystrokes) {
            turnOffKeystrokeRecorder(true, getBoxId(), fileList.length, 1)
          } else {
            saveMetricsData(true, getBoxId(), fileList.length, 1, false, getState().timerObj)
          }
        } else {
          if (keystrokes.length === 0) {
            saveMetricsData(true, getBoxId(), fileList.length, 1)
          } else {
            turnOffKeystrokeRecorder(true, getBoxId(), fileList.length, 1)
          }
        }
      } else {
        if (currentBoxCount > 0) {
          if (recordKeystrokes) {
            turnOffKeystrokeRecorder(false, getBoxId(), 0, currentBoxCount)
          } else {
            saveMetricsData(false, getBoxId(), 0, currentBoxCount, false, getState().timerObj)
          }
        } else {
          if (keystrokes.length === 0) {
            saveMetricsData(false, getBoxId(), 0, currentBoxCount)
          } else {
            turnOffKeystrokeRecorder(false, getBoxId(), 0, currentBoxCount)
          }
        }
        //920 saving the BoxId assuming data as empty onClick of save & close button
        const boxesListToUpdate = [...getState().boxList]
        boxesListToUpdate.forEach(async (box) => {
          const boxName = box.skpBoxId
          const boxStatus = box.status ? box.status : ''
          box.skpBoxId = boxName
          if (getState()?.jobDetails?.dataEntryType === 'Maintenance Box' && getState()?.jobDetails?.templateData?.templateFields !== undefined) {
            box.maintenanceCode = getState()?.jobDetails?.templateData?.templateFields?.maintenanceCode?.defaultValue
          }
          box.customerId = getState().jobDetails.accountLevel1.toUpperCase()
          delete box.status
          const boxData = {
            actionTs: new Date(),
            boxInfo: box,
          }
          await gdeTransactions.updateBox(getState().jobId, boxName, boxData)
          // adding status key back
          box.status = boxStatus
        })
      }
      gdeTransactions.updateBoxStatus(getState().jobId, boxId, constants.boxStatus.dataEntryInProcess, false, null, getState().currentFileCount)
    }
    closeGeneralDialog()
    // 647: saving the total files count value in the backend when user clicks on save and close
    getFiles(getState().templateTypeSelected)
    history.push(`${routePaths.myJobs}`)
  }

  const updateRefs = () => {
    const enteredData = {}
    const { templateFields } = getState()
    const arrCount = DATAENTRYSTARTINGKEY
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      for (let i = arrCount; i < arrRefs.length; i++) {
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const isDisabled = arrRefs[i]?.current?.getFormTemplate().disabled
        enteredData[key] = arrRefs[i]?.current?.getValue()

        if (!isDisabled || !getState().lockableFields[key]) {
          arrRefs[i]?.current?.clear()
          if (arrRefs[i]?.current?.getFormTemplate().defaultValue) {
            arrRefs[i]?.current?.setValue(arrRefs[i]?.current?.getFormTemplate().defaultValue)
          } else {
            arrRefs[i]?.current?.setValue('')
          }
        }
      }
    } else {
      for (let i = arrCount; i < arrRefs.length; i++) {
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const isDisabled = arrRefs[i]?.current?.getFormTemplate().disabled
        enteredData[key] = arrRefs[i]?.current?.getValue()
        let defaultValue = ''
        // checking default value with template field data

        templateFields.forEach((element) => {
          if (element.name === key) {
            defaultValue = element.defaultValue
          }
        })

        if (!isDisabled || !getState().lockableFields[key]) {
          arrRefs[i]?.current?.clear()
          if (defaultValue) {
            arrRefs[i]?.current?.setValue(defaultValue)
          } else {
            arrRefs[i]?.current?.setValue('')
          }
        }
      }
    }
  }

  const navigationUpdateRefs = () => {
    const { boxList, boxVerifyStartCount } = getState()
    const enteredData = {}
    const arrCount = DATAENTRYSTARTINGKEY
    for (let i = arrCount; i < arrRefs.length; i++) {
      const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
      const isDisabled = arrRefs[i]?.current?.getFormTemplate().disabled
      enteredData[key] = arrRefs[i]?.current?.getValue()

      if (!isDisabled || !getState().lockableFields[key]) {
        arrRefs[i]?.current?.clear()
        if (arrRefs[i]?.current?.getFormTemplate().defaultValue) {
          arrRefs[i]?.current?.setValue(arrRefs[i]?.current?.getFormTemplate().defaultValue)
        } else {
          arrRefs[i]?.current?.setValue('')
        }
      }
    }
  }

  // update existing files with new changes in every flow
  const updateFileOnEnter = (onLastEnter = false) => {
    const arrCount = DATAENTRYSTARTINGKEY
    const boxId = getBoxId()
    const enteredData = {}

    if (onLastEnter) {
      enteredData[fileStatus] = constants.fileStatus.keyed
      enteredData[SKP_BOX_ID] = boxId
      // enteredData[fileName] = filename
    }

    const fileObj = getState().fileList
    for (let i = arrCount; i < arrRefs.length; i++) {
      const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
      enteredData[key] = arrRefs[i]?.current?.getValue()
    }

    enteredData.isLastExisiting = true
    enteredData.customerId = getState().jobDetails.accountLevel1.toUpperCase()
    enteredData.fileId = fileObj[getState().fileVerifyStartCount].fileId
    if (fileObj !== undefined) {
      fileObj[getState().fileVerifyStartCount] = enteredData
    }

    return fileObj
  }

  const updateBoxOnEnter = (onLastEnter = false) => {
    const arrCount = DATAENTRYSTARTINGKEY
    const enteredData = {}
    const boxId = getState().boxId || getBoxId()
    // if (!state.isRekey) {
    //   boxId = arrRefs[SKPBOX].current.getValue()
    // }

    if (onLastEnter) {
      enteredData[fileStatus] = constants.fileStatus.keyed
      enteredData.skpBoxId = boxId
    }

    const boxObj = getState().boxList
    for (let i = arrCount; i < arrRefs.length; i++) {
      const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
      enteredData[key] = arrRefs[i]?.current?.getValue()
    }

    if (boxObj !== undefined) {
      boxObj[getState().boxVerifyStartCount] = enteredData
    }

    return boxObj
  }

  const onBackToQC = async () => {
    await gdeTransactions.updateBoxStatus(getState().jobId, getState().boxId, constants.boxStatus.qcInProcess, false, null, getState().fileList.length)
    const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(getState().jobId, getState().boxId)
    jobBoxMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, totalBoxCount, jobCategory } = data
      if (metricsFileId !== undefined && jobCategory === 'Data Entry User') {
        const metricsData = {
          totalRecordCount: getState().fileList.length,
          updatedTs: new Date(),
        }
        totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })
    history.push(`${routePaths.fileQualityCheck}/${jobId}/${boxId}`)
  }

  const onAddNewFile = async () => {
    let setUserType
    let setFileIndex
    let setIsVerification
    let verificationIndex
    let hideBoxComplete

    if (!getState().addNewFileDuringVerification) {
      setUserType = userTypes.DATAENTRY_USER
      setFileIndex = getState().fileList.length
      setIsVerification = false
      hideBoxComplete = true
      verificationIndex = getState().fileVerifyStartCount
    } else {
      setUserType = userTypes.VERIFICATION_USER
      setFileIndex = getState().startVerificationIndexAfterAddFile
      setIsVerification = true
      hideBoxComplete = false
      verificationIndex = 0

      const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(getState().jobId, getState().boxId)
      jobBoxMetricsData.forEach((doc) => {
        const data = doc.data()
        const { metricsFileId, totalBoxCount, jobCategory } = data
        if (metricsFileId !== undefined && jobCategory === 'Data Entry User') {
          const metricsData = {
            totalRecordCount: getState().fileList.length,
            updatedTs: new Date(),
          }
          totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
        }
      })
    }

    setState({ startVerificationIndexAfterAddFile: verificationIndex, addNewFileDuringVerification: !getState().addNewFileDuringVerification, userType: setUserType, fileIndex: setFileIndex, fileSequence: setFileIndex + 1, fileVerifyStartCount: setFileIndex, filesKeyed: setFileIndex, initialfileCount: setFileIndex, isVerification: setIsVerification, enterDataDisabled: false, hideBoxComplete: hideBoxComplete, hideViewAllFilesButton: hideBoxComplete })
  }



  // Enter Data button Click for Data Entry and Rekey flow
  const onEnterData = async (e) => {
    const arrCount = DATAENTRYSTARTINGKEY
    let focusKey = arrCount
    setPauseEnabled(false)
    setBusy()
    const job = getState().jobDetails
    const { lockableFields, lockableFieldsData } = getState()
    if (openTable) {
      const fromDisplayTable = true
      setOpenTable(false)
      setHideTable(false)
      onResume(fromDisplayTable)
    }

    setState({ displayeBtnDisable: false })

    getState().templateFields.forEach((element, index) => {
      // if (element.name === DEPT_ID) {
      //   isDeptLocked = !((element.isRequired === true && state.deptValue === ''))
      // }
      // if (element.name === DIV_ID) {
      //   isDivLocked = !((element.isRequired === true && state.divisionValue === ''))
      // }
      if (element.name in lockableFields && lockableFields[element.name]) {
        lockableFields[element.name] = !((element.isRequired === true && lockableFieldsData[element.name] === ''))
      }
    })


    setState({
      isSkpBoxIdEditable: false,
      isTemplateFieldsEditable: true,
      enterDataDisabled: true,
      isAllFieldsDisabled: false
    })

    dropFirstLetterSkpBox && setDropFirstLetterSkpBox(false)
    dropFirstLetterSkpBoxCnf && setDropFirstLetterSkpBoxCnf(false)

    if (getState().jobDetails.jobStatus !== constants.jobStatus.inProgress) {
      const autoTransmit = (getState().jobDetails.autoTransmit === undefined) ? 'true' : getState().jobDetails.autoTransmit
      job.jobStatus = constants.jobStatus.inProgress
      job.autoTransmitAndStatus = `${autoTransmit}-${constants.jobStatus.inProgress}`
      gdeTransactions.updateJob(getState().jobId, job)
    }
    await createBox(e)
    clearBusy()
    if (!recordKeystrokes) {
      props.resume()
      turnOnKeystrokeRecorder(getState().timerObj)
    }

    // focusing on enabled field

    setTimeout(() => {
      for (let i = arrCount; i < arrRefs.length; i++) {
        // #340 : code to move the focus on next data entry field by excluding uploaded fields
        const key = arrRefs[i]?.current?.getFormTemplate().fieldKey
        const key2 = key.replace('_verify', '')
        let isKeyAvailable = false
        if (key2 !== getState()?.uniqueFieldKeyToUploadData && getState()?.isUploadCustomerDataFile === true) {
          isKeyAvailable = getState()?.dataUploadFields.includes(key2)
        }

        if (!arrRefs[i].current.getFormTemplate().disabled && !lockableFields[arrRefs[i].current.getFormTemplate().fieldKey] && isKeyAvailable !== true) {
          focusKey = i
          break
        }
      }

      arrRefs[focusKey].current.focus()
      setState({ enterDataDisabled: true, jobcompleteDisabled: true, recordKeyStrokesStatus: false })
    }, 3)
  }

  // Enter Data button Click for verification flow
  const onEnterVerifiedData = async () => {
    setBusy()
    setState({
      isSkpBoxIdEditable: false,
      isVerifyTemplateFieldsEditable: true,
      isTemplateFieldsEditable: false
    })
    await gdeTransactions.updateBoxStatus(jobId, boxId, constants.boxStatus.verificationInProcess, false, null, getState().currentFileCount)
    clearBusy()
    setPauseEnabled(false)
    arrRefs[getState().verifyFieldIndex[0] + DATAENTRYSTARTINGKEY].current.focus()
    if (!recordKeystrokes) {
      props.resume()
      turnOnKeystrokeRecorder(getState().timerObj)
    }
    setState({ enterDataDisabled: true, jobcompleteDisabled: true, recordKeyStrokesStatus: false })
  }

  const handleUpdate = async (props) => {
    setBusy()

    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      saveFiles()
    } else {
      saveBoxes()
    }

    const exceptionCode = props.arrRefs[EXCEPTION_CODE].current.getValue()
    const description = props.arrRefs[DESCRIPTION].current.getValue()
    const boxID = arrRefs[SKPBOX_CONFIRM]?.current?.getValue() || state.boxId
    let dataEntryUser
    let verificationUser
    if (getState().userType === userTypes.DATAENTRY_USER) {
      dataEntryUser = logedInUser
      verificationUser = getState()?.jobUserData?.verifyUser || logedInUser
    } else if (getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
      dataEntryUser = logedInUser
      verificationUser = logedInUser
    }
    const date = new Date()

    let isRequireQC = false
    if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined' && additionalPermissionsForUser[indexOfrequireQualityCheck]?.enabled && getState().isVerifyRequired) {
      isRequireQC = true
    }

    const boxData = {
      exceptionCode: exceptionCode,
      description: description,
      jobId: getState().jobId,
      districtId: getState().jobDetails.districtId,
      accountLevel1: getState().jobDetails.accountLevel1.toUpperCase(),
      boxId: boxID,
      status: constants.boxStatus.exception,
      dataEntryUser: dataEntryUser || '',
      verificationUser: verificationUser || '',
      actionTs: date,
      createdTs: date,
      requireQC: isRequireQC
    }
    const { boxesForJob, jobDetails } = getState()
    let exceptionCount = 0
    let isAlreadyExceptionBox = false

    // get existing exception boxes and get the count
    boxesForJob?.forEach(boxData => {
      const { boxId: id, status: boxStatus } = boxData.data()
      if (boxStatus === constants.boxStatus.exception) {
        if (id === boxID) {
          isAlreadyExceptionBox = true
        }
        exceptionCount = exceptionCount + 1
      }
    })

    // Adding gdeMetrics entry for an exception box
    const isException = true
    const fileCount = getState().fileList.length - getState().initialfileCount
    const boxCount = getState().boxList.length - getState().initialboxCount

    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (recordKeystrokes) {
        turnOffKeystrokeRecorder(false, getBoxId(), fileCount, currentBoxCount, isException)
      } else {
        saveMetricsData(false, getBoxId(), fileCount, currentBoxCount, isException, getState().timerObj)
      }
    } else {
      if (recordKeystrokes) {
        turnOffKeystrokeRecorder(false, getBoxId(), 0, boxCount, isException)
      } else {
        saveMetricsData(false, getBoxId(), 0, boxCount, isException, getState().timerObj)
      }
    }

    // increase count for the current box if not already an exception box
    if (!isAlreadyExceptionBox) {
      exceptionCount = exceptionCount + 1
    }
    jobDetails.exceptionBoxCount = exceptionCount

    try {
      await gdeTransactions.updateBoxDetails(getState().jobId, boxID, boxData)
      await gdeTransactions.updateJob(getState().jobId, jobDetails)
      successToast({ message: t('toast.exceptionSucess', { boxID }), title: t('toast.success') })
    } catch (e) {
      errorToast({ message: e?.message, title: t('toast.failedToUpdate') })
    }
    await statusUpdateForJob()

    closeGeneralDialog()
    clearBusy()
    // go back to the previous page after exception box submitted
    getState().jobId && history.push(`${routePaths.boxList}/${getState().jobId}`)
  }

  const openExceptionBoxDialog = () => {
    openGeneralDialog({
      title: t('dataEntry.exceptionBoxLowerCase'),
      message: <ContentForExceptionBox arrRefs={arrRefs} handleUpdate={handleUpdate} t={t} />,
      translateMessage: false,
      noTranslateTitle: true,
      buttons: (
        <ButtonsForExceptionBox
          arrRefs={arrRefs}
          handleCancel={handleCancelExceptionBox}
          handleUpdate={handleUpdate}
          t={t}
        />
      ),
      onCancel: () => { handleCancelExceptionBox() },
      closeX: true
    })
    return Promise.resolve()
  }

  // removed the commented out functions isObjectValuesEmpty, saveIncompleteFiles & saveIncompleteBoxes

  const onResume = async (fromDisplayTable) => {
    if (!(fromDisplayTable === true)) {
      getState()?.pauseStartTime && savePauseMetricsData()
    }
    props.resume()
    setPauseShortKeyActive(false)
    if (!recordKeystrokes) {
      turnOnKeystrokeRecorder(getState().timerObj)
    }

    // focusing on next empty field
    const arrCount = DATAENTRYSTARTINGKEY
    let focusKey = DATAENTRYSTARTINGKEY
    const { currentArrCount } = getState()

    for (let i = arrCount; i < arrRefs.length; i++) {
      const key = arrRefs[i].current?.getFormTemplate().fieldKey
      if (arrRefs[i]?.current?.getValue() === '' && getState().lockableFields[key] !== true) {
        if (i >= currentArrCount) {
          focusKey = i
          break
        } else {
          focusKey = currentArrCount
        }
      } else {
        focusKey = currentArrCount
      }
    }

    arrRefs[focusKey].current.focus()
  }

  const savePauseMetricsData = async () => {
    const date = moment(new Date()).format('MMDDYYYY')
    const pauseMetricsId = date + '-' + logedInUser
    const pauseMetricsId2 = date + '-' + logedInUser + '-' + Date.now()

    let pauseResumeObject = {}
    pauseResumeObject.userType = getState().userType
    pauseResumeObject.jobId = getState().jobId
    pauseResumeObject.boxId = arrRefs[SKPBOX]?.current?.getValue() || getState().boxId
    pauseResumeObject.workerId = logedInUser
    pauseResumeObject.createdTime = new Date()
    pauseResumeObject.createdDate = today()
    pauseResumeObject.activityType = constants.pauseMetrics
    pauseResumeObject.pauseStartTime = getState()?.pauseStartTime
    pauseResumeObject.pauseEndTime = new Date()
    pauseResumeObject.mainCollectionId = pauseMetricsId
    pauseResumeObject.districtId = getState().jobDetails.districtId
    pauseResumeObject.totalPauseTime = roundNumber((new Date().getTime() - getState()?.pauseStartTime?.getTime()) / 1000)
    await gdeTransactions.savePauseMetrics(pauseResumeObject, pauseMetricsId2)

    let summary = await gdeTransactions.getPauseMetricsSummary(pauseMetricsId)
    if (!summary || summary === undefined) {
      await initiatePauseMetricsSummary()
      summary = await gdeTransactions.getPauseMetricsSummary(pauseMetricsId)
    }

    if (summary) {
      let pauseCounterObject = {}
      pauseCounterObject.lastUpdatedTime = new Date()
      pauseCounterObject.totalPauseClicks = ++summary.totalPauseClicks
      pauseCounterObject.totalPauseTime = roundNumber(summary.totalPauseTime + pauseResumeObject.totalPauseTime)
      pauseCounterObject.averagePauseTime = roundNumber((summary.totalPauseTime + pauseResumeObject.totalPauseTime) / summary.totalPauseClicks)
      await gdeTransactions.updatePauseMetricsSummary(pauseCounterObject, pauseMetricsId)
    }

    setState({ pauseStartTime: false })
  }

  const initiatePauseMetricsSummary = async () => {
    const date = moment(new Date()).format('MMDDYYYY')
    const pauseMetricsId = date + '-' + logedInUser
    const summary = await gdeTransactions.getPauseMetricsSummary(pauseMetricsId)
    if (!summary || summary === undefined) {
      let pauseCounterObject = {}
      pauseCounterObject.workerId = logedInUser
      pauseCounterObject.createdTime = new Date()
      pauseCounterObject.createdDate = today()
      pauseCounterObject.activityType = constants.pauseCount
      pauseCounterObject.mainCollectionId = pauseMetricsId
      pauseCounterObject.totalPauseClicks = 0
      pauseCounterObject.totalPauseTime = 0
      pauseCounterObject.averagePauseTime = 0
      await gdeTransactions.savePauseMetricsSummary(pauseCounterObject, pauseMetricsId)
    }
  }

  const onVerifyResume = () => {
    getState()?.pauseStartTime && savePauseMetricsData()
    const { verifyFieldIndex } = getState()
    let focusKey = DATAENTRYSTARTINGKEY + verifyFieldIndex[0]
    props.resume()
    setPauseShortKeyActive(false)
    if (!recordKeystrokes) {
      turnOnKeystrokeRecorder(getState().timerObj)
    }

    // focusing on next empty field
    for (let i = 0; i < verifyFieldIndex.length; i++) {
      const index = verifyFieldIndex[i] + DATAENTRYSTARTINGKEY
      const key = arrRefs[index].current?.getFormTemplate().fieldKey
      if (arrRefs[index]?.current?.getValue() === '' && key !== DEPT_ID && key !== DIV_ID) {
        focusKey = i + DATAENTRYSTARTINGKEY
        break
      } else {
        focusKey = DATAENTRYSTARTINGKEY + verifyFieldIndex.length - 1
      }
    }

    arrRefs[focusKey].current.focus()
    closeGeneralDialog()
  }

  const ButtonsForTransmitDialogBox = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleTotalBoxes} autoFocus>buttons.yes</ContainedButton>
    </>


  const ButtonForIncompleteBoxesmsg = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleIncomplete} autoFocus>buttons.yes</ContainedButton>

    </>

  // const manualTransmitJob = async() => {
  //   const JobState = getState().jobId

  //   const data = {
  //     jobStatus: constants.jobStatus.readyToTransmit,
  //     autoTransmitAndStatus: `${getState().jobDetails.autoTransmit}-${constants.jobStatus.readyToTransmit}`,
  //   }
  //   await gdeTransactions.updateJob(JobState, data)

  //   const callabletransmit = httpsCallable(functions, 'grpGde-ManuallyExportSkpApprovedAssets')
  //   callabletransmit({ jobId: JobState }).then((result) => {
  //     successToast({ message: translate('toast.transmitQueued', { jobId: JobState }) })
  //   }).catch(error => {
  //     errorToast({ message: error = translate('toast.manualTransmitFailMessage'), title: translate('toast.manualTransmitFailTitle') })
  //     clearBusy()
  //   })

  //   closeGeneralDialog()
  //   history.push(`${routePaths.myJobs}`)
  // }


  // const handleTransmit = () => {
  //   getState().jobDetails.totalBoxes = getState().boxesKeyed
  //   openGeneralDialog({
  //     title: 'messages.transmit',
  //     message: 'messages.transmitConfirmMessage',
  //     translateMessage: true,
  //     buttons: <ButtonsForTransmitDialogBox />,
  //     closeX: true
  //   })
  // }

  const handlePause = (fromDisplayTable) => {
    props.stop()
    const boxId = getBoxId()
    if (!(fromDisplayTable === true)) {
      setState({ pauseStartTime: new Date() })
      initiatePauseMetricsSummary()
    }
    setPauseShortKeyActive(true)
    // saving incomplete files to firestore
    const { currentFileCount, currentBoxCount } = getState()

    // recording keystroke on pause
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      // code is blocked to restrict insertion of phantom file on pause-resume button
      // saveIncompleteFiles()
      if (currentFileCount > 0) {
        if (recordKeystrokes) {
          turnOffKeystrokeRecorder(false, getBoxId(), currentFileCount)
        } else {
          saveMetricsData(false, getBoxId(), currentFileCount, 0, false, getState().timerObj)
        }
      } else {
        if (keystrokes.length === 0) {
          saveMetricsData(false, getBoxId(), currentFileCount)
        } else {
          turnOffKeystrokeRecorder(false, getBoxId(), currentFileCount)
        }
      }
    } else {
      // code is blocked to restrict insertion of phantom file on pause-resume button
      // saveIncompleteBoxes()
      if (currentBoxCount > 0) {
        if (recordKeystrokes) {
          turnOffKeystrokeRecorder(false, getBoxId(), 0, currentBoxCount)
        } else {
          saveMetricsData(false, getBoxId(), 0, currentBoxCount, false, getState().timerObj)
        }
      } else {
        if (keystrokes.length === 0) {
          saveMetricsData(false, getBoxId(), 0, currentBoxCount)
        } else {
          turnOffKeystrokeRecorder(false, getBoxId(), 0, currentBoxCount)
        }
      }
    }
    gdeTransactions.updateBoxStatus(getState().jobId, boxId, constants.boxStatus.dataEntryInProcess, false, null, getState().currentFileCount)
    setState({ currentFileCount: 0, currentBoxCount: 0 })
    if (!(fromDisplayTable === true)) {
      openGeneralDialog({
        title: t('dataEntry.dataEntryPauseTitle'),
        message: <Label>dataEntry.pauseMessage</Label>,
        translateMessage: false,
        noTranslateTitle: true,
        buttons: (
          <ButtonsForPause onResume={() => {
            closeGeneralDialog()
            setTimeout(onResume, 1)
          }} />
        ),
        buttonsPlacement: 'center'
      })
    }
    return Promise.resolve()
  }

  const handleVerifyPause = () => {
    props.stop()
    const boxId = getBoxId()
    setState({ pauseStartTime: new Date() })
    initiatePauseMetricsSummary()
    setPauseShortKeyActive(true)
    // saving incomplete files to firestore
    const { fileList, fileVerifyStartCount, currentFileCount, verifyFieldIndex, isVerifyComplete, boxList, boxVerifyStartCount, currentBoxCount, } = getState()

    const arrCount = 0

    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      for (let i = arrCount; i < verifyFieldIndex.length; i++) {
        const index = verifyFieldIndex[i]
        const key = arrRefs[index].current?.getFormTemplate().fieldKey
        if (key !== undefined) {
          fileList[fileVerifyStartCount][key] = arrRefs[index]?.current?.getValue()
        }
      }

      if (!isVerifyComplete) {
        fileList[fileVerifyStartCount].status = constants.fileStatus.inProgress
      }

      // saveFiles(fileVerifyStartCount, fileList[fileVerifyStartCount])
      // recording keystroke on pause
      if (currentFileCount > 0) {
        if (recordKeystrokes) {
          turnOffKeystrokeRecorder(false, getBoxId(), currentFileCount)
        } else {
          saveMetricsData(false, getBoxId(), currentFileCount, 0, false, getState().timerObj)
        }
      } else {
        if (keystrokes.length === 0) {
          saveMetricsData(false, getBoxId(), currentFileCount)
        } else {
          turnOffKeystrokeRecorder(false, getBoxId(), currentFileCount)
        }
      }
    } else {
      for (let i = arrCount; i < verifyFieldIndex.length; i++) {
        const index = verifyFieldIndex[i]
        const key = arrRefs[index].current?.getFormTemplate().fieldKey
        if (key !== undefined) {
          boxList[boxVerifyStartCount][key] = arrRefs[index]?.current?.getValue()
        }
      }

      if (!isVerifyComplete) {
        boxList[boxVerifyStartCount].status = constants.fileStatus.inProgress
      }

      saveBoxes()
      // recording keystroke on pause
      if (currentBoxCount > 0) {
        if (recordKeystrokes) {
          turnOffKeystrokeRecorder(false, getBoxId(), 0, currentBoxCount)
        } else {
          saveMetricsData(false, getBoxId(), 0, currentBoxCount, false, getState().timerObj)
        }
      } else {
        if (keystrokes.length === 0) {
          saveMetricsData(false, getBoxId(), 0, currentBoxCount)
        } else {
          turnOffKeystrokeRecorder(false, getBoxId(), 0, currentBoxCount)
        }
      }
    }

    gdeTransactions.updateBoxStatus(getState().jobId, boxId, constants.boxStatus.verificationInProcess, false, null, getState().currentFileCount)
    setState({ currentFileCount: 0, currentBoxCount: 0 })
    openGeneralDialog({
      title: t('dataEntry.dataEntryPauseTitle'),
      message: <Label>dataEntry.pauseMessage</Label>,
      buttons: (
        <ButtonsForPause onResume={() => {
          closeGeneralDialog()
          setTimeout(onVerifyResume, 1)
        }} />
      ),
      buttonsPlacement: 'center'
    })
    return Promise.resolve()
  }

  const handleSubmitDataPop = async () => {
    if (!recordKeystrokes) {
      props.resume()
      turnOnKeystrokeRecorder(getState().timerObj)
    }
    let casepoint = 0
    const { userType } = getState()
    const { enterDataDisabled } = getState()
    if (enterDataDisabled === true) {
      if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.DATAENTRY_USER) {
        for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
          const value = arrRefs[i]?.current?.getValue()
          const key = arrRefs[i].current?.getFormTemplate().fieldKey
          if (value === '' && getState().lockableFields[key] === false) {
            casepoint = casepoint + 0
          } else if (getState().lockableFields[key] === false) {
            casepoint = casepoint + 1
          }
        }
        if (casepoint === 0) {
          // props.stop()
          // turnOffKeystrokeRecorder()
          setState({ enterDataDisabled: false })
          handleSubmitData()
        } else {
          openGeneralDialog({
            title: t('dataEntry.popup'),
            message: <Label>dataEntry.confirmationMsg</Label>,
            translateMessage: false,
            noTranslateTitle: true,
            buttons: (<ButtonsForBoxCompleteAlert arrRefs={arrRefs} cancelFileSaveBc={() => cancelFileSaveBc(true)} onSaveFileBc={() => onSaveFileBc()} />
            ),
            closeX: true
          })
        }
      } else {
        handleSubmitData()
      }
    } else {
      // props.stop()
      // turnOffKeystrokeRecorder()
      handleSubmitData()
    }
  }

  const handleSubmitData = async () => {
    setBusy()
    if (online) {
      setBoxcomplete(false)
      // showStatus && successToast({ message: translate('toast.onlineMsg') })
      const boxesRaw = await gdeTransactions.getBoxesForJob(jobId)

      const boxes = Object.values(boxesRaw.docs).sort(function (a, b) {
        const boxSrNoA = a.data().boxSrNo || a.data().boxId
        const boxSrNoB = b.data().boxSrNo || b.data().boxId
        return boxSrNoA > boxSrNoB ? 1 : -1
      }).slice(0)

      const { boxVerifyStartCount, boxList: list } = getState()
      const boxId = getBoxId()
      if (state.isRekey) {
        onNoMoreBoxToComplete(false)
      } else {
        if (getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
          onHaveMoreBoxToComplete()
          clearBusy()
        } else if (state.jobDetails.totalBoxes > boxesRaw.size) {
          clearBusy()
          if (!getState().boxIds.includes(boxId) || getState().jobDetails.dataEntryType === 'New File' || getState().jobDetails.dataEntryType === 'Maintenance File') {
            //removed the additional popuponClick of BoxComplete button
            onHaveMoreBoxToComplete()
          } else {
            saveBoxes()
            if (boxVerifyStartCount < list.length - 1) {
              arrRefs[DATAENTRYSTARTINGKEY].current.focus()
              setState({ boxVerifyStartCount: boxVerifyStartCount + 1 })
              setSkpBoxId()
            } else {
              setState({ isSkpBoxIdEditable: true, boxId: undefined })
              arrRefs[SKPBOX].current.focus()
            }
          }
        } else {
          clearBusy()
          onHaveMoreBoxToComplete()
        }
      }
      const boxList = []
      const boxUserList = []
      let counter = 0
      // if (getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
      //   currentBoxData = await gdeTransactions.getBox(jobId, getState().boxId)
      // }

      boxes.forEach((doc) => {
        const data = doc.data()
        let boxInfo
        if (getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
          boxInfo = doc?.data()?.boxInfo !== undefined ? doc?.data()?.boxInfo : state.boxList[counter]
          //if boxInfo for last keyded box is undefined then assign boxInfo from lastKeyedBoxData state element
          if (doc.data().boxInfo === undefined && getState()?.boxId === data.boxId && getState()?.lastKeyedBoxData !== false) {
            boxInfo = getState().lastKeyedBoxData !== undefined ? getState().lastKeyedBoxData : getState().boxList[counter]
          }
        }

        boxList[counter] = {
          boxId: data.boxId,
          entryUser: data.dataEntryUser,
          status: data.status,
          dataEntryUser: data.dataEntryUser,
          verificationUser: data.verificationUser,
          tempIndex: counter
        }

        if (getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
          boxInfo !== undefined && Object.keys(boxInfo).forEach(key => {
            boxList[counter][key] = boxInfo[key]
          })
        }

        counter++
        boxUserList.push(doc.data().dataEntryUser)
      })
      await statusUpdateForJob()
      // const checkReadyToTransmit = (Boxes) => {
      //   return Boxes.status === constants.boxStatus.approved
      // }
      // const result = boxList.filter(checkReadyToTransmit)
      // const transmitBoxEqual = boxList.length === 0 ? false : rows[i]?.boxes === result.length
      clearBusy()
      setState({
        isAllFieldsDisabled: true,
        boxList: boxList,
        lastKeyedBoxData: false
      })
      return Promise.resolve()
    } else {
      errorToast({ message: t('toast.offlineMsg'), title: t('toast.userOffline'), autoHideDuration: 3000 })
      setBoxcomplete(true)
      isStatusShown(true)
    }
  }

  const handleVerifySubmitData = async () => {
    let isVerificationPending = ''
    let unVerifiedFiles = []
    const unVerifiedFilesId = []
    let fileVerifyStartCount = 0
    const fileCount = getState().fileVerifyStartCount + 1
    getState().fileList.forEach((file, index) => {
      if (file[fileStatus] !== constants.fileStatus.verified) {
        // isVerificationPending = `${isVerificationPending} ${index + 1},`
        unVerifiedFiles.push(index + 1)
        unVerifiedFilesId.push(index + 1)
      }
    })

    let prevFileId = false
    let foundInSequence = false
    unVerifiedFilesId.forEach((fileId, fileIndex) => {
      if (fileIndex === 0) {
        prevFileId = fileId
        isVerificationPending = `${isVerificationPending} ${fileId}`
      } else if (prevFileId + 1 === fileId) {
        prevFileId = fileId
        foundInSequence = true
      } else if (fileId - prevFileId > 1) {
        if (foundInSequence) {
          foundInSequence = false
          isVerificationPending = `${isVerificationPending} - ${prevFileId}`
        }
        isVerificationPending = `${isVerificationPending}, ${fileId}`
        prevFileId = fileId
      }

      if (foundInSequence && fileIndex + 1 === unVerifiedFilesId.length) {
        foundInSequence = false
        isVerificationPending = `${isVerificationPending} - ${prevFileId}`
      }

      isVerificationPending = `${isVerificationPending}`
    })

    if (isVerificationPending) {
      setState({ enterDataDisabled: false })
      const firstUnverifiedFile = unVerifiedFiles[0]
      warningToast({
        message: t('toast.filesVerificationPendingMsg2', { verificatioPendingFiles: isVerificationPending, firstUnverifiedFile: firstUnverifiedFile }),
        noTranslateMessage: true,
        autoHideDuration: 5000,
        closeIcon: true,
        isBlocking: false
      })

      // Navigating the user to the first unVerified file on click of Boxcomplete button
      if (firstUnverifiedFile <= getState().fileList.length && fileCount !== firstUnverifiedFile) {
        fileVerifyStartCount = firstUnverifiedFile
        setState({ isVerifyBoxCompleteClick: true, fileVerifyStartCount: fileVerifyStartCount - 1 })
      }
    } else {
      const { userType, currentFileCount, currentBoxCount, fileList } = getState()
      props.stop()
      const fileCount = currentFileCount
      const boxCount = currentBoxCount

      if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        if (recordKeystrokes) {
          if (keystrokes.length > 0) {
            turnOffKeystrokeRecorder(true, getBoxId(), fileList.length, 1)
          } else {
            saveMetricsData(true, getBoxId(), fileList.length, 1)
          }
        } else {
          saveMetricsData(true, getBoxId(), fileList.length, 1, false, getState().timerObj)
        }
      } else {
        if (recordKeystrokes) {
          if (keystrokes.length > 0) {
            turnOffKeystrokeRecorder(false, getBoxId(), 0, boxCount)
          } else {
            saveMetricsData(false, getBoxId(), 0, boxCount)
          }
        } else {
          saveMetricsData(false, getBoxId(), 0, boxCount, false, getState().timerObj)
        }
      }

      if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
        saveViewAllFiles()
      } else {
        saveBoxes(false)
      }

      const jobId = getState().jobId
      const boxId = getState().boxId
      let status = await getJobStatusToBeupdated(jobId, userType, getState().isVerifyRequired, user)
      if (getState()?.boxData?.requireQC) {
        status = constants.boxStatus.readyForQc
      }
      gdeTransactions.updateBoxStatus(jobId, boxId, status, false, null, getState().currentFileCount)
        .then(() => {
          refLocalToast.current?.successToastOn({
            message: t('toast.boxSubmitted'),
            title: t('toast.jobManagement'),
          })
          setTimeout(() => {
            history.push(`${routePaths.boxList}/${jobId}`)
          }, 1)
          statusUpdateForJob()
        })
    }
  }

  const getBoxId = () => {
    let boxId = getState().boxId
    if (boxId === undefined) {
      boxId = arrRefs[SKPBOX]?.current?.getValue()
    }
    return boxId
  }

  const saveFiles = async (fileCount = -1, enteredData = {}, updateFiles = false, fileSequence = 1) => {
    if (!isNaN(fileSequence)) {
      const boxId = getBoxId() || arrRefs[SKPBOX]?.current?.getValue()
      // define users
      let dataentryUser
      let verificationUser
      if (getState().userType === userTypes.DATAENTRY_USER) {
        dataentryUser = logedInUser
        verificationUser = getState().isVerifyRequired ? getState()?.jobUserData?.verifyUser || (isAddNewFileByQc && logedInUser) : ''
      } else if (getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
        dataentryUser = logedInUser
        verificationUser = logedInUser
      } else if (getState().userType === userTypes.VERIFICATION_USER) {
        dataentryUser = getState().dataEntryUser
        verificationUser = logedInUser
      }

      if (getState().addNewFileDuringVerification) {
        dataentryUser = logedInUser
        verificationUser = logedInUser
      }

      const deletedFielList = getState().deletedFileIndex
      const filesListToUpdate = [...getState().fileList]
      filesListToUpdate.filter(file => !deletedFielList.includes(file.id))

      if (state.isRekey || state.isVerification) {
        enteredData = filesListToUpdate[fileCount]
        enteredData.skpBoxId = boxId
        enteredData.customerId = getState().jobDetails.accountLevel1.toUpperCase()
        const status = enteredData?.status ? enteredData.status : state.isRekey ? constants.fileStatus.keyed : constants.fileStatus.verified
        // const fileNumber = `file-${fileCount + 1}`
        delete enteredData.status
        delete enteredData.isLastExisiting
        enteredData.status = status
        if (updateFiles || state.isVerification) {
          const fileNumber = state.isVerification ? enteredData.fileId : fileSequence
          const fileData = {
            actionTs: new Date(),
            fileInfo: enteredData,
            status: status
          }
          gdeTransactions.updateFile(getState().jobId, boxId, fileNumber, fileData)
        } else {
          delete enteredData.isLastExisiting
          const fileNO = `${fileSequence}`
          const fileNumber = fileNO.padStart(5, '0')
          const fileData = {
            actionTs: new Date(),
            dataEntryUser: dataentryUser,
            fileInfo: enteredData,
            fileNumber: fileNumber,
            jobId: getState().jobId,
            verificationUser: verificationUser,
            status: status
          }
          gdeTransactions.createFileInfo(fileData, getState().jobId, boxId, fileNumber)
        }
      } else {
        // saving files for start-newbox flow
        enteredData.skpBoxId = boxId
        enteredData.customerId = getState().jobDetails.accountLevel1.toUpperCase()
        const status = enteredData.status || constants.fileStatus.keyed
        delete enteredData.status
        delete enteredData.isLastExisiting
        let fileNumber
        if (updateFiles) {
          fileNumber = fileSequence
        } else {
          const fileNo = `${fileSequence}`
          fileNumber = fileNo.padStart(5, '0')
        }

        const fileData = {
          actionTs: new Date(),
          dataEntryUser: dataentryUser,
          fileInfo: enteredData,
          fileNumber: fileNumber,
          jobId: getState().jobId,
          verificationUser: verificationUser,
          status: status
        }

        if (fileCount + 1 !== 0) {
          if (updateFiles) {
            gdeTransactions.updateFile(getState().jobId, boxId, fileNumber, fileData)
          } else {
            gdeTransactions.createFileInfo(fileData, getState().jobId, boxId, fileNumber)
          }
        }
        enteredData.status = status
      }
    }
    //setting the InfoToast on completion of every unVerified file, only if the status of box is in "Verification in process" state.
    if ((getState()?.boxData?.status === constants.boxStatus.verificationInProcess) && (getState()?.addNewFileDuringVerification === false) && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
      let isVerificationPending = ''
      const NewFileVerifycount = []
      const unVerifiedFilesId = []
      getState().fileList.forEach((file, index) => {
        if (file[fileStatus] !== constants.fileStatus.verified) {
          unVerifiedFilesId.push(index + 1)
          NewFileVerifycount.push(index + 1)
        }
      })

      let prevFileId = false
      let foundInSequence = false
      unVerifiedFilesId.forEach((fileId, fileIndex) => {
        if (fileIndex === 0) {
          prevFileId = fileId
          isVerificationPending = `${isVerificationPending} ${fileId}`
        } else if (prevFileId + 1 === fileId) {
          prevFileId = fileId
          foundInSequence = true
        } else if (fileId - prevFileId > 1) {
          if (foundInSequence) {
            foundInSequence = false
            isVerificationPending = `${isVerificationPending} - ${prevFileId}`
          }
          isVerificationPending = `${isVerificationPending}, ${fileId}`
          prevFileId = fileId
        }

        if (foundInSequence && fileIndex + 1 === unVerifiedFilesId.length) {
          foundInSequence = false
          isVerificationPending = `${isVerificationPending} - ${prevFileId}`
        }

        isVerificationPending = `${isVerificationPending}`
      })

      const firstUnverifiedFile = NewFileVerifycount[0]
      let verifiedcase = false
      getState().fileList.forEach((file, index) => {
        if (file[fileStatus] !== constants.fileStatus.verified) {
          verifiedcase = true
        }
      })
      if (verifiedcase && (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')) {
        warningToast({
          message: t('toast.filesVerificationPendingMsg2', { verificatioPendingFiles: isVerificationPending, firstUnverifiedFile: firstUnverifiedFile }),
          noTranslateMessage: true,
          autoHideDuration: 5000,
          closeIcon: true,
          isBlocking: false
        })
      }
    }
  }

  const saveViewAllFiles = async () => {
    const { fileList: viewAllFilesList, jobId } = getState()
    const boxId = getBoxId() || arrRefs[SKPBOX]?.current?.getValue()
    const filesListToUpdate = [...viewAllFilesList]
    await gdeTransactions.updateFileAsBatch(jobId, boxId, filesListToUpdate, getState().jobDetails.accountLevel1.toUpperCase())
  }

  const saveBoxes = async () => {
    const boxesListToUpdate = [...getState().boxList]
    const boxId = getState().boxId || getBoxId()
    let boxData = {}
    if (state.isRekey || state.isVerification) {
      boxesListToUpdate.forEach((box) => {
        if (box.skpBoxId === boxId) {
          const boxStatus = box.status ? box.status : ''
          box.status = boxStatus
          box.skpBoxId = getState().boxId
          box.customerId = getState().jobDetails.accountLevel1.toUpperCase()
          boxData = {
            actionTs: new Date(),
            boxInfo: box,
          }
        }
        // const boxName = box.skpBoxId
        delete box.status
      })
      await gdeTransactions.updateBox(getState().jobId, boxId, boxData)
    } else {
      for (const box of boxesListToUpdate) {
        if (box.skpBoxId === boxId) {
          const boxName = box.skpBoxId
          const boxStatus = box.status ? box.status : ''
          box.skpBoxId = boxName
          if (getState()?.jobDetails?.dataEntryType === 'Maintenance Box' && getState()?.jobDetails?.templateData?.templateFields !== undefined) {
            box.maintenanceCode = getState()?.jobDetails?.templateData?.templateFields?.maintenanceCode?.defaultValue
          }
          box.customerId = getState().jobDetails.accountLevel1.toUpperCase()
          delete box.status
          const boxData = {
            actionTs: new Date(),
            boxInfo: box,
          }
          await gdeTransactions.updateBox(getState().jobId, boxName, boxData)
          // adding status key back
          box.status = boxStatus
        }
      }
    }
  }

  const statusUpdateForJob = async (userType) => {
    const boxesRaw = await gdeTransactions.getBoxesForJob(jobId)

    const collection = Object.values(boxesRaw.docs).sort(function (a, b) {
      const boxSrNoA = a.data().boxSrNo || a.data().boxId
      const boxSrNoB = b.data().boxSrNo || b.data().boxId
      return boxSrNoA > boxSrNoB ? 1 : -1
    }).slice(0)

    const boxList = []
    const boxUserList = []

    collection.forEach((doc, index) => {
      const data = doc.data()
      boxList.push({
        boxId: data.boxId,
        boxInfo: data.boxInfo,
        entryUser: data.dataEntryUser,
        status: data.status,
        dataEntryUser: data.dataEntryUser,
        verificationUser: data.verificationUser
      })
      boxUserList.push(doc.data().dataEntryUser)
    })
    const checkReadyToTransmit = (Boxes) => {
      if (Boxes.status === constants.boxStatus.approved) {
        return Boxes.status === constants.boxStatus.approved
      }
      if (Boxes.status === constants.boxStatus.transmitted) {
        return Boxes.status === constants.boxStatus.transmitted
      }
      if (Boxes.status === constants.boxStatus.exception) {
        return Boxes.status === constants.boxStatus.exception
      }
    }
    const result = boxList.filter(checkReadyToTransmit)

    const transmitBoxEqual = boxList.length === 0 ? false : getState().jobDetails.totalBoxes === result.length

    if (transmitBoxEqual === true && getState().jobDetails.totalBoxes !== 9999) {
      const data = {
        jobStatus: constants.jobStatus.readyToTransmit,
        autoTransmitAndStatus: `${getState().jobDetails.autoTransmit}-${constants.jobStatus.readyToTransmit}`,
      }
      gdeTransactions.updateJob(jobId, data)
    }
    getFiles(getState().templateTypeSelected)
  }

  const toggleTable = (type) => {
    const fromDisplayTable = true
    setOpenTable(prev => !prev)
    if (openTable) {
      if (type === 'box') {
        setState({ isTemplateFieldsEditable: false, enterDataDisabled: state?.boxId ? false : true, isAllFieldsDisabled: true })
        setHideTable(false)
      } else {
        setState({ enterDataDisabled: state?.boxId ? false : true, isTemplateFieldsEditable: false, isAllFieldsDisabled: false, recordKeyStrokesStatus: false })
        setPauseEnabled(false)
        setHideTable(false)
        onEnterData()
      }
    } else {
      if (type === 'box') {
        if (!state.recordKeyStrokesStatus) {
          setState({ isTemplateFieldsEditable: false, enterDataDisabled: true, isAllFieldsDisabled: true })
          setHideTable(true)
          handlePause(fromDisplayTable)
          setPauseEnabled(true)
        } else {
          setState({ isTemplateFieldsEditable: false, enterDataDisabled: true, isAllFieldsDisabled: true })
          setHideTable(true)
        }
      } else {
        setState({ isTemplateFieldsEditable: false, enterDataDisabled: false, isAllFieldsDisabled: true, recordKeyStrokesStatus: true })
        setPauseEnabled(true)
        setHideTable(true)
        handlePause(fromDisplayTable)
      }
    }
  }

  const handleJobComplete = async () => {
    let isBoxInfoMissing = false
    const boxData = {
      actionTs: new Date(),
      status: constants.boxStatus.dataEntryInProcess,
    }
    if (getState()?.jobDetails?.dataEntryType === 'New Box' || getState()?.jobDetails?.dataEntryType === 'Maintenance Box') {
      const collectionBoxes = await gdeTransactions.getBoxesForJob(getState().jobDetails.jobId)
      collectionBoxes.forEach((doc) => {
        if (doc.data().boxInfo === undefined) {
          isBoxInfoMissing = true
          gdeTransactions.updateBoxData(getState().jobDetails.jobId, doc.data().boxId, boxData)
        }
      })
    }

    if (isBoxInfoMissing) {
      openGeneralDialog({
        title: t('dataEntry.IncompleteBoxes'),
        message: <Label>dataEntry.IncompleteMsg</Label>,
        translateMessage: false,
        noTranslateTitle: true,
        buttons: (
          <ButtonForIncompleteBoxesmsg />
        ),
        closeX: true
      })
    } else {
      setBusy()
      await getBoxCount()
      let bc = 0
      for (let i = getState().boxList.length - 1; i >= 0; i--) {
        // if (getState().boxListInfo[i].status === constants.boxStatus.readyForQc || getState().boxListInfo[i].status === constants.boxStatus.transmitted || getState().boxListInfo[i].status === constants.boxStatus.readyForVerification || getState().boxListInfo[i].status === constants.boxStatus.exception || getState().boxListInfo[i].status === constants.boxStatus.approved || getState().boxListInfo[i].status === constants.boxStatus.requiresReKey) {
        if (getState().boxListInfo[i].status !== constants.boxStatus.dataEntryInProcess) {
          bc = bc + 0
        } else {
          bc = bc + 1
        }
      }
      clearBusy()
      if (getState().boxesKeyed >= 1 && bc === 0) {
        openGeneralDialog({
          title: t('dataEntry.jobComplete'),
          message: <Label>dataEntry.jobCompleteMsg</Label>,
          translateMessage: false,
          noTranslateTitle: true,
          buttons: (
            <ButtonsForTransmitDialogBox />
          ),
          closeX: true
        })
      } else {
        openGeneralDialog({
          title: t('dataEntry.IncompleteBoxes'),
          message: <Label>dataEntry.IncompleteMsg</Label>,
          translateMessage: false,
          noTranslateTitle: true,
          buttons: (
            <ButtonForIncompleteBoxesmsg />
          ),
          closeX: true
        })
      }
    }


  }

  const handleIncomplete = async () => {
    closeGeneralDialog()
    setTimeout(() => {
      history.push(`${routePaths.boxList}/${getState().jobId}`)
    }, 1000)
    setBusy()
    setTimeout(() => {
      clearBusy()
    }, 1000)
  }

  const handleTotalBoxes = async () => {
    const JobState = getState().jobId
    const collection = await gdeTransactions.getBoxesForJob(JobState)
    const jobCompleteBoxCount = collection.size
    const data = {
      totalBoxes: jobCompleteBoxCount,
    }
    getState().jobDetails.totalBoxes = jobCompleteBoxCount
    await gdeTransactions.updateJob(JobState, data)
    setTimeout(() => {
      history.push(`${routePaths.myJobs}`)
    }, 1000)
    closeGeneralDialog()
    successToast({ message: t('toast.jobSubmitted') })
    await statusUpdateForJob()
    // else {
    //   const JobState = getState().jobId
    //   const data = {
    //     totalBoxes: getState().boxesKeyed,
    //   }
    //   await gdeTransactions.updateJob(JobState, data)
    //   setTimeout(() => {
    //     history.push(`${routePaths.myJobs}`)
    //   }, 1000)
    //   closeGeneralDialog()
    //   successToast({ message: translate('toast.jobSubmitted') })
    //   if (getState().lastBoxKeyedStatus === 'Ready To Transmit' || getState()?.isVerifyComplete) {
    //     manualTransmitJob()
    //   }
  }

  const onNoMoreBoxToComplete = async (isLimitNotReached) => {
    setBusy()
    setState({ displayeBtnDisable: true })
    const { userType, jobId, currentFileCount, currentBoxCount, boxData, isRekey, fileList, boxId } = getState()
    const fileCount = currentFileCount
    const boxCount = currentBoxCount
    const boxsId = getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' ? getBoxId() : state.isRekey ? boxId : getState().boxId
    props.stop()

    if (getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (recordKeystrokes) {
        if (keystrokes.length > 0) {
          turnOffKeystrokeRecorder(true, getBoxId(), fileList.length, 1)
        } else {
          saveMetricsData(true, getBoxId(), fileList.length, 1)
        }
      } else {
        saveMetricsData(true, getBoxId(), fileList.length, 1, false, getState().timerObj)
      }
    } else {
      if (recordKeystrokes) {
        if (keystrokes.length > 0) {
          turnOffKeystrokeRecorder(false, getBoxId(), 0, boxCount)
        } else {
          saveMetricsData(false, getBoxId(), 0, boxCount)
        }
      } else {
        saveMetricsData(false, getBoxId(), 0, boxCount, false, getState().timerObj)
      }
    }

    if (isLimitNotReached) {
      closeGeneralDialog()
    }

    if (getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      // deleting inprogress file before completing the box to avoid empty files in db
      let deleteFileId = ''
      fileList.forEach((file) => {
        if (file.status === constants.fileStatus.inProgress) {
          deleteFileId = file.fileId
        }
      })
      if (deleteFileId !== '') {
        await gdeTransactions.deleteFile(jobId, boxsId, deleteFileId)
      }

      if (props.updatedFileList !== undefined && (boxData?.status === constants.boxStatus.dataEntryInProcess ||
        isRekey || boxData?.status === undefined)) {
        saveViewAllFiles()
      } else {
        // saveFiles()
      }
    } else {
      await saveBoxes(true)
    }

    let status = await getJobStatusToBeupdated(jobId, userType, getState().isVerifyRequired, user)
    if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined' && additionalPermissionsForUser[indexOfrequireQualityCheck]?.enabled && (!getState().isVerifyRequired || getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      status = constants.boxStatus.readyForQc
    }

    await gdeTransactions.updateBoxStatus(jobId, boxsId, status, false, null, getState().currentFileCount)
      .then(() => {
        refLocalToast.current?.successToastOn({
          message: t('toast.boxSubmitted'),
          title: t('toast.jobManagement'),
        })
        setTimeout(() => {
          history.push(`${routePaths.boxList}/${getState().jobId}`)
        }, 1000)
      })
    if (getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      await boxIdUpdate(boxsId)
    }
    await statusUpdateForJob()
    clearFields()
    // 647: saving the total files count value in the backend
    getFiles(getState().templateTypeSelected)
    clearBusy()
  }

  const boxIdUpdate = async (submittedBoxId) => {
    const value = submittedBoxId || getBoxId() || arrRefs[SKPBOX]?.current?.getValue()
    if (value) {
      const filesForBox = await gdeTransactions.getFilesForBox(getState().jobId, value)
      const files = filesForBox.docs.sort(function (a, b) {
        return a.id.localeCompare(b.id, undefined, {
          numeric: true,
          sensitivity: 'base'
        })
      })

      files.forEach((doc) => {
        const docData = doc.data()
        docData.fileInfo.skpBoxId = value
        gdeTransactions.updateFile(getState().jobId, value, doc.data().fileInfo.fileId, docData)
      })
    }
  }

  const cancelFileSave = async () => {
    closeGeneralDialog()
    const status = getJobStatusToBeupdated(getState().jobId, getState().userType, getState().isVerifyRequired, user)
    props.onOpenTable(getState().fileList, getState().currentFileCount, status, getState().lockableFields, getState().lockableFieldsData, getState().userType, getState()?.timerObj?.dataEntryType)
  }

  const onSaveFile = async () => {
    const { lockableFields } = getState()
    closeGeneralDialog()
    const arrCount = DATAENTRYSTARTINGKEY
    let focusKey = DATAENTRYSTARTINGKEY
    setTimeout(() => {
      for (let i = arrCount; i < arrRefs.length; i++) {
        if (!arrRefs[i].current.getFormTemplate().disabled && !lockableFields[arrRefs[i].current.getFormTemplate().fieldKey]) {
          focusKey = i
          break
        }
      }

      arrRefs[focusKey].current.focus()
      // setState({ enterDataDisabled: true })
    }, 3)
  }

  const onSaveBox = async () => {
    const { lockableFields } = getState()
    closeGeneralDialog()
    const arrCount = DATAENTRYSTARTINGKEY
    let focusKey = DATAENTRYSTARTINGKEY
    setTimeout(() => {
      for (let i = arrCount; i < arrRefs.length; i++) {
        if (!arrRefs[i].current.getFormTemplate().disabled && !lockableFields[arrRefs[i].current.getFormTemplate().fieldKey]) {
          focusKey = i
          break
        }
      }

      arrRefs[focusKey].current.focus()
      // setState({ enterDataDisabled: true })
    }, 3)
  }

  const cancelFileSaveBc = async () => {
    closeGeneralDialog()
    // props.stop()
    // turnOffKeystrokeRecorder()
    setState({ enterDataDisabled: false })
    handleSubmitData()
  }

  const onSaveFileBc = async () => {
    const { lockableFields } = getState()
    closeGeneralDialog()
    const arrCount = DATAENTRYSTARTINGKEY
    let focusKey = DATAENTRYSTARTINGKEY
    setTimeout(() => {
      for (let i = arrCount; i < arrRefs.length; i++) {
        if (!arrRefs[i].current.getFormTemplate().disabled && !lockableFields[arrRefs[i].current.getFormTemplate().fieldKey]) {
          focusKey = i
          break
        }
      }

      arrRefs[focusKey].current.focus()
      // setState({ enterDataDisabled: true })
    }, 3)
  }

  const onHaveMoreBoxToComplete = async () => {
    setBusy()
    const { userType, jobId, currentFileCount, currentBoxCount, boxIds, boxData, fileList } = getState()
    const fileCount = currentFileCount
    const boxCountMetrics = currentBoxCount
    setPauseEnabled(true)
    setState({ displayeBtnDisable: true })
    const boxId = getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' ? getBoxId() : getState().boxId
    props.stop()

    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (recordKeystrokes) {
        if (keystrokes.length > 0) {
          turnOffKeystrokeRecorder(true, getBoxId(), fileList.length, 1)
        } else {
          saveMetricsData(true, getBoxId(), fileList.length, 1)
        }
      } else {
        saveMetricsData(true, getBoxId(), fileList.length, 1, false, getState().timerObj)
      }
    } else {
      if (recordKeystrokes) {
        if (keystrokes.length > 0) {
          turnOffKeystrokeRecorder(false, getBoxId(), 0, boxCountMetrics)
        } else {
          saveMetricsData(false, getBoxId(), 0, boxCountMetrics)
        }
      } else {
        saveMetricsData(false, getBoxId(), 0, boxCountMetrics, false, getState().timerObj)
      }
    }

    const boxCount = state.boxCount + 1
    let boxscount = state.boxesKeyed
    let verifyCount = boxscount
    // need to check
    if ((!boxIds.includes(boxId) && !isBoxExists)) {
      boxscount = state.boxesKeyed + 1
      verifyCount = boxscount
    } else if (!(boxData?.status === constants.boxStatus.dataEntryInProcess && isBoxExists)) {
      verifyCount++
    }

    closeGeneralDialog()
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      // deleting inprogress file before completing the box to avoid empty files in db
      let deleteFileId = ''
      fileList.forEach((file) => {
        if (file.status === constants.fileStatus.inProgress) {
          deleteFileId = file.fileId
        }
      })
      if (deleteFileId !== '') {
        await gdeTransactions.deleteFile(jobId, boxId, deleteFileId)
      }
      // files will get updated after returning from view all files screen
      if (props.updatedFileList !== undefined && (boxData?.status === constants.boxStatus.dataEntryInProcess ||
        boxData?.status === constants.boxStatus.requiresReKey || boxData?.status === undefined)) {
        saveViewAllFiles()
      } else {
        saveFiles()
      }
    } else {
      await saveBoxes(true)
    }
    let status = await getJobStatusToBeupdated(jobId, userType, getState().isVerifyRequired, user)

    boxIds.push(boxId)
    if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined' && additionalPermissionsForUser[indexOfrequireQualityCheck]?.enabled && (!getState().isVerifyRequired || getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      status = constants.boxStatus.readyForQc
    }
    await gdeTransactions.updateBoxStatus(jobId, boxId, status, false, null, getState().currentFileCount)
      .then(() => {
        arrRefs[SKPBOX].current.setValue('')
        arrRefs[SKPBOX_CONFIRM]?.current?.setValue('')
        refLocalToast.current?.successToastOn({
          message: t('toast.boxSubmitted'),
          title: t('toast.jobManagement'),
          autoHideDuration: 1000,
        })

        setIsModalOpen(true)
        // setting all values to initial state as we are starting a new box again
        setState({
          fileList: [],
          filesKeyed: 0,
          boxesKeyed: (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') ? boxCount : boxscount,
          boxsCount: boxscount,
          boxCount: boxCount,
          jobcompleteDisabled: false,
          recordKeyStrokesStatus: true,
          isSkpBoxIdEditable: false,
          isTemplateFieldsEditable: false,
          viewFiles: false,
          enterDataDisabled: true,
          isExcetionBoxDisabled: true,
          fileVerifyStartCount: 0,
          fileSequence: 1,
          currentFileCount: 0,
          boxVerifyStartCount: verifyCount,
          currentBoxCount: 0,
          boxId: undefined,
          boxIds: boxIds,
          lastBoxKeyedStatus: status
        })
        // if (getState().jobDetails.assignedUserList.length <= 2) {
        //   if (getState().jobDetails.assignedUserList.length === 2 && getState().jobUserData.verifyUser !== '') {
        //     setState({ jobcompleteDisabled: false })
        //   } else if (getState().jobDetails.assignedUserList.length === 1) {
        //     setState({ jobcompleteDisabled: false })
        //   } else {
        //     setState({ jobcompleteDisabled: true })
        //   }
        // } else {
        //   setState({ jobcompleteDisabled: true })
        // }
        // setTimeout(() => {
        //   history.push((state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile')
        //     ? `${routePaths.dataEntry}/${getState().jobId}`
        //     : (!isBoxExists) ? `${routePaths.dataEntry}/${getState().jobId}` : `${routePaths.boxList}/${getState().jobId}`)
        // }, 3000)

        setTimeout(() => {
          history.push(`${routePaths.dataEntry}/${getState().jobId}`)
        }, 3000)
      })
    if (getState().jobDetails.standardTemplateName === 'skpStandardNewFile' || getState().jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      await boxIdUpdate(boxId)
    }
    await statusUpdateForJob()

    clearBusy()
    // 647: saving the total files count value in the backend
    getFiles(getState().templateTypeSelected)
    clearFields()
    setTimeout(() => {
      setState({ isSkpBoxIdEditable: true })
      arrRefs[SKPBOX].current.focus()
    }, 1000)
  }

  const onChangeExceptionBox = (e) => {
    if (e === true) {
      openExceptionBoxDialog()
    }
  }

  const handleCancelExceptionBox = () => {
    arrRefs[EXCEPTION_BOX]?.current?.setValue(false)
    closeGeneralDialog()
  }

  const handleCancelOnClick = () => {
    if (online) {
      if (!recordKeystrokes) {
        turnOnKeystrokeRecorder(getState().timerObj)
      }
      openGeneralDialog({
        title: t('dataEntry.cancelDataEntry'),
        message: t('dataEntry.cancelMessage'),
        translateMessage: false,
        noTranslateTitle: true,
        buttons: (
          <ButtonsForCancelDialogBox onCancelDataEntry={onCancelDataEntry} />
        ),
        closeX: true
      })
    } else {
      errorToast({ message: t('toast.offlineStatusMsg'), title: t('toast.userOffline'), autoHideDuration: 3000 })
    }
  }

  document.onkeydown = function (evt) {
    evt = evt || window.event
    if (state.userType === userTypes.DATAENTRY_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
      if (evt.ctrlKey && (evt.key === 'M' || evt.key === 'm')) {
        getState().templateFields.forEach((element) => {
          if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
            if (evt.target.id === 'dataEntry_fields_' + element.customName || evt.target.id === 'dataEntry_fields_' + element.customName + ' *') {
              document.getElementById('dataEntry_lock' + element.name).click()
            }
          }
        })
      } else if (evt.ctrlKey && evt.key === ';') {
        handleNavigateBefore()
      } else if (evt.ctrlKey && evt.key === '.') {

        let count = 6
        getState().templateFields.forEach((element) => {
          if (element.isSelected && element.name !== SKP_BOX_ID && element.name !== CUSTOMER_ID) {
            ++count

            if (evt.target.id === 'dataEntry_fields_' + element.customName || evt.target.id === 'dataEntry_fields_' + element.customName + ' *' || evt.target.id === 'dataEntry_fieldsEditable_' + element.customName) {
              // if(element.verify && evt.target.id !== 'dataEntry_fieldsEditable_' + element.customName && (evt.target.id === 'dataEntry_fields_' + element.customName || evt.target.id === 'dataEntry_fields_' + element.customName + ' *')) {
              //   --count
              // }

              if (evt.target.id !== 'dataEntry_fieldsEditable_' + element.customName) {
                if (getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
                  const currentRecordIndex = getState().boxVerifyStartCount - 1
                  const fetchDataElement = element.name
                  const innercount = count
                  arrRefs[innercount]?.current?.setValue(getState().boxList[currentRecordIndex][fetchDataElement])
                } else {
                  const currentRecordIndex = getState().fileVerifyStartCount - 1
                  const fetchDataElement = element.name
                  const innercount = count
                  arrRefs[innercount]?.current?.setValue(getState().fileList[currentRecordIndex][fetchDataElement])
                }
              }
            }

          }
        })
      }
    }
  }

  const convertToUpperCase = async (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '')

    let skpBoxValue = e.target.value
    const firstElement = Array.from(skpBoxValue)[0]
    const barcodeLogic = getState()?.jobData?.barcodeLogic || appConstants?.originalBarcodeLogic
    
    if (skpBoxValue.length === 0) {
      if (e.target.id === 'dataEntry_skpBox' && dropFirstLetterSkpBox) {
        setDropFirstLetterSkpBox(false)
      } else if (e.target.id === 'dataEntry_skpBoxConfirm' && dropFirstLetterSkpBoxCnf) {
        setDropFirstLetterSkpBoxCnf(false)
      }
    }
    
    if (skpBoxValue.length > 0) {
      for (const [key, value] of Object.entries(barcodeLogic)) {
        if (key.includes(firstElement?.toUpperCase())) {
          const lengthLimit = value.logic.limit
          const operator = value.logic.operator
          const trim = value.logic.trim
          if (trim && eval(`${skpBoxValue.length} ${operator} ${lengthLimit}`)) {
            if (e.target.id === 'dataEntry_skpBox' && !dropFirstLetterSkpBox) {
              skpBoxValue = skpBoxValue.substring(1)
              setDropFirstLetterSkpBox(true)
            } else if (e.target.id === 'dataEntry_skpBoxConfirm' && !dropFirstLetterSkpBoxCnf) {
              skpBoxValue = skpBoxValue.substring(1)
              setDropFirstLetterSkpBoxCnf(true)
            }
          }
        }
      }
    }
    
    return e.target.value = ('' + skpBoxValue).toUpperCase()
  }
  
  const convertToUpperCaseBackup = async (e) => {
    let skpBoxValue = e.target.value
    const firstElement = Array.from(skpBoxValue)[0]
    const arrayOfIgnoredChars = appConstants.ignoreBarcodeScanCharacters

    if (skpBoxValue.length === 0) {
      if (e.target.id === 'dataEntry_skpBox' && dropFirstLetterSkpBox) {
        setDropFirstLetterSkpBox(false)
      } else if (e.target.id === 'dataEntry_skpBoxConfirm' && dropFirstLetterSkpBoxCnf) {
        setDropFirstLetterSkpBoxCnf(false)
      }
    }

    if (skpBoxValue.length === 12 && arrayOfIgnoredChars.indexOf(firstElement.toUpperCase()) !== -1) {
      skpBoxValue = skpBoxValue.substring(1)
    } else if (arrayOfIgnoredChars.indexOf(firstElement?.toUpperCase()) !== -1 && firstElement.toUpperCase() !== 'R' && skpBoxValue.length > 1) {
      if (e.target.id === 'dataEntry_skpBox' && !dropFirstLetterSkpBox) {
        skpBoxValue = skpBoxValue.substring(1)
        setDropFirstLetterSkpBox(true)
      } else if (e.target.id === 'dataEntry_skpBoxConfirm' && !dropFirstLetterSkpBoxCnf) {
        skpBoxValue = skpBoxValue.substring(1)
        setDropFirstLetterSkpBoxCnf(true)
      }
    }

    return e.target.value = ('' + skpBoxValue).toUpperCase()
  }

  const skpBoxValue = async (e) => {

    if (e.key && e.key.length === 1 && regexObj.test(e.key)) {
      e.preventDefault();
      return;
    }

    arrRefs[SKPBOX]?.current?.setFieldType('text')
    if (e.keyCode === 13 || e.keyCode === 9) {
      if (e.target.value !== '') {
        validateSkpBoxValue(e)
      }
    }
  }

  const onBlurSkpBoxValue = async (e) => {
    e.preventDefault()
    if (e.target.value !== '' && arrRefs[SKPBOX].current.getValue() !== '') {
      validateSkpBoxValue(e)
    }
  }

  const getBoxService = async (jobId, value) => {
    return await gdeTransactions.getBox(jobId, value)
  }

  const validateSkpBoxValue = async (e) => {
    if (e.target.value.length > 11) {
      arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxLengthInvalid')
    } else {
      arrRefs[SKPBOX].current.clearErrorMsg()
      arrRefs[SKPBOX_CONFIRM]?.current?.clearErrorMsg()
      arrRefs[SKPBOX_CONFIRM]?.current?.setValue('')
      const boxes = await getBoxService(jobId, e.target.value)
      if (boxes.exists()) {
        if (getState().jobDetails.dataEntryType !== 'Maintenance Box' && getState().jobDetails.dataEntryType !== 'New Box') {
          arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxAlreadyExists')
        } else {
          if (e.keyCode === 13 || e.keyCode === 9) {
            arrRefs[SKPBOX].current.setErrorMsg('dataEntry.boxAlreadyExists')
          }
        }
      } else {
        arrRefs[SKPBOX]?.current?.setFieldType('password')
        if (getState().jobDetails.dataEntryType !== 'Maintenance Box' && getState().jobDetails.dataEntryType !== 'New Box') {
          arrRefs[SKPBOX_CONFIRM]?.current?.focus()
        } else {
          if (e.keyCode === 13 || e.keyCode === 9) {
            if ((getState().jobDetails.dataEntryType === 'Maintenance Box' && getState().templateFields[1]?.verify === false) || (getState().jobDetails.dataEntryType === 'New Box' && getState().templateFields[1]?.verify === false)) {
              // #1019: Added a new function which gets called only when all the fields are locked in the template
              const { lockableFields } = getState()
              let tempCounter = 0
              getState().templateFields.forEach((element, index) => {
                if (element.name in getState().lockableFields && lockableFields[element.name]) {
                  tempCounter++
                }
              })
              if (tempCounter === getState().templateFields.length - 2 && e !== undefined) {
                onLockFieldSave(e)
              } else {
                onEnterData(e)
                setState({ enterDataDisabled: false, isExcetionBoxDisabled: false, isEditable: false, startnewBox: false })
              }
            } else {
              arrRefs[SKPBOX_CONFIRM]?.current?.focus()
            }
          }
        }
      }
    }
  }

const skpBoxValueConfirmKeyPress = (e) => {

    if (e.key && e.key.length === 1 && regexObj.test(e.key)) {
      e.preventDefault();
      return; 
    }

    if (e.keyCode === 13 || e.keyCode === 9) {
      if (e.target.value !== '') {
        skpBoxValueConfirm(e)
      }
    }
  }

  const onBlurSkpValueConfirm = (e) => {
    e?.preventDefault()
    if (e.target.value !== '') {
      skpBoxValueConfirm(e)
    }
  }

  const skpBoxValueConfirm = async (e) => {
    const { lockableFields } = getState()
    const boxes = await getBoxService(jobId, e.target.value)
    if (arrRefs[SKPBOX_CONFIRM]?.current?.getValue() !== arrRefs[SKPBOX].current.getValue()) {
      arrRefs[SKPBOX_CONFIRM]?.current?.setErrorMsg('dataEntry.fieldsMustMatch')
      setState({ isTemplateFieldsEditable: false })
    } else if (e.keyCode !== undefined && e.target.value.length < 12 && !boxes.exists()) {
      if (e.keyCode === 13 || e.keyCode === 9) {
        // #1019: Added a new function which gets called only when all the fields are locked in the template
        if (getState().templateTypeSelected === 'Maintenance Box' || getState().templateTypeSelected === 'New Box') {
          let tempCounter = 0
          getState().templateFields.forEach((element, index) => {
            if (element.name in getState().lockableFields && lockableFields[element.name]) {
              tempCounter++
            }
          })
          if (tempCounter === getState().templateFields.length - 2 && e !== undefined) {
            onLockFieldSave(e)
          } else {
            onEnterData(e)
          }
        } else {
          onEnterData(e)
        }
      }
      setState({ isExcetionBoxDisabled: false, isEditable: false, startnewBox: false })
    }
  }

  const setSkpBoxId = () => {
    const { boxList, boxVerifyStartCount } = getState()
    const boxId = boxList[boxVerifyStartCount]?.skpBoxId
    arrRefs[SKPBOX].current.setValue(boxId)
    arrRefs[SKPBOX_CONFIRM]?.current?.setValue(boxId)
    setState({ isSkpBoxIdEditable: false, boxId: boxId })
    // setState({ boxId })
  }

  const handleNavigateBefore = () => {
    const { fileVerifyStartCount, boxData, boxVerifyStartCount } = getState()
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (fileVerifyStartCount > 0) {
        fileNumberRef.current.setValue('')
        setState({ fileVerifyStartCount: fileVerifyStartCount - 1 })
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(updateRefs, 2)
        }
      }
    } else {
      setState({
        isTemplateFieldsEditable: true,
        enterDataDisabled: false,
      })
      if (boxVerifyStartCount > 0) {
        boxNumberRef.current.setValue('')
        setState({ boxVerifyStartCount: boxVerifyStartCount - 1 })
        setSkpBoxId()
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(navigationUpdateRefs, 2)
        }
      }
    }
  }

  const handleFirstPage = () => {
    const { fileVerifyStartCount, boxData, boxVerifyStartCount } = getState()

    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (fileVerifyStartCount > 0) {
        fileNumberRef.current.setValue('')
        setState({ fileVerifyStartCount: 0 })
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(updateRefs, 2)
        }
      }
    } else {
      setState({
        isTemplateFieldsEditable: true,
        enterDataDisabled: false,
      })
      if (boxVerifyStartCount > 0) {
        boxNumberRef.current.setValue('')
        setState({ boxVerifyStartCount: 0 })
        setSkpBoxId()
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(navigationUpdateRefs, 2)
        }
      }
    }
  }

  const handleNavigateNext = () => {
    const { fileVerifyStartCount, boxData, fileList, boxVerifyStartCount, boxList } = getState()
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (fileVerifyStartCount < fileList.length - 1) {
        fileNumberRef.current.setValue('')
        setState({ fileVerifyStartCount: fileVerifyStartCount + 1 })
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(updateRefs, 2)
        }
      }
    } else {
      setState({
        isTemplateFieldsEditable: true,
        enterDataDisabled: false,
      })
      if (boxVerifyStartCount < boxList.length - 1) {
        boxNumberRef.current.setValue('')
        setState({ boxVerifyStartCount: boxVerifyStartCount + 1 })
        setSkpBoxId()
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(navigationUpdateRefs, 2)
        }
      }
    }
  }

  const handleLastPage = () => {
    const { fileVerifyStartCount, boxData, fileList, boxVerifyStartCount, boxList } = getState()
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      if (fileVerifyStartCount < fileList.length - 1) {
        fileNumberRef.current.setValue('')
        setState({ fileVerifyStartCount: fileList.length - 1 })
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(updateRefs, 2)
        }
      }
    } else {
      setState({
        isTemplateFieldsEditable: true,
        enterDataDisabled: false,
      })
      if (boxVerifyStartCount < boxList.length - 1) {
        boxNumberRef.current.setValue('')
        setState({ boxVerifyStartCount: boxList.length - 1 })
        setSkpBoxId()
        if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
          boxData?.status === constants.boxStatus.requiresReKey ||
          boxId === undefined) {
          setTimeout(navigationUpdateRefs, 2)
        }
      }
    }
  }

  const handleRefreshData = () => {
    const arrCount = DATAENTRYSTARTINGKEY

    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      for (let i = arrCount; i < arrRefs.length; i++) {
        const nextFieldLockStatus = getState().lockableFields[arrRefs[i]?.current?.getFormTemplate().fieldKey]
        if (!nextFieldLockStatus) {
          arrRefs[i].current.clear()
          arrRefs[i].current.setValue('')
        }
      }
    } else {
      arrRefs[SKPBOX].current.clear()
      arrRefs[SKPBOX].current.setValue('')
      arrRefs[SKPBOX_CONFIRM]?.current?.clear()
      arrRefs[SKPBOX_CONFIRM]?.current?.setValue('')
      for (let i = arrCount; i < arrRefs.length; i++) {
        arrRefs[i].current.clear()
        arrRefs[i].current.setValue('')
      }
      setState({ isSkpBoxIdEditable: true })
    }
    // arrRefs[SKPBOX].current.focus()
  }

  // const handleEditFile = () => {
  //   const { fileList, boxData } = getState()
  //   setState({ fileVerifyStartCount: fileList.length })
  //   fileNumberRef.current.setValue('')
  //   if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
  //     boxData?.status === constants.boxStatus.requiresReKey ||
  //     boxId === undefined) {
  //     setTimeout(updateRefs, 2)
  //   }
  // }

  const handleYesButtonForDeleteIcon = async (closeDialog) => {
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      let { fileVerifyStartCount: fileCount, filesKeyed: fileKeyedCount, currentFileCount } = getState()
      const { deletedFileIndex: deletedList, fileVerifyStartCount: index, boxData, boxId } = getState()
      const fileList = [...getState().fileList]

      const currentBoxId = arrRefs[SKPBOX].current.getValue() || boxId
      if (fileList.length > 0) {
        fileKeyedCount--
        currentFileCount--
        if (fileCount > 0) {
          fileCount--
        }
      }
      const deletedFileId = fileList[index]?.fileId
      deletedList.push([deletedFileId])
      fileList.splice(index, 1)

      // Delete file in firebase
      if (deletedFileId) {
        await gdeTransactions.deleteFile(getState().jobId, currentBoxId, deletedFileId)
      }

      fileNumberRef.current.setValue('')
      const arrCount = DATAENTRYSTARTINGKEY
      let focusKey = arrCount
      for (let i = arrCount; i < arrRefs.length; i++) {
        if (!arrRefs[i].current?.getFormTemplate()?.disabled && arrRefs[i]?.current?.getValue() === '') {
          focusKey = i
          break
        }
      }
      arrRefs[focusKey]?.current?.focus()

      setState({ fileList: fileList, deletedFielList: deletedList, fileVerifyStartCount: fileList?.length, filesKeyed: fileKeyedCount, currentFileCount })
      if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
        boxData?.status === constants.boxStatus.requiresReKey ||
        boxId === undefined) {
        setTimeout(updateRefs, 2)
      }
      if (closeDialog) {
        closeGeneralDialog()
      }
      refLocalToast.current?.successToastOn({
        message: t('toast.fileDeleted'),
        title: t('toast.jobManagement'),
      })
      history.push(`${routePaths.dataEntry}/${getState().jobId}`)
      // arrRefs[SKPBOX].current.focus()
    } else {
      let { boxVerifyStartCount: boxsCount, boxesKeyed: boxKeyedCount, currentBoxCount } = getState()
      const { deletedFileIndex: deletedList, boxVerifyStartCount: index, boxData, jobId } = getState()
      const boxList = [...getState().boxList]
      // const deleteBoxCount = -1

      if (boxList.length > 0) {
        boxKeyedCount--
        currentBoxCount--
        if (boxsCount > 0) {
          boxsCount--
        }
      }

      const deletedBoxId = boxList[index]?.skpBoxId
      deletedList.push([deletedBoxId])
      boxList.splice(index, 1)

      // Delete box in firebase
      if (deletedBoxId) {
        await gdeTransactions.deleteBoxData(jobId, deletedBoxId)
      }

      // // keystroke metric for deleting a box
      // if (recordKeystrokes) {
      //   if (keystrokes.length > 0) {
      //     turnOffKeystrokeRecorder(false, getBoxId(), 0, deleteBoxCount)
      //   } else {
      //     saveMetricsData(false, getBoxId(), 0, deleteBoxCount)
      //   }
      // } else {
      //   saveMetricsData(false, getBoxId(), 0, deleteBoxCount, false, getState().timerObj)
      // }

      boxNumberRef.current.setValue('')
      const arrCount = DATAENTRYSTARTINGKEY
      let focusKey = arrCount
      for (let i = arrCount; i < arrRefs.length; i++) {
        if (!arrRefs[i].current?.getFormTemplate()?.disabled && arrRefs[i]?.current?.getValue() === '') {
          focusKey = i
          break
        }
      }
      arrRefs[focusKey]?.current?.focus()
      setState({ boxList: boxList, deletedFielList: deletedList, boxVerifyStartCount: boxsCount, boxesKeyed: boxKeyedCount, currentBoxCount })
      setSkpBoxId()
      if (boxData?.status === constants.boxStatus.dataEntryInProcess ||
        boxData?.status === constants.boxStatus.requiresReKey ||
        boxId === undefined) {
        setTimeout(updateRefs, 2)
      }
      if (closeDialog) {
        closeGeneralDialog()
      }
      refLocalToast.current?.successToastOn({
        message: t('toast.boxDeleted'),
        title: t('toast.jobManagement'),
      })
      history.push(`${routePaths.dataEntry}/${getState().jobId}`)
      arrRefs[SKPBOX].current.focus()
    }
    // 647: Decreasing the total file count by 1 when user deleted a file from UI only
    setState({
      totalFiles: getState().totalFiles - 1
    })
  }

  const handleNoButtonForDeleteIcon = () => {
    closeGeneralDialog()
  }

  const handleDelete = () => {
    openGeneralDialog({
      title: (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' ? t('dataEntry.navigation.dataEntryDeleteFileIconTitle') : t('dataEntry.navigation.dataEntryDeleteBoxIconTitle')),
      message: (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' ? <Label>dataEntry.navigation.dataEntryDeleteFileIconMsg</Label> : <Label>dataEntry.navigation.dataEntryDeleteBoxIconMsg</Label>),
      buttons: <ButtonsForDeleteIcon arrRefs={arrRefs} handleYesButtonForDeleteIcon={() => handleYesButtonForDeleteIcon(true)} handleNoButtonForDeleteIcon={() => handleNoButtonForDeleteIcon()} />,
      translateMessage: false,
      noTranslateTitle: true,
      closeX: true
    })
  }

  const isInteger = (num) => {
    if (isNaN(num)) {
      return false
    } else {
      return num % 1 === 0
    }
  }

  const onClickEditRecordButton = (rowId) => {
    setState({ isEditRecordButtonClicked: true })
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      !getState()?.enterDataDisabled && onEnterData()
    }

    handleFileNumber('onClickOfEditButton', rowId)
    arrRefs[DATAENTRYSTARTINGKEY].current.focus()

    if (state.jobDetails.standardTemplateName === 'skpStandardNewBox' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceBox') {
      !getState()?.enterDataDisabled && onEnterData()
    }
  }

  const handleFileNumber = (e, rowId) => {
    let fileVerifyStartCount = 0
    let boxVerifyStartCount = 0
    if (state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') {
      const value = parseInt(fileNumberRef.current.getValue()) || rowId
      const fileCount = getState().fileVerifyStartCount + 1
      const isRoundNumber = isInteger(fileNumberRef.current.getValue()) || rowId
      if (e.keyCode === 13 || e === 'onClickOfEditButton') {
        if (isNaN(value) || value === 0) {
          fileNumberRef.current.setErrorMsg('dataEntry.navigation.invalidNumber')
        } else if (!isRoundNumber) {
          fileNumberRef.current.setErrorMsg('dataEntry.navigation.notRoundNumber')
        } else {
          if (getState().fileList.length < value || value < 0) {
            fileNumberRef.current.setErrorMsg('dataEntry.navigation.invalidFileNumber')
          } else if (value <= getState().fileList.length && fileCount !== value) {
            fileVerifyStartCount = value
            setState({ fileVerifyStartCount: fileVerifyStartCount - 1 })
            if (getState().boxData?.status === constants.boxStatus.dataEntryInProcess ||
              getState().boxData?.status === constants.boxStatus.requiresReKey ||
              boxId === undefined) {
              setTimeout(updateRefs, 2)
              // setTimeout(navigationUpdateRefs, 2)
            }
            fileNumberRef.current.setValue('')
          }
        }
      }
    } else {
      setState({
        isTemplateFieldsEditable: true,
      })
      const value = parseInt(boxNumberRef.current.getValue()) || rowId
      const boxCount = getState().boxVerifyStartCount + 1
      const isRoundNumber = isInteger(boxNumberRef.current.getValue()) || rowId
      if (e.keyCode === 13 || e === 'onClickOfEditButton') {
        if (isNaN(value) || value === 0) {
          boxNumberRef.current.setErrorMsg('dataEntry.navigation.invalidNumber')
        } else if (!isRoundNumber) {
          boxNumberRef.current.setErrorMsg('dataEntry.navigation.notRoundNumber')
        } else {
          if (getState().boxList.length < value || value < 0) {
            boxNumberRef.current.setErrorMsg('dataEntry.navigation.invalidFileNumber')
          } else if (value <= getState().boxList.length && boxCount !== value) {
            boxVerifyStartCount = value
            setState({ boxVerifyStartCount: boxVerifyStartCount - 1 })
            setSkpBoxId()
            setState({ enterDataDisabled: false })
            setTimeout(navigationUpdateRefs, 2)
            // setTimeout(updateRefs, 2)
            boxNumberRef.current.setValue('')
          }
        }
      }
    }
  }

  const getdataEntryfields = () => {
    if (getState().boxData && (state.userType === userTypes.VERIFICATION_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER) &&
      (getState().boxData.status === constants.boxStatus.readyForVerification || getState().boxData.status === constants.boxStatus.verificationInProcess)) {
      return getVerificationUserTemplateFields()
    } else if (getState().isRekey && (state.userType === userTypes.DATAENTRY_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      return getFieldsForReKey()
    } else if (((getState().boxData && getState()?.boxData?.status === constants.boxStatus.dataEntryInProcess) || !getState().boxData) &&
      (state.userType === userTypes.DATAENTRY_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      return getTemplateFields()
    } else if (getState().addNewFileDuringVerification) {
      return getTemplateFields()
    }
  }

  const getdataEntryBoxfields = () => {
    if (getState().boxData && (state.userType === userTypes.VERIFICATION_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER) &&
      (getState().boxData.status === constants.boxStatus.readyForVerification || getState().boxData.status === constants.boxStatus.verificationInProcess)) {
      return getVerificationUserBoxTemplateFields()
    } else if (getState().isRekey && (state.userType === userTypes.DATAENTRY_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      return getBoxFieldsForReKey()
    } else if (((getState().boxData && getState()?.boxData?.status === constants.boxStatus.dataEntryInProcess) || !getState().boxData) &&
      (state.userType === userTypes.DATAENTRY_USER || state.userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      return getBoxTemplateFields()
    }
  }


  useImperativeHandle(ref, () => ({
    onIimeChange: value => {
      refStopWatchComponent.current.setValue(value)
    },
    getValues: () => {
      return ({
        boxId: getBoxId(),
        jobId: getState().jobId,
        fileList: getState().fileList,
        fileVerifyStartCount: getState().fileVerifyStartCount,
        fileSequence: getState().fileSequence,
        isTemplateFieldsEditable: getState().isTemplateFieldsEditable,
        boxCount: getState().boxCount,
        isRecordCountOpen: isModalOpen
      })
    },
  }))

  const checkNetworkBeforeNav = () => {
    if (online) onClickViewAllFiles()
    else {
      errorToast({ message: t('toast.offlineStatusMsg'), title: t('toast.userOffline'), autoHideDuration: 3000 })
    }
  }

  let casepoint = 0
  const onClickViewAllFiles = () => {
    if (!recordKeystrokes) {
      props.resume()
      turnOnKeystrokeRecorder(getState().timerObj)
    }
    const { userType } = getState()
    const { enterDataDisabled } = getState()
    let dataList
    if (enterDataDisabled === true && getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
      dataList = getState().boxList
      const pskp = arrRefs[SKPBOX].current.getValue()
      const pskpconfirm = arrRefs[SKPBOX_CONFIRM]?.current?.getValue() || arrRefs[SKPBOX].current.getValue()
      if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.DATAENTRY_USER) {
        if (pskp === '' || pskpconfirm === '' || (pskp === undefined && pskpconfirm === '') || (pskp === undefined && pskpconfirm === undefined) || ((pskp !== ('' || undefined)) && pskp !== pskpconfirm)) {
          dataList = getState().boxList
          const status = getJobStatusToBeupdated(getState().jobId, getState().userType, getState().isVerifyRequired, user)
          props.onOpenTable(dataList, getState().currentFileCount, status, getState().lockableFields, getState().lockableFieldsData, getState().userType, getState()?.timerObj?.dataEntryType)
        } else if (pskp === undefined && (pskpconfirm !== '')) {
          openGeneralDialog({
            title: t('dataEntry.popupBox'),
            message: <Label>dataEntry.boxConfirmationMsg</Label>,
            translateMessage: false,
            noTranslateTitle: true,
            buttons: (<ButtonForViewAllBoxes arrRefs={arrRefs} onSaveBox={() => onSaveBox()} />
            ),
            closeX: true
          })
        } else {
          openGeneralDialog({
            title: t('dataEntry.popupBox'),
            message: <Label>dataEntry.boxConfirmationMsg</Label>,
            translateMessage: false,
            noTranslateTitle: true,
            buttons: (<ButtonForViewAllBoxes arrRefs={arrRefs} onSaveBox={() => onSaveBox()} />
            ),
            closeX: true
          })
        }
      } else {
        dataList = getState().boxList
        const status = getJobStatusToBeupdated(getState().jobId, getState().userType, getState().isVerifyRequired, user)
        props.onOpenTable(dataList, getState().currentFileCount, status, getState().lockableFields, getState().lockableFieldsData, getState().userType, getState()?.timerObj?.dataEntryType)
      }
    } else if (enterDataDisabled === true && getState().jobDetails.dataEntryType === 'Maintenance File' || getState().jobDetails.dataEntryType === 'New File') {
      dataList = getState().fileList
      if (userType === userTypes.DATAENTRY_AND_VERIFY_USER || userType === userTypes.DATAENTRY_USER) {
        for (let i = DATAENTRYSTARTINGKEY; i < arrRefs.length; i++) {
          const value = arrRefs[i]?.current?.getValue()
          const key = arrRefs[i].current?.getFormTemplate().fieldKey
          if (value === '' && getState().lockableFields[key] === false) {
            casepoint = casepoint + 0
          } else if (getState().lockableFields[key] === false) {
            casepoint = casepoint + 1
          }
        }
        if (casepoint === 0) {
          const status = getJobStatusToBeupdated(getState().jobId, getState().userType, getState().isVerifyRequired, user)
          props.onOpenTable(dataList, getState().currentFileCount, status, getState().lockableFields, getState().lockableFieldsData, getState().userType, getState()?.timerObj?.dataEntryType)
        } else {
          openGeneralDialog({
            title: t('dataEntry.popup'),
            message: <Label>dataEntry.confirmationMsg</Label>,
            translateMessage: false,
            noTranslateTitle: true,
            buttons: (<ButtonsForConfirmation arrRefs={arrRefs} cancelFileSave={() => cancelFileSave(true)} onSaveFile={() => onSaveFile()} />
            ),
            closeX: true
          })
        }
      } else {
        const status = getJobStatusToBeupdated(getState().jobId, getState().userType, getState().isVerifyRequired, user)
        props.onOpenTable(dataList, getState().currentFileCount, status, getState().lockableFields, getState().lockableFieldsData, getState().userType, getState()?.timerObj?.dataEntryType)
      }
    } else {
      if (getState().jobDetails.dataEntryType === 'Maintenance Box' || getState().jobDetails.dataEntryType === 'New Box') {
        dataList = getState().boxList
      } else {
        dataList = getState().fileList
      }
      const status = getJobStatusToBeupdated(getState().jobId, getState().userType, getState().isVerifyRequired, user)
      props.onOpenTable(dataList, getState().currentFileCount, status, getState().lockableFields, getState().lockableFieldsData, getState().userType, getState()?.timerObj?.dataEntryType)
    }
  }

  const handleViewTemplateInstructions = async (jobid) => {
    setBusy()
    const jobDocument = await gdeTransactions.getJobById(jobId)
    const jobDoc = jobDocument.data()
    const templateInstructions = jobDoc.templateData.templateInstructions
    setState({ viewTemplateInstructions: templateInstructions })
    if (templateInstructions === undefined || templateInstructions === '') {
      setState({ isTemplateInstructions: false })
    } else {
      setState({ isTemplateInstructions: true })
    }
    const jobCountryCode = jobDoc?.countryCode
    const userRole = user?.userRolesObj?.gdeRole

    if (history.action === 'PUSH') {
      setState({ allowAccessToDataEntry: true })
    }

    if (history.action === 'POP') {
      if (userRole !== 'Super User') {
        const userCountryCode = user.countryCode
        const userAlternateCountryCode = user.alternateCountryCode
        if (jobCountryCode === userCountryCode || jobCountryCode === userAlternateCountryCode) {
          setState({ allowAccessToDataEntry: true })
        } else {
          setState({ allowAccessToDataEntry: false })
        }
      } else {
        const userCountryCode = user.countryCode
        const userAlternateCountryCode = user.alternateCountryCode
        if (jobCountryCode === userCountryCode || jobCountryCode === userAlternateCountryCode) {
          setState({ allowAccessToDataEntry: true })
        } else {
          const countryDoc = await gdeTransactions.getCountryByID(jobCountryCode)
          const countryData = countryDoc.data()
          const jobCountry = countryData?.countryName
          const userCountries = user?.userRolesObj?.country
          if (userCountries.includes(jobCountry)) {
            setState({ allowAccessToDataEntry: true })
          } else {
            setState({ allowAccessToDataEntry: false })
          }
        }
      }
    }
    clearBusy()

  }

  // const handleViewFieldInstructions = async(jobid) => {
  //   setBusy()
  //   const jobDocument = await gdeTransactions.getJobById(jobId)
  //   const jobDoc = jobDocument.data()
  //   const templateName = jobDoc.templateName ? jobDoc.templateName : jobDoc.standardTemplateName
  //   const templateData = await gdeTransactions.getTemplateById(templateName)
  //   let fieldInstructions = ''
  //   const templateFields = templateData.data().templateFields
  //   const newLine = '\n'
  //   for (const [key, value] of Object.entries(templateFields)) {
  //     const { instructionData, customName } = value
  //     if (instructionData) {
  //       fieldInstructions = fieldInstructions + '' + customName + ' : ' + instructionData + newLine
  //     }
  //   }
  //   clearBusy()
  //   return (
  //     openInformationDialog({
  //       title: 'forms.viewFieldInstructions',
  //       message: <pre>{fieldInstructions || 'No instructions available.'}</pre>,
  //       closeX: true
  //     })
  //   )
  // }
  return (
    <>
      <audio ref={audioPlayer} src={NotificationSound} autoplay />
      <audio ref={audioPlayerVerification} src={VerificationSound} autoplay />
      {(getState().allowAccessToDataEntry === true)
        ? <MainRouteSubRoutePage
          mainTitle="dataEntry.dataEntry"
          subTitle={state?.userType === 'VERIFICATION_USER' ? 'dataEntry.dataEntryVerification' : 'dataEntry.dataEntry'}
          buttons={
            <Buttons
              arrRefs={arrRefs}
              handlePause={handlePause}
              // handleTransmit={handleTransmit}
              handleJobComplete={handleJobComplete}
              toggleTable={toggleTable}
              displayeBtnDisable={getState().displayeBtnDisable}
              openTable={openTable}
              handleVerifyPause={handleVerifyPause}
              handleSubmitDataPop={handleSubmitDataPop}
              handleVerifySubmitData={handleVerifySubmitData}
              handleCancel={handleCancelOnClick}
              isCancelButtonvisible={state.isCancelButtonvisible}
              isBoxCompleteButtonvisible={state.hideBoxComplete === true ? state.hideBoxComplete : !((state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile'))}
              isVerify={(state.userType === userTypes.VERIFICATION_USER)}
              isVerifyComplete={state.isVerifyComplete}
              isButtondisabled={state.fileList.length > 0}
              jobcompleteDisabled={state.jobcompleteDisabled}
              templateSelected={state.templateTypeSelected}
              userType={state.userType}
              isAddNewFileByQc={isAddNewFileByQc}
              pauseEnabled={pauseEnabled}
              recordKeyStrokesStatus={state.recordKeyStrokesStatus}
              dataLength={(state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile') ? state?.fileList?.length : state?.boxList?.length}
              addNewFileDuringVerification={state?.addNewFileDuringVerification}
            />
          }
          viewRecentRecords={(state?.userType !== userTypes.VERIFICATION_USER && !state?.addNewFileDuringVerification && (((state?.templateTypeSelected === 'New File' || state?.templateTypeSelected === 'Maintenance File') && state?.fileList.length > 0) || ((state?.templateTypeSelected === 'New Box' || state?.templateTypeSelected === 'Maintenance Box') && state?.boxList.length > 0)) && openTable) ?
            <ViewRecentRecordsTable
              arrRefs={arrRefs}
              columns={state?.templateFields}
              tableData={(state?.templateTypeSelected === 'New File' || state?.templateTypeSelected === 'Maintenance File') ? state?.fileList : state?.boxList}
              currentTemplateType={state?.templateTypeSelected}
              onEditRecord={onClickEditRecordButton}
            /> : ""}
        >
          <BoxUp theme={theme}>
            <OuterContainer theme={theme}>
              <LocalToast ref={refLocalToast} />
              <FlexByRow>
                <BoxStyle theme={theme}>
                  <Box>
                    <div>
                      <Label>dataEntry.jobId</Label>
                    </div>
                    <YDivider />
                    <div>
                      <Label noTranslate>{state.jobId}</Label>
                    </div>
                  </Box>
                </BoxStyle>
                <BoxStyle theme={theme}>
                  <Box>
                    <div>
                      <Label>dataEntry.customerId</Label>
                    </div>
                    <YDivider />
                    <div>
                      <Label noTranslate >{state.jobDetails.accountLevel1?.toUpperCase()}</Label>
                    </div>
                  </Box>
                </BoxStyle>
                <BoxStyle theme={theme}>
                  <Box>
                    <div>
                      <Label>dataEntry.templateName</Label>
                    </div>
                    <YDivider />
                    <div>
                      <Label noTranslate>{state.jobDetails.templateName ? state.jobDetails.templateName : state.jobDetails.standardTemplateName}</Label>
                    </div>
                  </Box>
                </BoxStyle>
                <BoxStyle theme={theme}>
                  <Box>
                    <div>
                      <Label>dataEntry.boxesCompleted</Label>
                    </div>
                    <YDivider />
                    <div>
                      <Label>{state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' ? state.boxCount : state.boxesKeyed}</Label>
                    </div>
                  </Box>
                </BoxStyle>
                {
                  state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile'
                    ? <><BoxStyle theme={theme}>
                      <Box>
                        <div>
                          <Label>dataEntry.filesKeyed</Label>
                        </div>
                        <YDivider />
                        <div>
                          <Label>{getState()?.totalFiles}</Label>
                        </div>
                      </Box>
                    </BoxStyle>
                      <BoxStyle theme={theme}>
                        <Box>
                          <div>
                            <Label>{t('templates.file')}  {getState()?.fileList?.length === 0 ? getState()?.fileList?.length + 1 : getState()?.fileVerifyStartCount + 1} {t('templates.of')} {getState()?.fileVerifyStartCount + 1 > getState()?.fileList?.length ? getState().fileList.length + 1 : getState().fileList.length}</Label>
                          </div>
                          <YDivider />
                        </Box>
                      </BoxStyle>
                      <BoxStyle theme={theme}>
                        <Box>
                          <div>
                            <Label>{t('templates.box')} {index === 0 ? getState()?.boxList?.length + 1 : index} {t('templates.of')} {getState()?.boxId ? getState()?.boxList?.length : getState()?.boxList?.length + 1}</Label>
                          </div>
                          <YDivider />
                        </Box>
                      </BoxStyle></>
                    : <BoxStyle theme={theme}>
                      <Box>
                        <div>
                          <Label>{t('templates.box')} {index === 0 ? getState()?.boxList?.length + 1 : index} {t('templates.of')} {getState()?.boxId ? getState()?.boxList?.length : getState()?.boxList?.length + 1}</Label>
                        </div>
                        <YDivider />
                      </Box>
                    </BoxStyle>
                }
              </FlexByRow>
            </OuterContainer>
            {getState().isTemplateInstructions
              ? <>
                <ExternalContainer theme={theme}>
                  <InnerBoxStyle>
                    <InstructionLabel id={`dataEntry_viewFieldInstructions`}>
                      <BoldTitle theme={theme}>
                        {t('buttons.viewTemplateInstructions')} :
                      </BoldTitle>
                      {getState().viewTemplateInstructions}
                    </InstructionLabel>
                  </InnerBoxStyle>
                </ExternalContainer>
              </>
              : null
            }
            <YDivider height="15px" />
            <EvenSpace>
              <WidthForSkpBox>
                <MarginLeft>
                  <TextField
                    id={'dataEntry_skpBox'}
                    data={data}
                    ref={arrRefs[SKPBOX]}
                    fieldTemplate={formTemplate[SKPBOX]}
                    disabled={!state.isSkpBoxIdEditable}
                    onKeyDown={(e) => skpBoxValue(e)}
                    onBlur={(e) => onBlurSkpBoxValue(e)}
                    value={state.boxId ? state.boxId : ''}
                    inputProps={{ maxLength: 12 }}
                    onInput={(e) => convertToUpperCase(e)}
                  />
                </MarginLeft>
              </WidthForSkpBox>
              <XDivider width="20px" />
              {(getState().jobDetails.dataEntryType === 'Maintenance Box' && getState().templateFields[1]?.verify === false) || (getState().jobDetails.dataEntryType === 'New Box' && getState().templateFields[1]?.verify === false) ?
                '' : <WidthForSkpBox>
                  <TextField
                    id={'dataEntry_skpBoxConfirm'}
                    ref={arrRefs[SKPBOX_CONFIRM]}
                    fieldTemplate={formTemplate[SKPBOX_CONFIRM]}
                    disabled={!state.isSkpBoxIdEditable}
                    onKeyDown={(e) => skpBoxValueConfirmKeyPress(e)}
                    onBlur={(e) => onBlurSkpValueConfirm(e)}
                    value={state.boxId ? state.boxId : ''}
                    inputProps={{ maxLength: 12 }}
                    onInput={(e) => convertToUpperCase(e)}
                  />
                </WidthForSkpBox>
              }
            </EvenSpace>
          </BoxUp>
          <YDivider height="20px" />
          {/* <OutlinedButton style={{ marginLeft: 5, marginRight: 20 }} onClick={handleViewTemplateInstructions} disabled={!getState().templateInstruction}>buttons.viewTemplateInstructions</OutlinedButton> */}
          {/* <OutlinedButton onClick={handleViewFieldInstructions}>buttons.viewFieldInstructions</OutlinedButton> */}
          <YDivider height="20px" />
          <BoxFlex>
            <FlexGrow>
              <StopWatchComponent id={'dataEntry_StopWatch'} ref={refStopWatchComponent} />
            </FlexGrow>
            {
              (state.boxData === undefined || state?.boxData?.status === constants.boxStatus.dataEntryInProcess) && (getState().templateTypeSelected !== 'New Box' && getState().templateTypeSelected !== 'Maintenance Box')
                ? <CheckBox
                  id={'dataEntry_exceptionBox'}
                  fieldTemplate={formTemplate[EXCEPTION_BOX]}
                  ref={arrRefs[EXCEPTION_BOX]}
                  onChange={onChangeExceptionBox}
                  disabled={state.isExcetionBoxDisabled}
                />
                : <></>
            }
            <XDivider width="20px" />
            {state.viewFiles && !isAddNewFileByQc && !getState().hideViewAllFilesButton
              ? (
                <>
                  <BottomPaddedButton disabled={hideTable} id={'dataEntry_button_viewFIles'} variant='outlined' color='primary' onClick={checkNetworkBeforeNav}>
                    buttons.ViewFiles
                  </BottomPaddedButton>
                  <XDivider width="20px" />
                </>
              )
              : null
            }
            {state.boxesKeyed > 0 && (getState()?.timerObj?.dataEntryType === 'Maintenance Box' || getState()?.timerObj?.dataEntryType === 'New Box')
              ? (
                <>
                  <BottomPaddedButton disabled={hideTable} id={'dataEntry_button_viewBoxes'} variant='outlined' color='primary' onClick={checkNetworkBeforeNav}>
                    buttons.ViewAllBoxes
                  </BottomPaddedButton>
                  <XDivider width="20px" />
                </>
              )
              : null
            }
            {(getState().userType === userTypes.VERIFICATION_USER ||
              (getState().userType === userTypes.DATAENTRY_AND_VERIFY_USER && (
                getState()?.boxData?.status === constants.boxStatus.readyForVerification || getState()?.boxData?.status === constants.boxStatus.verificationInProcess)))
              ? (
                <>
                  <BottomPaddedButton id={'dataEntry_button_EnterdataUpperCase'} variant="contained" color="primary" disabled={state.enterDataDisabled} onClick={onEnterVerifiedData}>
                    dataEntry.EnterdataUpperCase
                  </BottomPaddedButton>
                </>
              )
              : (
                <>
                  <BottomPaddedButton id={'dataEntry_button_EnterdataUpperCase1'} variant='contained' color='primary' onClick={onEnterData} disabled={state.enterDataDisabled}>
                    dataEntry.EnterdataUpperCase
                  </BottomPaddedButton>
                </>
              )}

            {getState()?.timerObj?.dataEntryType !== 'Maintenance Box' && getState()?.timerObj?.dataEntryType !== 'New Box' && getState().userType === userTypes.VERIFICATION_USER && !getState().addNewFileDuringVerification && !isAddNewFileByQc &&
              <>
                <XDivider width="20px" />
                <BottomPaddedButton id={'dataEntry_button_addNewFile'} variant="contained" color="primary" onClick={onAddNewFile} style={{ width: '15%' }}>dataEntry.addNewFile
                </BottomPaddedButton>
              </>}
            {getState()?.timerObj?.dataEntryType !== 'Maintenance Box' && getState()?.timerObj?.dataEntryType !== 'New Box' && getState().userType !== userTypes.VERIFICATION_USER && getState().addNewFileDuringVerification && !isAddNewFileByQc &&
              <>
                <XDivider width="20px" />
                <BottomPaddedButton id={'dataEntry_button_addNewFile'} variant="contained" color="primary" onClick={onAddNewFile} style={{ width: '15%' }}>dataEntry.startVerification
                </BottomPaddedButton>
              </>}
            {getState()?.timerObj?.dataEntryType !== 'Maintenance Box' && getState()?.timerObj?.dataEntryType !== 'New Box' && isAddNewFileByQc &&
              <>
                <XDivider width="20px" />
                <BottomPaddedButton id={'dataEntry_button_addNewFile'} variant="contained" color="primary" onClick={onBackToQC} style={{ width: '20%' }}>dataEntry.backToQC
                </BottomPaddedButton>
              </>}
          </BoxFlex>
          <XDivider width="40px" />
          {getState()?.templateFields?.length > 0
            ? <>
              <DivCenter>
                <Paper elevation={3}>
                  <MarginBothSide>
                    <XDivider width='30px' />
                    {state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile' ? getdataEntryfields() : getdataEntryBoxfields()}
                  </MarginBothSide>
                </Paper>
              </DivCenter>
              <YDivider height='50px' />
              {state.jobDetails.standardTemplateName === 'skpStandardNewFile' || state.jobDetails.standardTemplateName === 'skpStandardMaintenanceFile'
                ? <DivCenter>
                  <NavigationLabel noTranslate><Label>dataEntry.dataControl</Label></NavigationLabel>
                  <XDivider width="10px" />
                  <LableStyle>

                    <IconButton id={'dataEntry_button_verificationUser'} onClick={handleRefreshData} disabled={getState().userType === userTypes.VERIFICATION_USER} >
                      <ToolTip message='dataEntry.navigation.reset' style={{ height: '21px' }}>
                        <Refresh className={`${getState().userType === userTypes.VERIFICATION_USER ? classes.disabledState : ''} + ${classes.icons}`} />
                      </ToolTip>
                    </IconButton>

                    {/* <IconButton id={'dataEntry_button_editFile'} onClick={handleEditFile} disabled={getState().userType === userTypes.VERIFICATION_USER} >
                  <ToolTip message='dataEntry.navigation.edit' style={{ height: '21px' }}>
                    <Edit className={`${getState().userType === userTypes.VERIFICATION_USER ? classes.disabledState : ''} + ${classes.icons}`} />
                  </ToolTip>
                </IconButton> */}

                    <IconButton id={'dataEntry_button_deleteFile'} onClick={handleDelete} disabled={getState().userType === userTypes.VERIFICATION_USER || getState().fileVerifyStartCount + 1 > getState().fileList?.length} >
                      <ToolTip message={'dataEntry.navigation.deleteFile'} style={{ height: '21px' }}>
                        <DeleteOutline className={`${getState().userType === userTypes.VERIFICATION_USER ? classes.disabledState : ''} + ${classes.icons}`} />
                      </ToolTip>
                    </IconButton>
                  </LableStyle>

                  <IconButton id={'dataEntry_button_firstPage'} onClick={handleFirstPage} disabled={getState().fileVerifyStartCount === 0}>
                    <ToolTip message={'dataEntry.navigation.firstFile'} style={{ height: '21px' }}>
                      <FirstPage className={`${getState().fileVerifyStartCount === 0 ? classes.disabledState : ''} + ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                  <IconButton id={'dataEntry_button_navigateBefore'} onClick={handleNavigateBefore} disabled={getState().fileVerifyStartCount === 0}>
                    <ToolTip message={'dataEntry.navigation.previousFile'} style={{ height: '21px' }}>
                      <NavigateBefore className={`${getState().fileVerifyStartCount === 0 ? classes.disabledState : ''} + ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                  <FileNumberContainer>
                    <TextField
                      id={'dataEntry_button_fileNumber'}
                      ref={fileNumberRef}
                      fieldTemplate={fileNavigation[FILE_NUMBER]}
                      onKeyUp={(e) => handleFileNumber(e)}
                    />
                  </FileNumberContainer>

                  <IconButton id={'dataEntry_button_navigateNext'} onClick={handleNavigateNext} disabled={getState().fileVerifyStartCount === (getState().fileList.length - 1) || getState().fileVerifyStartCount === (getState().fileList.length)} >
                    <ToolTip message={'dataEntry.navigation.nextFile'} style={{ height: '21px' }}>
                      <NavigateNext className={`${getState().fileVerifyStartCount === (getState().fileList.length - 1) || getState().fileVerifyStartCount === (getState().fileList.length) ? classes.disabledState : ''} +  ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                  <IconButton id={'dataEntry_button_lastPage'} onClick={handleLastPage} disabled={getState().fileVerifyStartCount === (getState().fileList.length - 1) || getState().fileVerifyStartCount === (getState().fileList.length)}>
                    <ToolTip message={'dataEntry.navigation.lastFile'} style={{ height: '21px' }}>
                      <LastPage className={`${getState().fileVerifyStartCount === (getState().fileList.length - 1) || getState().fileVerifyStartCount === (getState().fileList.length) ? classes.disabledState : ''} + ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                </DivCenter>
                : <DivCenter>
                  <NavigationLabel noTranslate><Label>dataEntry.dataControl</Label></NavigationLabel>
                  <XDivider width="10px" />
                  <LableStyle>

                    <IconButton id={'dataEntry_button_verificationUser'} onClick={handleRefreshData} disabled={getState().userType === userTypes.VERIFICATION_USER} >
                      <ToolTip message='dataEntry.navigation.reset' style={{ height: '21px' }}>
                        <Refresh className={`${getState().userType === userTypes.VERIFICATION_USER ? classes.disabledState : ''} + ${classes.icons}`} />
                      </ToolTip>
                    </IconButton>

                    <IconButton id={'dataEntry_button_deleteFile'} onClick={handleDelete} disabled={getState().userType === userTypes.VERIFICATION_USER || getState().fileVerifyStartCount + 1 > getState().fileList?.length} >
                      <ToolTip message={'dataEntry.navigation.deleteBox'} style={{ height: '21px' }}>
                        <DeleteOutline className={`${getState().userType === userTypes.VERIFICATION_USER ? classes.disabledState : ''} + ${classes.icons}`} />
                      </ToolTip>
                    </IconButton>
                  </LableStyle>

                  <IconButton id={'dataEntry_button_firstPage'} onClick={handleFirstPage} disabled={getState().boxList.length === 0}>
                    <ToolTip message={'dataEntry.navigation.firstBox'} style={{ height: '21px' }}>
                      <FirstPage className={`${getState().boxVerifyStartCount === 0 ? classes.disabledState : ''} + ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                  <IconButton id={'dataEntry_button_navigateBefore'} onClick={handleNavigateBefore} disabled={getState().boxList.length === 0}>
                    <ToolTip message={'dataEntry.navigation.previousBox'} style={{ height: '21px' }}>
                      <NavigateBefore className={`${getState().boxVerifyStartCount === 0 ? classes.disabledState : ''} + ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                  <FileNumberContainer>
                    <TextField
                      id={'dataEntry_button_fileNumber'}
                      ref={boxNumberRef}
                      fieldTemplate={boxNavigation[BOX_NUMBER]}
                      onKeyUp={(e) => handleFileNumber(e)}
                    />
                  </FileNumberContainer>

                  <IconButton id={'dataEntry_button_navigateNext'} onClick={handleNavigateNext} disabled={getState().boxVerifyStartCount === (getState().boxList.length - 1) || getState().boxVerifyStartCount === (getState().boxList.length)} >
                    <ToolTip message={'dataEntry.navigation.nextBox'} style={{ height: '21px' }}>
                      <NavigateNext className={`${getState().boxVerifyStartCount === (getState().boxList.length - 1) || getState().boxVerifyStartCount === (getState().boxList.length) ? classes.disabledState : ''} +  ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                  <IconButton id={'dataEntry_button_lastPage'} onClick={handleLastPage} disabled={getState().boxVerifyStartCount === (getState().boxList.length - 1) || getState().boxVerifyStartCount === (getState().boxList.length)}>
                    <ToolTip message={'dataEntry.navigation.lastBox'} style={{ height: '21px' }}>
                      <LastPage className={`${getState().boxVerifyStartCount === (getState().boxList.length - 1) || getState().boxVerifyStartCount === (getState().boxList.length) ? classes.disabledState : ''} + ${classes.icons}`} />
                    </ToolTip>
                  </IconButton>

                </DivCenter>}
            </>
            : <></>}
          <YDivider height='20px' />
        </MainRouteSubRoutePage>
        : <>{<ErrorPage allowAccess={true} />}</>
      }
    </>
  )
})

DataEntryBase.propTypes = {
  updatedFileList: PropTypes.array,
  updatedBoxList: PropTypes.array,
  arrRefs: PropTypes.array,
  boxId: PropTypes.string,
  stop: PropTypes.func,
  resume: PropTypes.func,
  onOpenTable: PropTypes.func,
  showPause: PropTypes.bool,
  isTemplateFieldsEditable: PropTypes.bool,
  currentFileCount: PropTypes.any,
  currentBoxCount: PropTypes.any,
  fileVerifyStartCount: PropTypes.any,
  fileSequence: PropTypes.any,
  isRecordCountOpen: PropTypes.bool,
  currentLockableFields: PropTypes.any,
  currentLockableFieldsData: PropTypes.any,
  currentJobCompleteButtonEnable: PropTypes.any,
}

const DataEntry = props => {
  const [showTable, setShowTable] = useState(false)
  const [showPause, setShowPause] = useState(true)
  const tableValues = useRef({})
  const fileList = useRef(props.updatedFileList)
  const currentBoxId = useRef(props.boxId)
  const currentReturnFileCount = useRef(props.fileVerifyStartCount)
  const boxList = useRef(props.updatedBoxList)
  const currentFileCount = useRef(props.currentFileCount)
  const currentBoxCount = useRef(props.currentBoxCount)
  const currentLockableFields = useRef(props.currentLockableFields)
  const currentLockableFieldsData = useRef(props.currentLockableFieldsData)
  const currentJobCompleteButtonEnable = useRef(props.currentJobCompleteButtonEnable)
  const refDataEntryBase = useRef()
  const refViewAllFiles = useRef()
  const updateStatus = useRef(props.statusTobeUpdated)
  const currentUserType = useRef()
  const currentTemplateType = useRef()

  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const isViewAllFiles = pathParams[4]

  // Counts clicks as keystrokes
  const clickCounts = () => {
    recordKeystroke()
  }
  useEffect(() => {
    window.addEventListener('click', clickCounts)
    return () => {
      window.removeEventListener('click', clickCounts)
    }
  }, [])


  const onIimeChange = value => {
    if (refDataEntryBase.current) {
      refDataEntryBase.current.onIimeChange(value)
    }
  }

  const { resume, stop } = useStopWatchTimer(onIimeChange)

  const onCloseTable = async (currentUserType = false, changedFileData, jobId, boxId, fileCount = 0, isBulkUpdate = false, selectedFiles = {}, lockableFields, lockableFieldsData, templateType = false) => {
    let postingData = []
    if (!isBulkUpdate) {
      let count = 0
      changedFileData.forEach(file => {
        if (file.tableData) {
          delete file.tableData
        }
        postingData[count] = file
        count++
      })
    } else {
      postingData = selectedFiles
    }

    currentBoxId.current = boxId
    fileList.current = postingData
    fileCount >= fileList.current.length && fileList.current.slice().reverse().forEach((file, index) => {
      if (file && index) {
        fileCount = index
      }
    })

    fileCount++
    if (currentUserType.current === userTypes.VERIFICATION_USER && fileCount === fileList.current.length) {
      fileCount--
    }

    currentReturnFileCount.current = fileCount
    currentFileCount.current = fileCount
    tableValues.current.fileSequence = fileCount + 1
    currentLockableFields.current = lockableFields
    currentLockableFieldsData.current = lockableFieldsData

    if (templateType === 'New Box' || templateType === 'Maintenance Box') {
      currentJobCompleteButtonEnable.current = true
    }

    setShowTable(false)
    setTimeout(clearBusy(), 100000)
  }


  const onOpenTable = (newFileList, fileCount, statusTobeUpdated, lockableFields, lockableFieldsData, userType, templateType) => {
    tableValues.current = refDataEntryBase.current.getValues()
    fileList.current = newFileList
    currentFileCount.current = fileCount
    currentLockableFields.current = lockableFields
    currentLockableFieldsData.current = lockableFieldsData
    updateStatus.current = statusTobeUpdated
    currentUserType.current = userType
    currentTemplateType.current = templateType
    setShowTable(true)
    setShowPause(false)
  }

  const onCancel = (boxId, fileCount, lockableFields, lockableFieldsData, templateType) => {
    if (templateType === 'New Box' || templateType === 'Maintenance Box') {
      currentLockableFields.current = lockableFields
      currentLockableFieldsData.current = lockableFieldsData
      currentJobCompleteButtonEnable.current = true
    } else {
      currentBoxId.current = boxId
      currentReturnFileCount.current = fileCount
      currentLockableFields.current = lockableFields
      currentLockableFieldsData.current = lockableFieldsData
    }
    setShowTable(false)
  }

  const onBackToBoxList = (history, jobId) => {
    history.push(`${routePaths.boxList}/${jobId}`)
  }

  useEffect(() => {
    return () => {
      if (recordKeystrokes) {
        turnOffKeystrokeRecorder(false)
      }
    }
  }, [])

  if (showTable) {
    return (
      <ViewAllFiles
        ref={refViewAllFiles}
        onCancel={onCancel}
        onCloseTable={onCloseTable}
        onBackToBoxList={onBackToBoxList}
        boxId={tableValues.current.boxId}
        jobId={tableValues.current.jobId}
        fileList={fileList.current}
        currentFileCount={currentFileCount.current}
        currentLockableFields={currentLockableFields.current}
        currentLockableFieldsData={currentLockableFieldsData.current}
        boxCount={tableValues.current.boxCount}
        fileCount={tableValues.current.fileVerifyStartCount}
        statusTobeUpdated={updateStatus.current}
        isViewAllFiles={isViewAllFiles}
        currentUserType={currentUserType}
        currentTemplateType={currentTemplateType}
      />
    )
  } else {
    return (
      <DataEntryBase
        resume={resume}
        stop={stop}
        arrRefs={props.arrRefs}
        onOpenTable={onOpenTable}
        showPause={showPause}
        ref={refDataEntryBase}
        updatedFileList={fileList.current}
        currentFileCount={currentFileCount.current}
        isRecordCountOpen={tableValues.current.isRecordCountOpen}
        updatedBoxList={boxList.current}
        currentBoxCount={currentBoxCount.current}
        boxId={currentBoxId.current}
        fileVerifyStartCount={currentReturnFileCount.current}
        fileSequence={tableValues.current.fileSequence}
        boxVerifyStartCount={tableValues.current.boxVerifyStartCount}
        isTemplateFieldsEditable={tableValues.current.isTemplateFieldsEditable}
        statusTobeUpdated={updateStatus.current}
        currentLockableFields={currentLockableFields.current}
        currentLockableFieldsData={currentLockableFieldsData.current}
        currentJobCompleteButtonEnable={currentJobCompleteButtonEnable.current}
      />
    )
  }
}

DataEntry.propTypes = {
  updatedFileList: PropTypes.array,
  updatedBoxList: PropTypes.array,
  arrRefs: PropTypes.array,
  currentFileCount: PropTypes.any,
  currentBoxCount: PropTypes.any,
  boxId: PropTypes.any,
  fileVerifyStartCount: PropTypes.any,
  statusTobeUpdated: PropTypes.any,
  currentLockableFields: PropTypes.any,
  currentLockableFieldsData: PropTypes.any,
}

export default DataEntry